import type { Dict } from '../types';

export const de: Dict = {
  'chat.amrCard.switchTitle': 'Modellaufruf fehlgeschlagen — dieser Lauf ist pausiert',
  'chat.amrCard.switchBody': 'Wechsle zum offiziellen AMR-Modelldienst von Open Design — kein API-Key-Setup nötig. Nach Anmeldung, Autorisierung und Aufladung wird dieser Lauf automatisch wiederholt.',
  'chat.amrCard.chipOfficial': 'Offizielles Hosting',
  'chat.amrCard.chipNoKey': 'Kein API-Key',
  'chat.amrCard.chipAutoRetry': 'Auto-Wiederholung nach Anmeldung',
  'chat.amrCard.switchCta': 'Zu AMR wechseln und wiederholen',
  'chat.amrError.authMessage': 'Dein AMR-Konto ist noch nicht autorisiert. Autorisiere es, und dieser Lauf wird automatisch wiederholt.',
  'chat.amrError.balanceMessage': 'Dein AMR-Guthaben ist aufgebraucht. Lade auf, um diesen Lauf fortzusetzen.',
  'chat.amrError.authorizeCta': 'Autorisieren und wiederholen',
  'chat.amrError.rechargeCta': 'AMR aufladen',
  'chat.antigravityError.launchTerminalCta': 'Über Terminal anmelden',
  'chat.antigravityError.launchSwitchModelCta': 'Modell im Terminal wechseln',
  'chat.connectionDropped': 'Die Verbindung zum Modelldienst wurde vor dem Ende der Antwort unterbrochen – meist ein instabiles Netzwerk oder ein Proxy. Bitte erneut versuchen.',
  'chat.runError.title.authRequired': 'Autorisierung erforderlich',
  'chat.runError.title.balance': 'Guthaben aufgebraucht',
  'chat.runError.title.connectionDropped': 'Verbindung unterbrochen',
  'chat.runError.title.signInRequired': 'Anmeldung erforderlich',
  'chat.runError.title.rateLimited': 'Nutzungslimit erreicht',
  'chat.runError.title.generic': 'Aufgabe fehlgeschlagen',
  'chat.runError.signInMessage.amr': 'Der Open Design-Agent ist noch nicht angemeldet – melde dich an, um ihn zu nutzen.',
  'chat.runError.signInMessage.other': '{agent} ist nicht angemeldet. Prüfe den Anmeldestatus lokal. Wir empfehlen den Open Design-Agenten – stabiler und günstiger.',
  'chat.runError.agentFallback': 'der Agent',
  'chat.runError.sourceLabel': 'Fehlerquelle',
  'chat.runError.sourceExpandAria': 'Fehlerquelle einblenden',
  'chat.runError.sourceCollapseAria': 'Fehlerquelle ausblenden',
  'common.cancel': 'Abbrechen',
  'chat.selectFromLibrary': 'Aus Bibliothek importieren',
  'chat.importFigma': 'Aus Figma importieren',
  'designFiles.library.label': 'Aus Bibliothek importieren',
  'designFiles.library.title': 'Aus Bibliothek importieren',
  'libraryPicker.title': 'Aus Bibliothek importieren',
  'libraryPicker.searchPlaceholder': 'Bibliothek durchsuchen…',
  'libraryPicker.empty': 'Noch keine Inhalte in deiner Bibliothek',
  'libraryPicker.allKinds': 'Alle',
  'libraryPicker.add': 'Importieren',
  'libraryPicker.loading': 'Wird geladen…',
  'common.save': 'Speichern',
  'common.close': 'Schließen',
  'common.clear': 'Leeren',
  'common.delete': 'Löschen',
  'common.rename': 'Umbenennen',
  'common.edit': 'Bearbeiten',
  'common.preview': 'Vorschau',
  'common.share': 'Teilen',
  'common.search': 'Suchen',
  'common.searchEllipsis': 'Suchen…',
  'common.loading': 'Wird geladen…',
  'common.all': 'Alle',
  'common.none': 'Keine',
  'common.default': 'Standard',
  'common.installed': 'installiert',
  'common.notInstalled': 'nicht installiert',
  'common.active': 'aktiv',
  'common.offline': 'offline',
  'common.selected': 'ausgewählt',
  'common.create': 'Erstellen',
  'common.openPreview': 'Vorschau öffnen',
  'common.exitFullscreen': 'Vollbild verlassen',
  'common.fullscreen': 'Vollbild',
  'common.openInNewTab': 'In neuem Tab öffnen',
  'common.exportPdf': 'Als PDF exportieren',
  'common.exportZip': 'Als .zip herunterladen',
  'common.exportHtml': 'Als eigenständiges HTML exportieren',
  'common.exportImage': 'Als Bild exportieren',
  'common.exportImageFailed': 'Bildaufnahme fehlgeschlagen. Bitte versuchen Sie es erneut oder verwenden Sie das Screenshot-Tool Ihres Browsers.',
  'common.justNow': 'gerade eben',
  'common.minutesAgo': 'vor {n} Min.',
  'common.hoursAgo': 'vor {n} Std.',
  'common.daysAgo': 'vor {n} T.',
  'common.weeksAgo': 'vor {n} Wo.',
  'common.now': 'jetzt',
  'common.minutesShort': '{n} Min.',
  'common.hoursShort': '{n} Std.',
  'common.daysShort': '{n} T.',
  'common.untitled': 'Ohne Titel',
  'plugins.availableDetails.provenance': 'Herkunft',
  'plugins.availableDetails.provenanceLine': 'von {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'von {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Installieren',
  'plugins.availableDetails.version': 'Version',
  'plugins.availableDetails.pluginVersion': 'Plugin-Version',
  'plugins.availableDetails.copyInstallCommand': 'Installationsbefehl kopieren',
  'plugins.availableDetails.copied': 'Kopiert',
  'plugins.availableDetails.deprecatedPrefix': 'Veraltet: {message}',
  'plugins.availableDetails.deprecatedFallback': 'Diese Version wurde als veraltet markiert.',
  'plugins.availableDetails.yanked': 'Zurückgezogen.',
  'plugins.availableDetails.yankedWithReason': 'Zurückgezogen: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (veraltet)',
  'plugins.availableDetails.versionYankedSuffix': ' (zurückgezogen)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Berechtigungen',
  'plugins.availableDetails.capabilitySummary': 'Funktionsübersicht',
  'plugins.actions.copyInstallCommand': 'Installationsbefehl kopieren',
  'plugins.actions.copyPluginId': 'Plugin-ID kopieren',
  'plugins.actions.copyReadmeBadge': 'README-Badge kopieren',
  'plugins.actions.openSourceGithub': 'Quelle auf GitHub öffnen',
  'plugins.actions.openSource': 'Quelle öffnen',
  'plugins.actions.openHomepage': 'Homepage öffnen',
  'plugins.actions.openMarketplace': 'Im Marktplatz öffnen',
  'app.brand': 'Open Design',
  'app.brandPill': 'Forschungsvorschau',
  'app.brandSubtitle': 'von Nexu Labs',
  'app.welcomeLoading': 'Workspace wird geladen…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Willkommen bei Open Design',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Mit einem Briefing beginnen',
  'settings.onboardingCreateBody': 'Beschreibe die Website, App, Präsentation, das Bild oder Video, das du erstellen möchtest. Open Design erstellt ein Projekt und hält die Arbeit bearbeitbar.',
  'settings.onboardingMemoryTitle': 'Arbeitskontext speichern',
  'settings.onboardingMemoryBody': 'Füge Präferenzen, Projektfakten und wiederkehrende Regeln hinzu, damit künftige Chats den richtigen Kontext aufgreifen.',
  'settings.onboardingMemoryCalloutTitle': 'In deinem Speicher gesichert',
  'settings.onboardingMemoryCalloutBody': 'Diese Antworten bilden die Grundlage deines Speicher-Profils. Open Design verwendet es bei jeder Aufgabe wieder – und lernt weiter, während du arbeitest.',
  'settings.onboardingMemoryBenefitIntent': 'Versteht aus einer kurzen Anfrage, was du meinst',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Überspringt wiederholte Einrichtungsfragen',
  'settings.onboardingMemoryBenefitPersonalized': 'Passt die Ergebnisse an deine Rolle, dein Publikum und deinen Geschmack an',
  'settings.onboardingSystemsTitle': 'Bring dein Designsystem mit',
  'settings.onboardingSystemsBody': 'Wähle oder erstelle ein Markensystem, damit generierte Arbeit echten Farben, Typografie und Produktsprache folgt.',
  'settings.onboardingExecutionTitle': 'Wählen, wie die Generierung läuft',
  'settings.onboardingExecutionBody': 'Offizielles CLI mit Ein-Klick-Einrichtung und sofort einsatzbereiten Voreinstellungen. Nutze einen Schlüssel, um aus vielen Modellen zu besserem Preis zu wählen.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Offiziell empfohlen',
  'settings.onboardingAmrCloudBenefitReady': 'Ohne Deployment',
  'settings.onboardingAmrCloudBenefitModels': 'Unterstützt Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Demnächst',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Bild und Video',
  'settings.onboardingAmrCloudUpcomingSkills': 'Viele Skills',
  'settings.onboardingAmrCloudUpcomingRouting': 'Smart Routing',
  'settings.onboardingAmrModelSourceLabel': 'AMR CLI',
  'settings.onboardingAmrCloudAuthorizeAction': 'AMR autorisieren',
  'settings.onboardingAmrCloudAuthorizedAction': 'Autorisiert',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Designsystem erstellen',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Auf dem Laufenden bleiben',
  'settings.onboardingNewsletterTitle': 'Bleib im Loop',
  'settings.onboardingNewsletterBody': 'Erhalte Produkt-Updates, neue Vorlagen, Design-System-Drops und Botschafter-Arbeit per E-Mail. Optional — kann übersprungen werden.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Bei Open Design anmelden',
  'settings.onboardingCloudBody': 'Melde dich an und gestalte sofort mit Cloud-KI – ganz ohne komplizierte Einrichtung.',
  'settings.onboardingCloudSignIn': 'Bei Open Design Cloud anmelden',
  'settings.onboardingCloudContinue': 'Weiter (angemeldet)',
  'settings.onboardingCloudAlternative': 'Lokale CLI oder eigenen API-Schlüssel verwenden',
  'settings.onboardingCloudRights': 'Alle Rechte vorbehalten.',
  'settings.onboardingCloudOr': 'oder',
  'settings.onboardingGateTooltipNoRuntime': 'Die nächsten Schritte laufen über KI — wähle eine Laufzeit, um fortzufahren.',
  'settings.onboardingGateTooltipAmr': 'Die nächsten Schritte laufen über KI — melde dich bei Open Design AMR an, um fortzufahren.',
  'settings.onboardingGateTooltipLocal': 'Die nächsten Schritte laufen über KI — wähle eine verfügbare lokale CLI, um fortzufahren.',
  'settings.onboardingGateTooltipByok': 'Die nächsten Schritte laufen über KI — füge deinen Modell-Key hinzu und teste ihn, um fortzufahren.',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'Offiziell',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'About you',
  'settings.onboardingProfileBody': 'Optional details for better defaults.',
  'settings.onboardingRoleLabel': 'Your role',
  'settings.onboardingOrgSizeLabel': 'Organization size',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Where did you hear about us?',
  'settings.onboardingSelectPlaceholder': 'Select one',
  'settings.onboardingSelectMultiplePlaceholder': 'Select one or more',
  'settings.onboardingOrgSolo': 'Solo / personal (1)',
  'settings.onboardingOrgTeam': 'Small team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Growth company (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engineer',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleAgency': '📣 Marketingagentur',
  'settings.onboardingRoleGrowth': '📈 Growth',
  'settings.onboardingRoleOps': '⚙️ Operations',
  'settings.onboardingRoleFounder': '🚀 Founder / executive',
  'settings.onboardingRoleStudent': '🎓 Student / educator',
  'settings.onboardingRoleOther': '✨ Other',
  'settings.onboardingUseProduct': '🎨 Product design',
  'settings.onboardingUseDesignSystem': '🧩 Design system',
  'settings.onboardingUsePrototype': '📱 Prototype / app UI',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Ads / social content',
  'settings.onboardingUseDashboard': '📊 Dashboards / internal tools',
  'settings.onboardingUseDeck': '🖥️ Presentation / deck',
  'settings.onboardingUseMarketing': '📈 Marketing / growth',
  'settings.onboardingUseEngineering': '🤝 Engineering handoff',
  'settings.onboardingUseAgency': '💼 Agency / client work',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceFriend': '👥 Friend or coworker',
  'settings.onboardingSourceSocial': '📱 Social media',
  'settings.onboardingSourceProductHunt': '🅿️ Product Hunt',
  'settings.onboardingSourceCommunity': '💬 Design / AI community',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceBlog': '📰 Blog or newsletter',
  'settings.onboardingSourceAiTool': '✨ AI tool recommendation',
  'settings.onboardingSourceSearch': '🔍 Search',
  'settings.onboardingSourceEvent': '🎤 Event or community',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Einstellungen',
  'settings.title': 'Ausführungsmodus',
  'settings.subtitle': 'Wählen Sie zwischen lokaler CLI und BYOK.',
  'settings.modeAria': 'Ausführungsmodus',
  'settings.protocolAria': 'API-Protokoll',
  'settings.modeDaemon': 'Lokale CLI',
  'settings.modeDaemonHelp': 'Über eine Code-Agent-CLI auf Ihrem Rechner ausführen',
  'settings.modeDaemonOffline': 'Daemon läuft nicht',
  'settings.modeDaemonOfflineMeta': 'Daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} installiert',
  'settings.modeApi': 'API-Anbieter',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK kann Projektdateien nicht lesen, schreiben oder bearbeiten. Verwenden Sie die Local CLI, wenn Sie Codeänderungen benötigen.',
  'settings.codeAgent': 'Code-Agent',
  'settings.codeAgentHint': 'Durch Scannen Ihres PATH erkannt. Wählen Sie die CLI, über die Generierungen laufen sollen.',
  'settings.rescan': '↻ Neu scannen',
  'settings.rescanTitle': 'PATH erneut scannen',
  'settings.rescanRunning': 'Scannen...',
  'settings.rescanSuccess': 'Scan abgeschlossen. {count} verfuegbar.',
  'settings.designSystemRenameFailed': 'Umbenennen fehlgeschlagen. Pruefen Sie den Daemon und versuchen Sie es erneut.',
  'settings.rescanFailed': 'Scan fehlgeschlagen. Pruefen Sie den Daemon und versuchen Sie es erneut.',
  'settings.test': 'Testen',
  'settings.testTitle': 'Sende einen winzigen Testprompt, um die Verbindung zu pruefen',
  'settings.testRunning': 'Verbindung wird geprueft…',
  'settings.byokReadyToTest': 'Bereit zum Testen',
  'settings.testCancel': 'Abbrechen',
  'settings.testRetry': 'Test wiederholen',
  'settings.required': 'erforderlich',
  'settings.testMissingFields': 'Füllen Sie {fields} aus, um die Verbindung zu testen.',
  'settings.testSuccessApi': 'Verbunden. Antwort in {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} antwortete in {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Authentifizierung fehlgeschlagen. Pruefen Sie Ihren API-Schluessel.',
  'settings.testForbidden': 'Zugriff verweigert. Pruefen Sie Konto, Region oder Organisation.',
  'settings.testNotFoundModel': 'Modell \'{model}\' an diesem Endpunkt nicht gefunden.',
  'settings.testInvalidModelId': 'Modell-ID \'{model}\' ist ungueltig. Benutzerdefinierte IDs muessen mit einem Buchstaben oder einer Zahl beginnen und duerfen keine Leerzeichen enthalten.',
  'settings.testInvalidBaseUrl': 'Base URL ist ungueltig oder nicht erreichbar.',
  'settings.testRateLimited': 'Anbieter hat den Test ratenbegrenzt. Konfiguration sieht gueltig aus.',
  'settings.testUpstream': 'Anbieter antwortete mit {status}. Versuchen Sie es gleich erneut.',
  'settings.testTimeout': 'Test abgebrochen nach {ms} ms.',
  'settings.testAgentMissing': '{agentName} ist nicht installiert oder nicht im PATH.',
  'settings.testAgentSpawn': '{agentName} konnte nicht gestartet werden: {detail}.',
  'settings.testUnknown': 'Test fehlgeschlagen: {detail}',
  'settings.agentInstall.install': 'Installieren',
  'settings.agentInstall.docs': 'Doku',
  'settings.agentInstall.pathHint': 'Wenn Sie eine CLI mit npm oder Homebrew installiert haben und sie weiterhin als nicht installiert angezeigt wird, stellen Sie sicher, dass das Bin-Verzeichnis der CLI im PATH enthalten ist, den der Open-Design-Daemon erbt (Terminal und GUI-Apps koennen sich unter macOS unterscheiden). Siehe QUICKSTART.md (Abschnitt "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Oeffnen Sie Installieren oder Doku fuer den gewuenschten Agenten.',
  'settings.agentInstall.stepAuth': 'Authentifizieren Sie sich mit der Anbieter-CLI (anmelden oder API-Zugangsdaten setzen), bevor Sie zu Open Design zurueckkehren.',
  'settings.agentInstall.stepRescan': 'Klicken Sie in diesem Bereich auf Neu scannen.',
  'settings.agentInstall.stepSelect': 'Waehlen Sie die Agent-Karte aus, sobald sie als installiert angezeigt wird.',
  'settings.noAgentsDetected': 'Noch keine Agents erkannt. Installieren Sie Claude Code, Codex, Devin for Terminal, Gemini CLI, OpenCode, Cursor Agent, Qwen oder GitHub Copilot CLI und klicken Sie dann auf Neu scannen.',
  'settings.agentInstalledGroup': 'Ihre CLIs ({count})',
  'settings.agentInstallGroup': 'Zur Installation verfügbar ({count})',
  'settings.agentAuthRequired': 'Authentifizierung erforderlich',
  'settings.agentAuthUnknown': 'Authentifizierungsstatus unbekannt',
  'settings.amrCloud': 'Open Design AMR',
  'settings.amrAuthorize': 'Autorisieren',
  'settings.amrBenefitOfficial': 'Officially maintained',
  'settings.amrBenefitLowerPrice': 'Lower price',
  'settings.amrBenefitManyModels': 'Viele Modelle',
  'settings.amrPromoBonus': 'Begrenzter Bonus: +100 %',
  'settings.amrSignInToContinue': 'Zum Fortfahren anmelden',
  'settings.amrSignIn': 'Anmelden',
  'settings.amrSignedIn': 'Angemeldet',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh AMR wallet balance',
  'settings.amrNotSignedIn': 'Nicht angemeldet',
  'settings.amrSigningIn': 'Anmeldung läuft…',
  'settings.amrActivationHint': 'Anmeldeseite nicht geöffnet? Tippe unten auf die Schaltfläche, um sie erneut zu öffnen.',
  'settings.amrActivationBrowserFailed': 'Browser konnte nicht automatisch geöffnet werden. Öffne die Anmeldeseite unten, um fortzufahren.',
  'settings.amrActivationOpen': 'Anmeldeseite öffnen',
  'settings.amrCancelSignIn': 'Anmeldung abbrechen',
  'settings.amrAccountStatus': 'AMR-Kontostatus',
  'settings.amrConsole': 'AMR-Konsole',
  'settings.amrLoginErrorCompact': 'AMR-Anmeldung fehlgeschlagen.',
  'settings.advanced': 'Erweitert',
  'settings.amrLogin': 'Anmelden',
  'settings.amrLogout': 'Abmelden',
  'settings.amrLoggingIn': 'Anmeldung läuft…',
  'settings.amrLoggingOut': 'Abmeldung läuft…',
  'settings.amrLoggedInAs': 'Angemeldet als {email}',
  'settings.amrLoggedInWithPlan': 'Angemeldet als {email} · {plan}',
  'settings.amrLoggedInPill': 'Angemeldet',
  'settings.amrNotLoggedIn': 'Nicht angemeldet',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Anbieter schnell ausfüllen',
  'settings.providerPreset': 'Gateway-Voreinstellung',
  'settings.protocolGroupProtocols': 'Protokolle',
  'settings.protocolGroupGateways': 'Gateways',
  'settings.customProvider': 'Benutzerdefinierter Anbieter',
  'settings.apiKey': 'API-Key',
  'settings.apiKeyGetLink': 'Key abrufen ↗',
  'settings.showKey': 'Key anzeigen',
  'settings.hideKey': 'Key ausblenden',
  'settings.show': 'Anzeigen',
  'settings.hide': 'Ausblenden',
  'settings.model': 'Modell',
  'settings.apiKeyInvalid': 'Ungültiger API key.',
  'settings.apiKeyCleaned': 'Zusätzliche Leerzeichen aus dem API key entfernt.',
  'settings.modelsLoadedFromAccount': '✓ {count} Modelle aus deinem Konto geladen.',
  'settings.modelsLoadedCount': '✓ {count} Modelle geladen.',
  'settings.modelSourceAccount': 'Aus Ihrem Konto',
  'settings.modelSourceSuggested': 'Vorgeschlagen',
  'settings.fetchModels': 'Modelle abrufen',
  'settings.fetchModelsTitle': 'Verfügbare Modelle von diesem Anbieter abrufen',
  'settings.fetchModelsRunning': 'Modelle werden abgerufen…',
  'settings.fetchModelsMissingFields': 'Füllen Sie {fields} aus, um Modelle abzurufen.',
  'settings.fetchModelsInvalidBaseUrl': 'Geben Sie eine gültige Base URL ein, um Modelle abzurufen.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI verwendet Deployment-Namen, daher ist die Modellerkennung hier nicht verfügbar.',
  'settings.fetchModelsUnsupportedOllama': 'Die Modellerkennung für Ollama Cloud ist noch nicht verfügbar. Wählen Sie ein Modell aus oder geben Sie eines ein.',
  'settings.fetchModelsSuccess': '{count} Modelle abgerufen.',
  'settings.fetchModelsEmpty': 'Es wurden keine kompatiblen Textmodelle zurückgegeben.',
  'settings.fetchModelsUnsupported': 'Die Modellerkennung ist für dieses Protokoll nicht verfügbar.',
  'settings.fetchModelsFailed': 'Modelle konnten nicht abgerufen werden: {detail}',
  'settings.suggestedModelsHint': 'Dies sind vorgeschlagene Modelle für dieses Protokoll. Ihr Anbieter kann andere Modelle unterstützen.',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': 'Öffentliche http://- oder https://-URL verwenden.',
  'settings.baseUrlCustomize': 'Anpassen',
  'settings.baseUrlDefaultHint': 'Standard-Endpunkt. Normalerweise muss dies nicht geändert werden.',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Du findest dies im Azure-Portal → deine Ressource → Endpoint.',
  'settings.azureDeploymentModel': 'Deployment-Name',
  'settings.azureCustomDeploymentName': 'Benutzerdefinierter Deployment-Name',
  'settings.azureDeploymentModelHint': 'Fuer Azure OpenAI wird dieses Feld als Deployment-Name in /openai/deployments/<model> verwendet. Geben Sie den in Azure angelegten Deployment-Namen ein.',
  'settings.azureModelFetchHint': 'Gib den Bereitstellungsnamen deiner Azure-Ressource ein. Azure-Bereitstellungen können nicht automatisch abgerufen werden.',
  'settings.apiVersion': 'API-Version',
  'settings.byokImageModel': 'Bilderzeugungsmodell',
  'settings.byokVideoModel': 'Videoerzeugungsmodell',
  'settings.byokVideoI2vHint': 'Bild-zu-Video-Modell: Referenzbild erforderlich (sonst wird automatisch das neueste Projektbild verwendet)',
  'settings.byokSpeechModel': 'Sprachsynthese-Modell',
  'settings.byokSpeechVoice': 'Stimme',
  'settings.byokModelDefaultOption': 'Standard',
  'settings.maxTokens': 'Max. Tokens (optional)',
  'settings.maxTokensHint': 'Obergrenze für die Antwortlänge. Jedes Modell hat einen abgestimmten Standardwert (im Platzhalter sichtbar); leer lassen, um ihn zu verwenden, oder eine Zahl eingeben, um ihn zu überschreiben.',
  'settings.apiHint': 'Anfragen werden über den lokalen Daemon-Proxy an die festgelegte Base URL gesendet. Der Schlüssel wird nur in diesem Browser gespeichert und mit Provider-Anfragen gesendet.',
  'settings.skipForNow': 'Vorerst überspringen',
  'settings.getStarted': 'Loslegen',
  'settings.envConfigure': 'Ausführungsmodus',
  'settings.localCli': 'Lokale CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'kein Agent ausgewählt',
  'settings.language': 'Sprache',
  'settings.languageHint': 'Wechseln Sie die Sprache der Oberfläche. Wird in diesem Browser gespeichert.',
  'settings.appearance': 'Erscheinungsbild',
  'settings.appearanceHint': 'Hell, dunkel oder Systemeinstellung übernehmen.',
  'settings.themeSystem': 'System',
  'settings.themeLight': 'Hell',
  'settings.themeDark': 'Dunkel',
  'settings.agentModelHead': 'Modell für:',
  'settings.modelPicker': 'Modell',
  'settings.modelSourceLive': 'Live aus der CLI',
  'settings.modelSourceFallback': 'Integrierte Liste',
  'settings.reasoningPicker': 'Reasoning-Aufwand',
  'settings.modelPickerHint': 'Wird aus der CLI geladen, wenn sie einen `models`-Befehl anbietet. „Standard“ überlässt die Auswahl der CLI-Konfiguration; mit „Benutzerdefiniert…“ können Sie jede von der CLI akzeptierte Modell-ID eingeben.',
  'settings.modelPickerLiveHint': 'Modelle wurden aus der installierten CLI aktualisiert. Standard verwendet weiterhin die CLI-Konfiguration.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Modelle wurden aus der installierten CLI aktualisiert.',
  'settings.modelPickerFallbackHint': 'Integrierte Standardwerte werden angezeigt. Klicken Sie auf Neu scannen, um Live-Modelle aus der CLI abzurufen.',
  'settings.cliEnvTitle': 'Erweitert: Proxy und benutzerdefinierte Pfade',
  'settings.cliEnvHint': 'Nutze diese Felder, um die Umgebung der ausgewählten CLI zu überschreiben: API-Keys, Proxy-Base-URLs, eigene Homes oder nicht standardmäßige Binary-Pfade. Ohne Base URL nutzt die CLI ihren Standard-Endpunkt. Secrets bleiben in der lokalen App-Konfiguration und werden nur an die ausgewählte CLI weitergegeben.',
  'settings.cliEnvClaudeConfigDir': 'Claude Code-Konfigurationsverzeichnis',
  'settings.cliEnvClaudeBaseUrl': 'Claude-Proxy-Base-URL',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API-Key',
  'settings.cliEnvCodexHome': 'Codex-Home',
  'settings.cliEnvCodexBin': 'Codex-Programmpfad',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI-Proxy-Base-URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API-Key',
  'settings.modelCustom': 'Benutzerdefiniert (unten eingeben)…',
  'settings.modelCustomLabel': 'Benutzerdefinierte Modell-ID',
  'settings.modelCustomPlaceholder': 'z. B. anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'Medienanbieter',
  'settings.mediaProvidersHint': 'API-Keys für Bild-, Video- und Audiogenerierung. Lokal gespeichert und mit dem lokalen Daemon synchronisiert.',
  'settings.mcpServerTitle': 'MCP-Server',
  'settings.mcpServerHint': 'Stelle Open Design als MCP-Server für deinen Coding-Agent bereit.',
  'settings.externalMcpTitle': 'Externes MCP',
  'settings.externalMcpHint': 'MCP-Tools aus externen Diensten hinzufügen (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API-Key',
  'settings.mediaProviderBaseUrl': 'Base URL',
  'settings.mediaProviderConfigured': 'Konfiguriert',
  'settings.mediaProviderUnset': 'Nicht gesetzt',
  'settings.mediaProviderClear': 'Leeren',
  'settings.mediaProviderClearConfirm': 'Gespeicherte {name}-Einstellungen löschen? Du musst sie erneut eingeben, um {name} zu nutzen.',
  'settings.mediaProviderPlaceholder': 'API-Key einfügen',
  'settings.mediaProviderBaseUrlPlaceholder': 'Standard-Base-URL überschreiben',
  'settings.mediaProviderReload': 'Vom lokalen Daemon neu laden',
  'settings.mediaProviderReloadError': 'Die Einstellungen der Medienanbieter konnten nicht vom lokalen Daemon neu geladen werden.',
  'settings.mediaProviderReloadSuccess': 'Die Einstellungen der Medienanbieter wurden vom lokalen Daemon neu geladen.',
  'settings.mediaProviderLoadError': 'Die Einstellungen der Medienanbieter konnten nicht vom lokalen Daemon geladen werden. Vorerst werden die im Browser gespeicherten Einstellungen verwendet.',
  'settings.mediaProviderComingSoonHint': 'Wir verfolgen diese für die Roadmap; der Daemon liefert noch keinen Client, daher gibt es nichts zu konfigurieren.',
  'settings.privacy': 'Datenschutz',
  'settings.privacyHint': 'Welche Daten mit dem Open Design-Team geteilt werden',
  'settings.privacyConsentKicker': 'Hilf uns, Open Design zu verbessern',
  'settings.privacyConsentLead': 'Open Design kann Nutzungsdaten mit unserem Team teilen, um uns bei Verbesserungen zu helfen. Dazu gehören:',
  'settings.privacyConsentFooter': 'Du kannst diese Einstellungen jederzeit unter Einstellungen → Datenschutz ändern.',
  'settings.privacyConsentShare': 'Nutzungsdaten teilen',
  'settings.privacyConsentDecline': 'Nicht teilen',
  'settings.privacyConsentAccept': 'Verstanden',
  'settings.privacyConsentBannerFooter': 'Datenfreigabe ist standardmäßig aktiviert. Du kannst sie jederzeit unter Einstellungen → Datenschutz deaktivieren.',
  'settings.privacyConsentPolicyLink': 'Datenschutzrichtlinie lesen',
  'settings.privacyMetrics': 'Anonyme Metriken',
  'settings.privacyMetricsHint': 'Ausführungsanzahl, Token-Verbrauch, Fehlerrate, Dauer. Keine Prompts, keine Projektdaten.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': 'Prompts, Antworten des Assistenten, Ein- und Ausgaben von Tools sowie vollständige Kontextdateien, die für die Qualitätsprüfung benötigt werden. Geheimnisse werden vor dem Senden entfernt.',
  'settings.privacyInstallationId': 'Anonyme ID',
  'settings.privacyOptedOut': 'abgemeldet',
  'settings.privacyDataDeletion': 'Meine Daten löschen',
  'settings.privacyDataDeletionHint': 'Erneuert deine anonyme ID und stoppt das Senden. Bestehende Traces verfallen gemäß unserer Aufbewahrungsrichtlinie.',
  'settings.about': 'Info',
  'settings.aboutHint': 'Version und Laufzeitdetails',
  'settings.appVersion': 'Version',
  'settings.appChannel': 'Kanal',
  'settings.appRuntime': 'Laufzeit',
  'settings.appPlatform': 'Plattform',
  'settings.appArchitecture': 'Architektur',
  'settings.runtimePackaged': 'Paketierte App',
  'settings.runtimeDevelopment': 'Entwicklung',
  'settings.versionUnavailable': 'Versionsdetails sind nicht verfügbar, solange der Daemon offline ist.',
  'settings.installLatest': 'Neueste Version installieren',
  'settings.alreadyLatest': 'Sie verwenden die neueste Version',
  'settings.mcpTitle': 'MCP-Server',
  'settings.mcpHint': 'Lass Coding-Agents (Cursor, Claude Code, VS Code…) deine Open Design-Projekte direkt lesen.',
  'settings.mcpDaemonError': 'Der lokale Daemon konnte nicht erreicht werden, um die Installationspfade aufzulösen ({error}). Stelle sicher, dass Open Design läuft, und öffne dieses Panel dann erneut.',
  'settings.mcpBuildDaemon': 'Erstelle zuerst den Daemon.',
  'settings.mcpNodeMissing': 'Node-Binary fehlt.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js fehlt. Führe `pnpm --filter @open-design/daemon build` aus und aktualisiere.',
  'settings.mcpMethodCli': 'CLI-Befehl',
  'settings.mcpInstructionCli': 'Führe dies in deinem Terminal aus.',
  'settings.mcpMethodToml': 'TOML-Konfiguration',
  'settings.mcpInstructionCodex': 'Füge diese Tabelle an {path} an. Dieselbe Konfiguration wird zwischen der Codex CLI und der Codex-IDE-Erweiterung geteilt.',
  'settings.mcpMethodOneClick': 'Ein-Klick-Installation',
  'settings.mcpInstructionCursor': 'Klicke auf "In Cursor installieren", um mit einem Bestätigungsdialog zu installieren, oder führe dieses JSON in {path} zusammen.',
  'settings.mcpDeeplinkInstallCursor': 'In Cursor installieren',
  'settings.mcpMethodJson': 'JSON-Konfiguration',
  'settings.mcpInstructionCopilot': 'Öffne die Befehlspalette ({shortcut}), führe "MCP: Open User Configuration" aus und führe dieses JSON zusammen. Copilot Chat muss im Agent-Modus sein, damit die Tools angezeigt werden.',
  'settings.mcpInstructionAntigravity': 'In Antigravity: Agent-Panel-Menü "..." → MCP Servers → Manage MCP Servers → View raw config. Führe dieses JSON zusammen.',
  'settings.mcpInstructionZed': 'Öffne die Zed-Einstellungen ({shortcut}) und füge dies in das Objekt der obersten Ebene ein. Zed verwendet "context_servers", nicht "mcpServers".',
  'settings.mcpInstructionWindsurf': 'Öffne {path} (oder verwende das MCPs-Symbol in Cascade → Configure) und führe zusammen:',
  'settings.mcpCopyAria': 'MCP-Konfigurations-Snippet kopieren',
  'settings.mcpResolvingFailed': '# Auflösen der Pfade fehlgeschlagen, siehe den Fehler oben',
  'settings.mcpLoadingPaths': '# Installationspfade werden vom lokalen Daemon geladen…',
  'settings.mcpCopied': 'Kopiert',
  'settings.mcpCopy': 'Kopieren',
  'settings.mcpCursorApproval': 'Cursor zeigt vor dem Schreiben der Konfiguration einen Bestätigungsdialog an.',
  'settings.mcpCodexOneClickInstall': 'In Codex installieren',
  'settings.mcpCodexOneClickUninstall': 'Aus Codex entfernen',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI nicht im PATH gefunden — installiere Codex oder füge das Snippet manuell ein.',
  'settings.mcpCodexInstallSuccess': 'Installiert. Starte Codex neu, um den neuen Server zu laden.',
  'settings.mcpCodexUninstallSuccess': 'Aus Codex entfernt.',
  'settings.mcpCodexBusy': 'Wird bearbeitet…',
  'settings.mcpCodexInstallError': 'Vorgang fehlgeschlagen: {error}',
  'settings.mcpRestartNote': 'Starte deinen Client neu, um den neuen Server zu übernehmen.',
  'settings.mcpRestartDetail': 'Die meisten Editoren laden MCP-Server nur beim Start. In Cursor / VS Code / Antigravity / Windsurf kannst du statt eines vollständigen Neustarts `Developer: Reload Window` aus der Befehlspalette ausführen. Zed und Claude Code müssen beendet und neu geöffnet werden.',
  'settings.mcpCapabilitiesTitle': 'Was dein Agent tun kann',
  'settings.mcpCapabilityRead': 'Beliebige Datei in einem Projekt lesen oder durchsuchen (HTML, JSX, CSS, JSON, SVG, Markdown).',
  'settings.mcpCapabilityPull': 'Ein Design-Bundle in einem einzigen Aufruf abrufen: die Einstiegsdatei sowie jede CSS-Variable, Komponente und Schriftart, auf die sie verweist.',
  'settings.mcpCapabilityDefault': 'Standardmäßig wird das Projekt und die Datei verwendet, die du in Open Design geöffnet hast, sodass du "Baue das in meiner App" sagen kannst, ohne erneut anzugeben, welches Design gemeint ist.',
  'settings.mcpRunningNote': 'Open Design muss laufen, damit MCP-Tool-Aufrufe erfolgreich sind. Wenn du deinen Coding-Agent gestartet hast, bevor du Open Design geöffnet hast, starte den Agent neu, damit er den aktiven Daemon erreichen kann.',
  'entry.tabDesigns': 'Designs',
  'entry.tabTemplates': 'Vorlagen',
  'entry.tabDesignSystems': 'Designsysteme',
  'entry.tabConnectors': 'Connectors',
  'entry.openSettingsTitle': 'Einstellungen',
  'entry.openSettingsAria': 'Einstellungen öffnen',
  'entry.discordLabel': 'Discord beitreten',
  'entry.discordAria': 'Tritt dem Open Design Discord bei',
  'entry.discordAriaWithOnline': 'Tritt dem Open Design Discord bei - {online}',
  'entry.discordOnlineLabel': '{count} online',
  'entry.followXLabel': 'Folge @OpenDesignHQ auf X',
  'entry.followThreadsLabel': 'Follow Open Design on Threads',
  'entry.youtubeLabel': 'Open Design on YouTube',
  'entry.resizeAria': 'Seitenleiste skalieren',
  'entry.loadingWorkspace': 'Workspace wird geladen…',
  'entry.useEverywhereTitle': 'Überall verwenden',
  'entry.useEverywhereAria': 'Anleitung „Überall verwenden“ öffnen (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'entry.workspaceTeamsTitle': 'Workspace für Teams — sag uns, was dein Team braucht',
  'entry.workspaceTeamsAria': 'Die Seite „Workspace für Teams“ öffnen',
  'entry.navExpand': 'Seitenleiste einblenden',
  'entry.navCollapse': 'Seitenleiste ausblenden',
  'entry.navNewProject': 'Neues Projekt',
  'entry.navHome': 'Start',
  'entry.navProjects': 'Projekte',
  'entry.navTasks': 'Automatisierungen',
  'entry.navPlugins': 'Plugins',
  'entry.navDesignSystems': 'Design-Systeme',
  'entry.navBrands': 'Brand Kit',
  'entry.navIntegrations': 'Integrationen',
  'workspaceTabs.project': 'Projekt',
  'workspaceTabs.pluginDetails': 'Plugin-Details',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'Was gestaltest du heute?',
  'homeHero.startWithTemplate': 'Mit einer Vorlage beginnen…',
  'homeHero.startBlankProject': '…oder mit einem leeren Projekt beginnen',
  'homeHero.templatePicker.label': 'Vorlage',
  'homeHero.templatePicker.searchPlaceholder': 'Vorlagen suchen',
  'homeHero.templatePicker.projectTypes': 'Projekttypen',
  'homeHero.templatesScrollHint': 'Nach oben scrollen, um weitere Vorlagen zu entdecken',
  'homeHero.templatesCollapse': 'Vorlagen einklappen',
  'homeHero.subtitlePrefix': 'Die quelloffene Alternative zu Claude Design.',
  'homeHero.placeholder': 'Beschreibe, was du generieren möchtest…',
  'homeHero.placeholderActive': 'Bearbeite die Beispielabfrage oder schreibe eine eigene…',
  'homeHero.carousel.hint': 'Datei anhängen, Designsystem verknüpfen oder beschreiben, was du erstellen möchtest',
  'homeHero.carousel.onePageBrief': 'Ein einseitiges Projekt-Briefing entwerfen',
  'homeHero.carousel.notesToDeck': 'Meine Notizen in eine Präsentation verwandeln',
  'homeHero.carousel.signupFlow': 'Einen Anmeldeflow entwerfen',
  'homeHero.carousel.improveBrief': 'Ein bestehendes Projekt-Briefing verbessern',
  'homeHero.carousel.loadingAnimation': 'Eine Ladeanimation erstellen',
  'homeHero.carousel.teamUpdateSlides': 'Folien für ein Team-Update gestalten',
  'homeHero.carousel.ordersDashboard': 'Ein Dashboard zur Bestellverfolgung prototypisieren',
  'homeHero.carousel.productDetail': 'Eine Produktdetailseite layouten',
  'homeHero.carousel.caseStudy': 'Eine Fallstudie skizzieren',
  'homeHero.carousel.landingIntro': 'Eine kurze Einleitung für eine Landingpage gestalten',
  'homeHero.carousel.pitchDeck': 'Ein Pitch-Deck für ein neues Produkt erstellen',
  'homeHero.carousel.appIdea': 'Eine App-Idee beschreiben',
  'homeHero.carousel.landingLayout': 'Ein Landingpage-Layout skizzieren',
  'homeHero.skills': 'Skills',
  'homeHero.addMenu': 'Kontext hinzufügen',
  'homeHero.addPlugin': 'Plugin hinzufügen',
  'homeHero.addConnectors': 'Konnektoren hinzufügen',
  'homeHero.addMcp': 'MCP-Server hinzufügen',
  'homeHero.noPlugins': 'Keine installierten Plugins',
  'homeHero.noMcp': 'Keine MCP-Server',
  'homeHero.noConnectors': 'Keine verbundenen Konnektoren',
  'homeHero.applying': 'Wird angewendet…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'Plugin entfernen',
  'homeHero.removePluginAria': 'Plugin {title} entfernen',
  'homeHero.clearActivePlugin': 'Aktives Plugin entfernen',
  'homeHero.clearActiveSkill': 'Aktiven Skill entfernen',
  'homeHero.contextItemsResolved': '{n} Kontextelemente aufgelöst',
  'homeHero.removeFile': 'Datei entfernen',
  'homeHero.contextSearchResults': 'Kontext-Suchergebnisse',
  'homeHero.contextSurfaces': 'Kontextquellen',
  'homeHero.loadingContext': 'Kontext wird geladen…',
  'homeHero.noResults': 'Keine Ergebnisse für "{query}".',
  'homeHero.searchPrompt': 'Dateien, Plugins, Skills, MCP-Server und Connectors durchsuchen.',
  'homeHero.parameters': '{n} Parameter',
  'homeHero.details': 'Details',
  'homeHero.toRun': 'zum Ausführen',
  'homeHero.forNewLine': 'für neue Zeile',
  'homeHero.run': 'Ausführen',
  'homeHero.typeSomethingToRun': 'Etwas zum Ausführen eingeben',
  'homeHero.promptExamples': 'Beispiele',
  'homeHero.footer.designSystem': 'Stil',
  'homeHero.footer.autoDesignSystem': 'Automatisch',
  'homeHero.footer.autoDesignSystemSummary': 'Wählt automatisch das passende Designsystem und den visuellen Stil für den aktuellen Prompt.',
  'homeHero.footer.ratio': 'Format',
  'homeHero.footer.duration': 'Dauer',
  'homeHero.footer.resolution': 'Auflösung',
  'homeHero.footer.speakerNotes': 'Notizen',
  'homeHero.footer.noSpeakerNotes': 'Keine Notizen',
  'homeHero.footer.availableCount': '{n} verfügbar',
  'homeHero.footer.noMatches': 'Keine Treffer',
  'homeHero.moreShortcuts': 'Mehr',
  'homeHero.railAria': 'Wähle eine Projektkategorie oder einen Starter-Shortcut',
  'homeHero.subTypeAria': 'Wähle einen Untertyp',
  'homeHero.confirmReplaceTitle': 'Aktuellen Prompt ersetzen?',
  'homeHero.confirmReplaceBody': 'Wenn du {title} verwendest, wird der aktuelle Text im Eingabefeld ersetzt.',
  'homeHero.confirmReplace': 'Ersetzen',
  'homeHero.chip.prototype': 'Prototyp',
  'homeHero.chip.liveArtifact': 'Live-Artefakt',
  'homeHero.chip.deck': 'Präsentation',
  'homeHero.chip.image': 'Bild',
  'homeHero.chip.video': 'Video',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.audio': 'Audio',
  'homeHero.chip.createBrandKit': 'Brand Kit erstellen',
  'homeHero.chip.createPlugin': 'Plugin erstellen',
  'homeHero.chip.figma': 'Aus Figma',
  'homeHero.chip.folder': 'Aus Ordner',
  'homeHero.chip.template': 'Aus Vorlage',
  'homeHero.chip.liveArtifactHint': 'Erstelle ein interaktives HTML/CSS/JS-Artefakt, das du live in der Vorschau ansehen kannst.',
  'homeHero.chip.hyperframesHint': 'Erstelle HTML-basierte Animationen: Untertitel, audioreaktive Visuals, Szenenübergänge.',
  'homeHero.chip.createBrandKitHint': 'Extrahiere ein Brand Kit aus einer Website und wende es in jedem Chat an.',
  'homeHero.chip.createPluginHint': 'Erstelle ein wiederverwendbares Open Design Plugin und füge es zu Meine Plugins hinzu.',
  'homeHero.chip.figmaHint': 'Migriere einen Figma-Frame in das aktive Designsystem.',
  'homeHero.chip.folderHint': 'Importiere einen vorhandenen lokalen Ordner und setze die Bearbeitung fort.',
  'homeHero.chip.templateHint': 'Beginne mit einer mitgelieferten Vorlage.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Ordner',
  'workingDirPicker.homeTitle': 'Im lokalen Speicher gespeichert – zum Ordner auswählen klicken',
  'workingDirPicker.processing': 'Wird verarbeitet…',
  'workingDirPicker.select': 'Lokaler Speicher',
  'workingDirPicker.clearAria': 'Arbeitsverzeichnis leeren',
  'workingDirPicker.replaceFailed': 'Arbeitsverzeichnis konnte nicht ersetzt werden',
  'workingDirPicker.unavailable': 'Die Ordnerauswahl ist in diesem Build nicht verfügbar. Führen Sie die Desktop-App aus, um einen Ordner auszuwählen.',
  'workingDirPicker.openUnavailable': 'Öffnen Sie dieses Projekt in der Desktop-App, um den Ordner anzuzeigen.',
  'workingDirPicker.openFailed': 'Dieser Ordner konnte nicht angezeigt werden',
  'workingDirPicker.showInFileManager': 'Im Dateimanager anzeigen',
  'workingDirPicker.replace': 'Ordner auswählen…',
  'workingDirPicker.recent': 'Zuletzt verwendete Verzeichnisse',
  'workingDirPicker.defaultLabel': 'Lokaler Speicher',
  'handoff.toTarget': 'An {target} übergeben',
  'handoff.openInTarget': 'In {target} öffnen',
  'handoff.openAction': 'Öffnen',
  'handoff.menuTitle': 'In welchem Editor öffnen?',
  'handoff.action': 'Übergeben',
  'handoff.fallbackTitle': 'Keine Editoren im $PATH gefunden – wird in {target} geöffnet',
  'handoff.chooseTargetAria': 'Übergabeziel auswählen',
  'handoff.optionsAria': 'Übergabeoptionen',
  'handoff.editorSection': 'Mit Editor öffnen',
  'handoff.cliSection': 'Für CLI kopieren',
  'handoff.clickOpen': 'Zum Öffnen klicken',
  'handoff.framework': 'Code-Framework',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'reines JavaScript, HTML und CSS',
  'handoff.amrWebsite': 'AMR-Website öffnen',
  'handoff.copyPrompt': 'Prompt kopieren',
  'handoff.copyPromptForTarget': 'Prompt für {target} kopieren',
  'handoff.copied': 'Kopiert',
  'handoff.projectPathUnavailable': 'Der Projektpfad wird noch geladen. Versuchen Sie es gleich erneut.',
  'handoff.copyFailed': 'Das Schreiben in die Zwischenablage wurde blockiert. Versuchen Sie es gleich erneut.',
  'handoff.promptIntro': 'Von diesem lokalen Open Design-Projektordner fortfahren:',
  'handoff.promptTarget': 'Ziel',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'Sie übernehmen in {cli}. Bitte:',
  'handoff.promptReadFiles': 'Betreten oder lesen Sie zuerst dieses Verzeichnis. Priorisieren Sie DESIGN.md, README, vorhandenes HTML/CSS/JS, Assets und package.json, falls vorhanden.',
  'handoff.promptKeepDesign': 'Bewahren Sie das aktuelle visuelle Design, Layout, die Interaktionen und Assets. Hören Sie nicht bei einem Plan auf.',
  'handoff.promptProduceCode': 'Generieren oder ändern Sie echten, lauffähigen {framework}-Code. Wenn das Projekt bereits einen klareren Stack hat, weisen Sie auf den Konflikt hin und halten Sie das Ergebnis lauffähig.',
  'handoff.promptVerify': 'Nennen Sie mir zum Abschluss die Befehle zum Ausführen, zur Vorschau und zur Überprüfung.',
  'handoff.promptCommandHint': 'Um aus dem Projektverzeichnis zu starten, verwenden Sie:',
  'handoff.promptProject': 'Projekt',
  'handoff.promptProjectId': 'Projekt-ID',
  'handoff.notInstalled': 'Nicht installiert',
  'handoff.notDetectedTitle': '{target} – nicht im $PATH erkannt',
  'designSystemPicker.select': 'Designsystem auswählen',
  'designSystemPicker.loading': 'Design Systems werden geladen…',
  'designSystemPicker.searchPlaceholder': 'Designsysteme durchsuchen (Titel / Kategorie / Zusammenfassung)',
  'designSystemPicker.searchCompactPlaceholder': 'Designsysteme durchsuchen',
  'designSystemPicker.noneTitle': 'Kein Designsystem',
  'designSystemPicker.noneSummary': 'Das Modell frei wählen lassen',
  'designSystemPicker.empty': 'Keine passenden Designsysteme',
  'designSystemPicker.openPreview': 'Vorschau öffnen',
  'designSystemPicker.loadingPreview': 'Vorschau wird geladen…',
  'designSystemPicker.noPreview': 'Keine Vorschauseite. Öffnen Sie Designsysteme, um die vollständige Vorschau anzuzeigen.',
  'designSystemPicker.previewHint': 'Fahren Sie mit dem Mauszeiger über ein Designsystem, um es in der Vorschau anzuzeigen',
  'designSystemPicker.fullscreenAria': '{title} Vollbildvorschau',
  'designSystemPicker.closeFullscreen': 'Vollbildvorschau schließen',
  'designSystemPicker.closeEsc': 'Schließen (Esc)',
  'designSystemPicker.previewFrameTitle': '{title} Vorschau',
  'designSystemPicker.fullscreenFrameTitle': '{title} Vollbildvorschau',
  'recentProjects.title': 'Zuletzt verwendete Projekte',
  'recentProjects.viewAll': 'Alle anzeigen',
  'recentProjects.empty': 'Noch keine Projekte – gib einen Prompt ein, um eines zu starten.',
  'pluginsHome.title': 'Community',
  'pluginsHome.subtitle': 'Sofort einsatzbereite Open Design Workflows, die mit dieser Laufzeitumgebung gebündelt sind. Wähle einen aus, um einen Starter-Prompt zu laden, oder durchsuche die Registry für mehr.',
  'pluginsHome.browseRegistry': 'Registry durchsuchen',
  'pluginsHome.count': '{filtered} von {total}',
  'pluginsHome.loadingCatalog': 'Katalog wird geladen…',
  'pluginsHome.emptyCatalog': 'Der Katalog ist leer. Gebündelte Plugins werden mit Open Design ausgeliefert und sollten hier automatisch erscheinen – versuche, den Daemon neu zu starten, falls dies weiterhin auftritt.',
  'pluginsHome.emptyFiltered': 'Keine Plugins entsprechen den aktuellen Filtern.',
  'pluginsHome.clearFilters': 'Filter zurücksetzen',
  'pluginsHome.modeAria': 'Plugin-Modus',
  'pluginsHome.featured': 'Gespeichert',
  'pluginsHome.totalInCatalog': '{n} im Katalog',
  'pluginsHome.categoryFilterAria': 'Kategoriefilter',
  'pluginsHome.subcategoryFilterAria': '{label} Unterkategoriefilter',
  'pluginsHome.allCategory': 'Alle {label}',
  'pluginsHome.searchPlaceholder': 'Plugins durchsuchen…',
  'pluginsHome.searchAria': 'Plugins durchsuchen',
  'pluginsHome.clearSearch': 'Suche zurücksetzen',
  'pluginsHome.facet.import': 'Importieren',
  'pluginsHome.facet.create': 'Erstellen',
  'pluginsHome.facet.export': 'Exportieren',
  'pluginsHome.facet.share': 'Teilen',
  'pluginsHome.facet.deploy': 'Bereitstellen',
  'pluginsHome.facet.refine': 'Verfeinern',
  'pluginsHome.facet.extend': 'Erweitern',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Code / Ordner',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Screenshot',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Folien',
  'pluginsHome.facet.publicLink': 'Öffentlicher Link',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Dashboards',
  'pluginsHome.subfacet.app-prototypes': 'Apps',
  'pluginsHome.subfacet.landing-marketing': 'Landing / Marketing',
  'pluginsHome.subfacet.developer-tools': 'Entwickler-Tools',
  'pluginsHome.subfacet.docs-reports': 'Doku / Berichte',
  'pluginsHome.subfacet.brand-design': 'Marke / Design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / Business',
  'pluginsHome.subfacet.course-training': 'Kurs / Training',
  'pluginsHome.subfacet.reports-briefings': 'Berichte / Briefings',
  'pluginsHome.subfacet.product-sales': 'Produkt / Vertrieb',
  'pluginsHome.subfacet.engineering-talks': 'Tech-Talks',
  'pluginsHome.subfacet.creative-decks': 'Kreative Decks',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / Produkt-Mockups',
  'pluginsHome.subfacet.brand-visuals': 'Marke / Logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboards',
  'pluginsHome.subfacet.social-content': 'Social / Content',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / Porträt',
  'pluginsHome.subfacet.illustration-style': 'Illustration / Stil',
  'pluginsHome.subfacet.motion-effects': 'Motion / Effekte',
  'pluginsHome.subfacet.social-short-form': 'Social / Short-Form',
  'pluginsHome.subfacet.marketing-product': 'Marketing / Produkt',
  'pluginsHome.subfacet.data-explainers': 'Daten / Erklärungen',
  'pluginsHome.subfacet.cinematic-story': 'Cinematisch / Story',
  'pluginsView.lede': 'Durchsuche installierte Workflows, entdecke Registry-Einträge, verwalte Quellen und bereite Plugins für die Verteilung im Team vor.',
  'pluginsView.importPlugin': 'Plugin importieren',
  'pluginsView.agentContext': 'Agent-Kontext',
  'pluginsView.summaryAria': 'Plugin-Übersicht',
  'pluginsView.areasAria': 'Plugin-Bereiche',
  'pluginsView.loading': 'Plugins werden geladen…',
  'pluginsView.tab.installed': 'Installiert',
  'pluginsView.tab.available': 'Verfügbar',
  'pluginsView.tab.sources': 'Quellen',
  'pluginsView.tab.team': 'Team',
  'pluginsView.tabHint.installed': 'Deine Plugins',
  'pluginsView.tabHint.available': 'Aus Quellen',
  'pluginsView.tabHint.sources': 'Kataloge',
  'pluginsView.tabHint.team': 'Enterprise',
  'pluginsView.installedTitle': 'Installierte Plugins',
  'pluginsView.installedSubtitle': 'Plugins, die du importiert oder aus Marketplace-Quellen installiert hast.',
  'pluginsView.installedEmpty': 'Noch keine installierten Benutzer-Plugins. Verwende Erstellen / Importieren oder installiere einen verfügbaren Eintrag.',
  'pluginsView.availableTitle': 'Verfügbar aus Quellen',
  'pluginsView.availableSubtitle': 'Katalogeinträge, die aus konfigurierten Marketplaces gefunden wurden.',
  'pluginsView.availableFiltersAria': 'Verfügbare Plugin-Filter',
  'pluginsView.searchAvailableAria': 'Verfügbare Plugins suchen',
  'pluginsView.searchAvailablePlaceholder': 'Verfügbare Plugins suchen',
  'pluginsView.clearAvailableSearch': 'Suche nach verfügbaren Plugins zurücksetzen',
  'pluginsView.source': 'Quelle',
  'pluginsView.availableEmptyInstalled': 'Noch keine verfügbaren Einträge. Installierte Katalogeinträge werden aus „Verfügbar“ entfernt; deinstalliere einen, um ihn wieder verfügbar zu machen.',
  'pluginsView.availableEmptyFiltered': 'Keine verfügbaren Einträge entsprechen deinen Filtern.',
  'pluginsView.availableEmptyNoSources': 'Noch keine verfügbaren Einträge. Füge im Tab „Quellen“ eine Quelle hinzu.',
  'pluginsView.installing': 'Wird installiert…',
  'pluginsView.install': 'Installieren',
  'pluginsView.sourcesTitle': 'Registry-Quellen',
  'pluginsView.sourcesSubtitle': 'Marketplace-Kataloge, die verfügbare Plugin-Einträge bereitstellen.',
  'pluginsView.sourceUrl': 'Quell-URL',
  'pluginsView.defaultTrust': 'Standardvertrauen',
  'pluginsView.trust.restricted': 'Eingeschränkt',
  'pluginsView.trust.trusted': 'Vertrauenswürdig',
  'pluginsView.trust.official': 'Offiziell',
  'pluginsView.adding': 'Wird hinzugefügt…',
  'pluginsView.addSource': 'Quelle hinzufügen',
  'pluginsView.sourcesEmpty': 'Noch keine Registry-Quellen konfiguriert.',
  'pluginsView.pluginsCount': '{n} Plugins',
  'pluginsView.catalogVersion': 'Katalog v{version}',
  'pluginsView.trustFor': 'Vertrauen für {name}',
  'pluginsView.refreshing': 'Wird aktualisiert…',
  'pluginsView.removing': 'Wird entfernt…',
  'pluginsView.teamTitle': 'Private Team-Marketplaces',
  'pluginsView.teamBody': 'Dieser Bereich ist für Enterprise- und Team-Kataloge, private Vertrauensrichtlinien und gemeinsame Plugin-Lebenszyklus-Steuerungen reserviert.',
  'pluginCard.details': 'Details',
  'pluginCard.use': 'Verwenden',
  'pluginCard.useWithQuery': 'Mit Suchanfrage verwenden',
  'pluginCard.applying': 'Wird angewendet…',
  'pluginCard.duplicate': 'Duplizieren',
  'pluginCard.duplicating': 'Wird dupliziert…',
  'pluginCard.duplicateFailed': 'Diese Vorlage konnte nicht dupliziert werden.',
  'pluginCard.saved': 'Gespeichert',
  'pluginCard.publish': 'Veröffentlichen',
  'pluginCard.contribute': 'Beitragen',
  'pluginCard.starting': 'Wird gestartet…',
  'pluginCard.detailsAria': 'Details für {title} anzeigen',
  'pluginCard.chooseUseAria': 'Wähle, wie {title} verwendet werden soll',
  'pluginCard.useOptionsAria': 'Verwendungsoptionen für {title}',
  'pluginCard.duplicateAria': '{title} als neues Projekt duplizieren',
  'pluginCard.saveAria': '{title} speichern',
  'pluginCard.savedAria': '{title} ist gespeichert',
  'pluginCard.shareAria': '{title} teilen',
  'pluginCard.publishAria': '{title} als GitHub-Repository veröffentlichen',
  'pluginCard.publishTitle': 'Plugin als GitHub-Repository veröffentlichen',
  'pluginCard.contributeAria': '{title} zu Open Design beitragen',
  'pluginCard.contributeTitle': 'Plugin per Pull Request zu Open Design beitragen',
  'skillPluginCandidate.createForMe': 'Plugin/Vorlage erstellen',
  'skillPluginCandidate.contributeToMain': 'Zu open-design beitragen',
  'skillPluginCandidate.repoDescription': 'Dieses Repo könnte als Plugin funktionieren.',
  'integrations.kicker': 'Integration',
  'integrations.lede': 'Verbinde externe Systeme, bringe MCP-Tools in deinen Agent-Loop und nutze Open Design aus anderen IDEs, Skripten und Automatisierungen.',
  'integrations.agentReady': 'Agent-bereit',
  'integrations.areasAria': 'Integrationsbereiche',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': 'Externe Tools',
  'integrations.tabHint.connectors': 'Konten und APIs',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Skills-Integrationen',
  'integrations.skillsBody': 'Die Verwaltung von Integrationen auf Skill-Ebene wird aus einem anderen Branch übernommen. Dieser Tab ist reserviert, damit MCP, Connectors und die künftige Skills-Einrichtung in derselben Integration-Route liegen.',
  'mcpClient.title': 'Externe MCP-Server',
  'mcpClient.subtitle': 'Tools von Drittanbietern für deinen Coding-Agent.',
  'mcpClient.addServer': 'Server hinzufügen',
  'mcpClient.emptyTitle': 'Keine MCP-Server konfiguriert.',
  'mcpClient.emptyBody': 'Klicke auf „Server hinzufügen“, um zu beginnen – wähle eine Vorlage (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) oder richte einen benutzerdefinierten stdio-/HTTP-Server ein.',
  'mcpClient.saveChanges': 'Änderungen speichern',
  'mcpClient.storedAt': 'Gespeichert unter',
  'mcpClient.daemonError': 'Der lokale Daemon konnte nicht erreicht werden. Stelle sicher, dass Open Design läuft, und öffne dieses Panel anschließend erneut.',
  'mcpClient.saveFailed': 'Speichern fehlgeschlagen. Prüfe, ob der Daemon läuft, und versuche es erneut.',
  'useEverywhere.modalAria': 'Open Design überall nutzen',
  'useEverywhere.modalTitle': 'Open Design überall verwenden',
  'useEverywhere.modalSubtitle': 'Binde Open Design in jede IDE, jeden Agent oder jedes Skript ein – CLI, HTTP, MCP und Skills. Verwende „Anleitung für einen Agent kopieren“ und füge sie in Claude Code, Codex, Cursor, openclaw oder hermes ein, um alles einzurichten.',
  'useEverywhere.closeAria': 'Überall-Verwendung schließen',
  'useEverywhere.closeTitle': 'Schließen (Esc)',
  'useEverywhere.tabsAria': 'Integrationsflächen',
  'useEverywhere.footStrong': 'Übergabe per Klick.',
  'useEverywhere.footBody': 'Kopiert eine strukturierte Markdown-Anleitung, die dein Agent sofort umsetzen kann – installieren, verifizieren und verwenden.',
  'useEverywhere.configureMcp': 'MCP-Server konfigurieren',
  'useEverywhere.copyGuide': 'Anleitung für einen Agent kopieren',
  'useEverywhere.copy': 'Kopieren',
  'useEverywhere.copied': 'Kopiert',
  'useEverywhere.copyFailed': 'Kopieren fehlgeschlagen',
  'useEverywhere.copySnippetAria': 'Snippet kopieren: {label}',
  'useEverywhere.section.overview.tab': 'Übersicht',
  'useEverywhere.section.overview.heading': 'Open Design funktioniert überall dort, wo dein Agent arbeitet',
  'useEverywhere.section.overview.intro': 'Open Design ist mehr als ein Fenster – es ist ein lokaler, privilegierter Daemon (`od`) plus eine Registry aus Skills + Design Systems + Atoms. Sobald er auf deinem Rechner läuft, kann jeder Code-Agent (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, dein eigenes Skript) Generierungen steuern, Projekte inspizieren und Design-Artefakte über vier austauschbare Oberflächen erzeugen.',
  'useEverywhere.section.overview.bullet1': 'CLI – `od <command>` für Headless-Skripte, CI und Shell-Automatisierung.',
  'useEverywhere.section.overview.bullet2': 'MCP-Server – verbindet Open Design als Model-Context-Protocol-Server, sodass jeder MCP-fähige Agent Skills auflisten, Szenarien ausführen und Artefakte lesen kann.',
  'useEverywhere.section.overview.bullet3': 'HTTP API – `http://127.0.0.1:7456/api/*` REST- + SSE-Endpunkte; dieselbe Oberfläche, die die Web-UI verwendet.',
  'useEverywhere.section.overview.bullet4': 'Skills – einsatzbereite `SKILL.md`-Pakete (Claude-kompatibel), die jeder Agent in deinem PATH ganz ohne Open Design aufrufen kann.',
  'useEverywhere.section.overview.bullet5': 'Standard-Artefakte – erzeuge echte HTML-Projekte aus Skills, gebündelten Standard-Plugins und Community-Plugin-Beispielen, bevor der Daemon startet.',
  'useEverywhere.section.overview.snippet1': 'Den Daemon (und die Web-UI) lokal starten',
  'useEverywhere.section.overview.snippet2': 'Bestätigen, dass er erreichbar ist',
  'useEverywhere.section.overview.snippet3': 'Standard-Artefakte vor dem Start einlesen',
  'useEverywhere.section.overview.footer': 'Der Daemon schreibt standardmäßig nach `./.od/` (projektlokal). Setze `OD_DATA_DIR=~/.open-design`, um Daten projektübergreifend zu teilen.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Open Design über eine beliebige Shell steuern',
  'useEverywhere.section.cli.intro': 'Das `od`-Bin wird mit dem Daemon ausgeliefert und ist dasselbe Binary, das Claude Code / Codex verwenden, wenn sie eine Generierung ausführen. Die meisten Unterbefehle sind schlanke Clients, die per POST an den lokalen Daemon senden, sodass sie gleich funktionieren, egal ob du ihn über `pnpm tools-dev` oder als gepackte App gestartet hast.',
  'useEverywhere.section.cli.bullet1': '`od` (ohne Argumente) – startet den Daemon und öffnet die Web-UI.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` – erzeugt Bild-/Video-/Audio-Bytes über das einheitliche Media-Protokoll.',
  'useEverywhere.section.cli.bullet3': '`od run ...` – startet einen Projektlauf aus einem Prompt + Skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` – installiert und wendet Community-Plugins an.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` – inspiziert, was lokal verfügbar ist.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` – überprüft den Daemon-Zustand und erkennt Agent-CLIs in deinem PATH.',
  'useEverywhere.section.cli.snippet1': 'Ein Bild generieren (delegiert an den konfigurierten Media-Provider)',
  'useEverywhere.section.cli.snippet2': 'Ein Szenario-Plugin headless ausführen und Ereignisse als JSON-Zeilen streamen',
  'useEverywhere.section.cli.snippet3': 'Lokal verfügbare Skills und Design-Systeme auflisten',
  'useEverywhere.section.cli.snippet4': 'Eingelesene Artefakte über die CLI prüfen',
  'useEverywhere.section.cli.snippet5': 'Umgebung + erkannte Agents verifizieren (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'Alle Unterbefehle akzeptieren `--daemon-url http://127.0.0.1:<port>`, um einen bestimmten laufenden Daemon anzusprechen – nützlich, wenn für Tests eine zweite Instanz in einer Sandbox läuft.',
  'useEverywhere.section.mcp.tab': 'MCP-Server',
  'useEverywhere.section.mcp.heading': 'Open Design als MCP-Server für jeden Coding-Agent bereitstellen',
  'useEverywhere.section.mcp.intro': 'Open Design wird mit einem Model-Context-Protocol-Server (`od mcp`) ausgeliefert, mit dem jeder MCP-fähige Client – Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes – Open-Design-Tools entdecken kann (Skills auflisten, Vorschauen rendern, Medien generieren, Plugins ausführen), ohne manuell eine Shell zu bemühen. Der Daemon veröffentlicht über `GET /api/mcp/install-info` für jeden wichtigen Client ein einfügefertiges Installations-Snippet.',
  'useEverywhere.section.mcp.bullet1': 'Stdio-Transport – kein zusätzlicher Port, der Client startet `od mcp` direkt.',
  'useEverywhere.section.mcp.bullet2': 'Ermittelt die Live-Daemon-URL automatisch über den lokalen IPC-Status-Socket, wenn er als Sidecar gestartet wird.',
  'useEverywhere.section.mcp.bullet3': 'Greift bei einfachen Installationen auf `--daemon-url http://127.0.0.1:<port>` zurück, damit der MCP-Prozess immer einen laufenden Daemon findet.',
  'useEverywhere.section.mcp.bullet4': 'Fixiert `OD_DATA_DIR`, sodass der gestartete MCP-Prozess an denselben Ort schreibt, den der Daemon bereits verwendet (vermeidet EPERM in gepackten macOS-App-Bundles).',
  'useEverywhere.section.mcp.snippet1': 'Generische MCP-Client-Konfiguration (funktioniert in Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Oder: Frage den Daemon nach dem auf deine Installation zugeschnittenen Snippet',
  'useEverywhere.section.mcp.snippet3': 'MCP-Variante für Live-Artefakte (Dashboards lesen & aktualisieren)',
  'useEverywhere.section.mcp.footer': 'Öffne in der Open-Design-App Einstellungen → Integrationen, um einen client-spezifischen Installationsbefehl (Cursor, Claude Code, Antigravity, VS Code) zu kopieren, statt JSON von Hand zu bearbeiten.',
  'useEverywhere.section.http.tab': 'HTTP-API',
  'useEverywhere.section.http.heading': 'Dieselbe REST- + SSE-Fläche, die die Web-UI verwendet',
  'useEverywhere.section.http.intro': 'Der lokale Daemon stellt eine HTTP-API unter `http://127.0.0.1:7456` bereit (Port konfigurierbar). Jeder Endpunkt, den die Web-UI aufruft, steht auch deinen Skripten offen. Streaming-Endpunkte (Chat-Turns, Projektläufe) senden Server-Sent Events mit den Vertragstypen in `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` – Daemon-Verfügbarkeit.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` und `GET /api/design-systems` – verfügbare Registrys.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` und `POST /api/projects` – Projekte auflisten und erstellen (POST gibt das Projekt + die erste Konversation zurück).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` – SSE-Stream von Agent-Ereignissen für eine Konversation.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — ein installiertes Plugin binden und die gerenderte Beispielabfrage + Eingaben abrufen.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — erkannte Code-Agent-CLIs in deinem PATH.',
  'useEverywhere.section.http.snippet1': 'Installierte Skills auflisten (der Agent verwendet diese als Vorlagen)',
  'useEverywhere.section.http.snippet2': 'Ein Projekt aus einem Prompt erstellen (vollständiger serverseitiger Ablauf)',
  'useEverywhere.section.http.snippet3': 'Einen Chat-Turn streamen (SSE — jede Zeile ist JSON-Lines-kompatibel)',
  'useEverywhere.section.http.footer': 'Reine TypeScript-Typen für jede Anfrage/Antwort befinden sich in `@open-design/contracts` — importiere sie in dein Skript für vollständige Autovervollständigung, ohne einen Generator einzurichten.',
  'useEverywhere.section.skills.tab': 'Skills & Headless',
  'useEverywhere.section.skills.heading': 'Sofort einsatzbereite Skills für jeden Agent — auch ohne laufendes Open Design',
  'useEverywhere.section.skills.intro': 'Ein Skill ist ein Verzeichnis mit einer Claude-kompatiblen `SKILL.md` (YAML-Front-Matter + Body). Open Design erweitert das Format um den `od:`-Namespace (`mode`, `preview`, `design_system`, `inputs`, …), sodass dasselbe Artefakt sowohl innerhalb von Open Design als auch von einem einfachen Agent wie Claude Code, Codex, openclaw oder hermes genutzt werden kann. Die Erkennung folgt einer Vorrangskette, sodass Projekte ihre eigenen Skills überschreiben können.',
  'useEverywhere.section.skills.bullet1': 'Erkennung: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (Projekt gewinnt).',
  'useEverywhere.section.skills.bullet2': 'Verlinke einen Skill per Symlink in mehrere Projekte, um ihn ohne Kopieren zu teilen.',
  'useEverywhere.section.skills.bullet3': 'Jeder Skill kann Konnektoren, Atome, Design-System-Anforderungen und eine `preview`-Beispielausgabe für die Galerie deklarieren.',
  'useEverywhere.section.skills.bullet4': 'Headless: Ein Agent mit `od` in seinem PATH kann `od skills list` aufrufen und dann jeden Skill ausführen; der Daemon ist für rein lesende Abläufe optional.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` testet dieselbe Artefaktform mit Standard-Plugin-Beispielen und Community-Plugin-Beispielen und speichert die resultierenden `index.html`-Projekte anschließend als wiederverwendbare Testdaten.',
  'useEverywhere.section.skills.snippet1': 'Minimale SKILL.md (Claude-kompatibles Front Matter + Open-Design-Extras)',
  'useEverywhere.section.skills.snippet2': 'Einen geteilten Skill per Symlink in ein Projekt einbinden (cc-switch-Stil)',
  'useEverywhere.section.skills.snippet3': 'Headless: Skills auflisten, die der Daemon gerade sieht',
  'useEverywhere.section.skills.snippet4': 'Headless-Artefakt-Fixture-Bundle',
  'useEverywhere.section.skills.footer': 'Spezifikation: `docs/skills-protocol.md` und `docs/agent-adapters.md` decken die vollständige Adapter-Fläche (Claude Code, Codex, Cursor, MCP-fähige Agents, BYOK-API-Fallback) und die Strategien zur Skill-Injektion pro Adapter ab.',
  'tasks.kicker': 'Automatisierungs-Workspace',
  'tasks.comingSoon': 'Demnächst verfügbar',
  'tasks.lede': 'Automatisierungen verwandeln Prompts in dauerhafte Arbeit: Orbit führt sie aus, Routinen erhalten sie, Zeitpläne entscheiden, wann sie ausgelöst werden, und Live-Artefakte zeigen, was sich geändert hat.',
  'tasks.newAutomation': 'Neue Automatisierung',
  'tasks.previewNote': 'Nur Vorschaufläche. Orbit-Einstellungen sind heute verfügbar; Routinen, Zeitpläne und die Verdrahtung von Live-Artefakten folgen, sobald die Backend-Branches gemergt werden.',
  'tasks.primitivesAria': 'Automatisierungs-Primitive',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'Eine persistente Laufzeitumgebung für langlaufende oder wiederkehrende Agent-Arbeit.',
  'tasks.primitive.orbit.enabled': 'Tägliche Zusammenfassung aktiviert',
  'tasks.primitive.orbit.manualOnly': 'Nur manuell',
  'tasks.primitive.routines.title': 'Routinen',
  'tasks.primitive.routines.body': 'Dauerhafte Aufgabendefinitionen, die nach dem Ende eines einzelnen Chats bestehen bleiben.',
  'tasks.primitive.routines.meta': 'Produkt-Shell bereit',
  'tasks.primitive.schedules.title': 'Zeitpläne',
  'tasks.primitive.schedules.body': 'Zeit- oder Ereignis-Trigger, die entscheiden, wann eine Routine ausgeführt werden soll.',
  'tasks.primitive.schedules.meta': 'Branch ausstehend',
  'tasks.primitive.liveArtifacts.title': 'Live-Artefakte',
  'tasks.primitive.liveArtifacts.body': 'Berichte und Notizen, die sich laufend aktualisieren, während ein Agent arbeitet.',
  'tasks.primitive.liveArtifacts.meta': 'Vorschaumodell',
  'tasks.listAria': 'Liste der Automatisierungen',
  'tasks.routinesAndRuns': '{n} Routinen und Durchläufe',
  'tasks.filtersAria': 'Automatisierungsfilter',
  'tasks.filter.scheduled': 'Geplant',
  'tasks.filter.running': 'Läuft',
  'tasks.filter.done': 'Fertig',
  'tasks.configurationAria': 'Automatisierungskonfiguration',
  'tasks.slot.trigger': 'Auslöser',
  'tasks.slot.pattern': 'Muster',
  'tasks.slot.runtime': 'Laufzeit',
  'tasks.slot.output': 'Ausgabe',
  'tasks.liveArtifact': 'Live-Artefakt',
  'tasks.viewProgress': 'Fortschritt anzeigen',
  'tasks.pause': 'Pausieren',
  'tasks.runNow': 'Jetzt ausführen',
  'tasks.openArtifact': 'Artefakt öffnen',
  'tasks.status.dailyAt': 'Täglich · {time}',
  'tasks.status.pausedManual': 'Pausiert · nur manuell',
  'tasks.sample.orbit.title': 'Orbit Daily Connector-Zusammenfassung',
  'tasks.sample.orbit.metaEnabled': 'Connector-Digest ist geplant',
  'tasks.sample.orbit.metaDisabled': 'Orbit-Einstellungen öffnen, um zu aktivieren',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · Live-Artefakt',
  'tasks.sample.orbit.previewDisabled': 'Kein Durchlauf geplant',
  'tasks.sample.orbit.triggerEnabled': 'Zeitplan · täglich um {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manuell · bei Bedarf ausführen',
  'tasks.sample.orbit.pattern': 'Routine · Connector-Digest',
  'tasks.sample.orbit.runtime': 'Orbit · Daemon-geplant',
  'tasks.sample.orbit.output': 'Live-Artefakt · aktualisierbarer Bericht',
  'tasks.sample.orbit.artifactMetaEnabled': 'Aktualisiert nach jedem Durchlauf',
  'tasks.sample.orbit.artifactMetaDisabled': 'Warten auf Zeitplan',
  'tasks.sample.orbit.body1': '# Orbit Daily Aktivitätszusammenfassung',
  'tasks.sample.orbit.body2': 'Connectors geprüft · Erfolge, Übersprungene und Fehler',
  'tasks.sample.orbit.body3': 'Highlights werden zu einem aktualisierbaren Live-Artefakt.',
  'tasks.sample.mcp.title': 'MCP-Alternativen-Recherche',
  'tasks.sample.mcp.status': 'Läuft in Orbit · 2 Std. 14 Min.',
  'tasks.sample.mcp.meta': '14 / 30 Quellen verarbeitet',
  'tasks.sample.mcp.preview': 'research_notes.md · live',
  'tasks.sample.mcp.trigger': 'Manuell · einmalig',
  'tasks.sample.mcp.pattern': 'Deep-Research-Prompt',
  'tasks.sample.mcp.runtime': 'Remote · dauerhaft',
  'tasks.sample.mcp.output': 'Live-Bericht · automatisch aktualisierend',
  'tasks.sample.mcp.artifactMeta': 'Vor 12 Sek. aktualisiert',
  'tasks.sample.mcp.body1': '# MCP-Alternativen – Zwischenergebnisse',
  'tasks.sample.mcp.body2': '14 Quellen geprüft · 3 Kandidaten in die engere Wahl',
  'tasks.sample.mcp.body3': '## Auswahlliste',
  'tasks.sample.mcp.body4': '- Tool-Call-Schemata via JSON-RPC...',
  'tasks.sample.mcp.body5': '- gRPC-basierte Agent-Protokolle...',
  'tasks.sample.weekly.title': 'Wöchentlicher Team-Digest',
  'tasks.sample.weekly.status': 'Nächster: Mo 9:00 Uhr',
  'tasks.sample.weekly.meta': 'Aktualisiert das wöchentliche Team-Dokument',
  'tasks.sample.weekly.preview': 'team_weekly.md · nächstes Artefakt',
  'tasks.sample.weekly.trigger': 'Zeitplan · wöchentlich',
  'tasks.sample.weekly.pattern': 'Routine · Team-Digest',
  'tasks.sample.weekly.runtime': 'Remote · wiederkehrend',
  'tasks.sample.weekly.output': 'Live-Artefakt · Markdown',
  'tasks.sample.weekly.artifactMeta': 'Zuletzt aktualisiert vor 4 T.',
  'tasks.sample.weekly.body1': '# Team-Wochenbericht',
  'tasks.sample.weekly.body2': '## In Arbeit',
  'tasks.sample.weekly.body3': '- Durchlauf zur Design-System-Integration',
  'tasks.sample.weekly.body4': '- Qualitätsprüfung der Connectors',
  'tasks.sample.weekly.body5': '## Risiken',
  'tasks.sample.pr.title': 'PR-Review-Erinnerung',
  'tasks.sample.pr.status': 'Bei neuem PR · vor 23 Min. ausgelöst',
  'tasks.sample.pr.meta': 'Sendet Slack-DM',
  'tasks.sample.pr.preview': 'Letzte Zustellung erfolgreich',
  'tasks.sample.pr.trigger': 'Ereignis · neuer PR',
  'tasks.sample.pr.pattern': 'Routine · Benachrichtigung',
  'tasks.sample.pr.runtime': 'Lokal · Schnelldurchlauf',
  'tasks.sample.pr.output': 'Nachricht · Slack-DM',
  'tasks.sample.pr.artifactMeta': 'Zuletzt ausgelöst vor 23 Min.',
  'tasks.sample.pr.body1': 'PR #184 zur Überprüfung geöffnet',
  'tasks.sample.pr.body2': 'Zugeordnete Reviewer: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Zustellung: Slack-DM gesendet',
  'tasks.sample.meeting.title': 'Meeting-Vorbereitung',
  'tasks.sample.meeting.status': 'Morgen · 10:00 Uhr',
  'tasks.sample.meeting.meta': 'Einmalig · sendet Zusammenfassung',
  'tasks.sample.meeting.preview': 'meeting_brief.md · in Warteschlange',
  'tasks.sample.meeting.trigger': 'Zeitplan · einmalig',
  'tasks.sample.meeting.pattern': 'Briefing-Prompt',
  'tasks.sample.meeting.runtime': 'Remote · begrenzt',
  'tasks.sample.meeting.output': 'Artefakt + Nachricht',
  'tasks.sample.meeting.artifactMeta': 'In Warteschlange zur Generierung',
  'tasks.sample.meeting.body1': '# Meeting-Briefing',
  'tasks.sample.meeting.body2': 'Agenda-Quelle: Kalendereintrag + verknüpfte Dokumente',
  'tasks.sample.meeting.body3': 'Die Ausgabe enthält Entscheidungen, Blocker und Fragen.',
  'tasks.sample.candidate.title': 'Kandidaten-Tracking',
  'tasks.sample.candidate.status': 'Fehlgeschlagen · erfordert Aufmerksamkeit',
  'tasks.sample.candidate.meta': 'Authentifizierung abgelaufen',
  'tasks.sample.candidate.preview': 'Greenhouse neu verbinden, um fortzufahren',
  'tasks.sample.candidate.trigger': 'Zeitplan · täglich',
  'tasks.sample.candidate.pattern': 'Routine · Bewerber-Sync',
  'tasks.sample.candidate.runtime': 'Remote · wiederkehrend',
  'tasks.sample.candidate.output': 'Live-Artefakt · Tabelle',
  'tasks.sample.candidate.artifactMeta': 'Pausiert, bis die Authentifizierung wiederhergestellt ist',
  'tasks.sample.candidate.body1': '# Kandidaten-Pipeline',
  'tasks.sample.candidate.body2': 'Letzte erfolgreiche Synchronisierung: vor 2 Tagen',
  'tasks.sample.candidate.body3': 'Aktion erforderlich: Quellkonto neu verbinden.',
  'routines.title': 'Automatisierungen',
  'routines.subtitle': 'Geplante Automatisierungen, die unbeaufsichtigt laufen.',
  'routines.newAutomation': 'Neue Automatisierung',
  'routines.loading': 'Wird geladen…',
  'routines.empty': 'Noch keine Automatisierungen.',
  'routines.emptyHint': 'Klicke auf Neue Automatisierung, um einen unbeaufsichtigten Agent-Lauf zu planen.',
  'routines.runHistoryLoading': 'Durchläufe werden geladen…',
  'routines.runHistoryEmpty': 'Noch keine Läufe.',
  'routines.fieldName': 'Name',
  'routines.fieldNamePlaceholder': 'Morgen-Briefing',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'GitHub- + Linear-Aktivität von gestern abrufen und zusammenfassen, was sich geändert hat.',
  'routines.fieldSchedule': 'Zeitplan',
  'routines.fieldMinute': 'Minute jeder Stunde',
  'routines.fieldTime': 'Uhrzeit',
  'routines.fieldTimezone': 'Zeitzone',
  'routines.fieldsetProject': 'Projekt',
  'routines.kind.hourly': 'Stündlich',
  'routines.kind.daily': 'Täglich',
  'routines.kind.weekdays': 'Wochentags',
  'routines.kind.weekly': 'Wöchentlich',
  'routines.weekday.short.0': 'So',
  'routines.weekday.short.1': 'Mo',
  'routines.weekday.short.2': 'Di',
  'routines.weekday.short.3': 'Mi',
  'routines.weekday.short.4': 'Do',
  'routines.weekday.short.5': 'Fr',
  'routines.weekday.short.6': 'Sa',
  'routines.weekday.long.0': 'Sonntag',
  'routines.weekday.long.1': 'Montag',
  'routines.weekday.long.2': 'Dienstag',
  'routines.weekday.long.3': 'Mittwoch',
  'routines.weekday.long.4': 'Donnerstag',
  'routines.weekday.long.5': 'Freitag',
  'routines.weekday.long.6': 'Samstag',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Läuft jede Stunde um :{minute}',
  'routines.describe.daily': 'Läuft täglich um {time} {tz}',
  'routines.describe.weekdays': 'Läuft Mo–Fr um {time} {tz}',
  'routines.describe.weekly': 'Läuft jeden {day} um {time} {tz}',
  'routines.modeCreate': 'Bei jedem Lauf ein neues Projekt erstellen',
  'routines.modeCreateHint': 'Ein frischer, isolierter Arbeitsbereich pro Ausführung.',
  'routines.modeReuse': 'Vorhandenes Projekt wiederverwenden',
  'routines.modeReuseHint': 'Jeder Lauf existiert als neue Konversation innerhalb des Projekts.',
  'routines.pickProject': '— Projekt auswählen —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ neues Projekt bei jedem Durchlauf',
  'routines.tagPaused': 'pausiert',
  'routines.metaNext': 'nächster: {when}',
  'routines.metaLast': 'letzter:',
  'routines.triggerManual': 'manuell',
  'routines.triggerScheduled': 'geplant',
  'routines.openProject': 'Projekt öffnen',
  'routines.openProjectTitle': 'Das Projekt öffnen, in das dieser Lauf geschrieben hat',
  'routines.runNow': 'Jetzt ausführen',
  'routines.edit': 'Bearbeiten',
  'routines.pause': 'Pausieren',
  'routines.resume': 'Fortsetzen',
  'routines.history': 'Verlauf',
  'routines.hideHistory': 'Verlauf ausblenden',
  'routines.delete': 'Löschen',
  'routines.deleteTitle': 'Diese Automatisierung löschen',
  'routines.cancel': 'Abbrechen',
  'routines.save': 'Speichern',
  'routines.saving': 'Wird gespeichert…',
  'routines.create': 'Erstellen',
  'routines.creating': 'Wird erstellt…',
  'routines.status.queued': 'in Warteschlange',
  'routines.status.running': 'läuft',
  'routines.status.succeeded': 'erfolgreich',
  'routines.status.failed': 'fehlgeschlagen',
  'routines.status.canceled': 'abgebrochen',
  'routines.confirmDelete': 'Diese Automatisierung löschen? Frühere Durchläufe und ihre Projekte bleiben erhalten.',
  'routines.errorPickProject': 'Wähle ein Projekt zur Wiederverwendung oder wechsle zu „Bei jedem Durchlauf neu erstellen“',
  'routines.errorAgentEmptyOutput': 'Agent wurde abgeschlossen, ohne eine Ausgabe zu erzeugen. Das Modell oder der Anbieter hat möglicherweise eine leere Antwort zurückgegeben — prüfe die Agent-Logs auf vorgelagerte Fehler.',
  'entry.helpAria': 'Hilfe',
  'entry.helpMenuAria': 'Hilfemenü',
  'entry.helpGetHelp': 'Hilfe auf GitHub',
  'entry.helpSubmitFeature': 'Feature vorschlagen',
  'entry.helpWhatsNew': 'Neuigkeiten',
  'entry.helpDownloadDesktop': 'Desktop-App herunterladen',
  'entry.githubStarLabel': 'Stern',
  'entry.githubStarTitle': 'Klicken, um uns auf GitHub einen Stern zu geben',
  'entry.githubStarAria': 'Open Design auf GitHub einen Stern geben',
  'entry.tabImageTemplates': 'Bildvorlagen',
  'entry.tabVideoTemplates': 'Videovorlagen',
  'promptTemplates.searchPlaceholder': 'Templates suchen…',
  'promptTemplates.countLabel': '{n} Ergebnisse',
  'promptTemplates.emptyImage': 'Noch keine Bild-Prompt-Templates installiert.',
  'promptTemplates.emptyVideo': 'Noch keine Video-Prompt-Templates installiert.',
  'promptTemplates.emptyNoMatch': 'Keine Templates passen zu Ihrer Suche.',
  'promptTemplates.attributionFooter': 'Aus öffentlichen Prompt-Bibliotheken adaptiert. Jede Karte verlinkt zum ursprünglichen Autor.',
  'promptTemplates.openPreviewTitle': 'Prompt und Vorschau öffnen',
  'promptTemplates.sourcePrefix': 'Quelle:',
  'promptTemplates.fetchError': 'Dieser Template-Inhalt konnte nicht geladen werden.',
  'promptTemplates.promptLabel': 'Prompt-Text',
  'promptTemplates.copyPrompt': 'Prompt kopieren',
  'promptTemplates.copyDone': 'Kopiert!',
  'promptTemplates.modelHint': 'Vorgeschlagenes Modell: {model}',
  'promptTemplates.openSource': 'Original anzeigen',
  'promptTemplates.openFullscreen': 'Vollbildvorschau öffnen',
  'promptTemplates.closeFullscreen': 'Vollbildvorschau schließen',
  'promptTemplates.allSources': 'Alle Quellen',
  'promptTemplates.sourceFilterAria': 'Nach Quelle filtern',
  'promptTemplates.retry': 'Erneut versuchen',
  'connectors.title': 'Connectors',
  'connectors.subtitle': 'Lokale und zukünftige Datenquellen, die Live-Artefakte ermöglichen können.',
  'connectors.account': 'Konto',
  'connectors.noAccount': 'Nicht verbunden',
  'connectors.tools': 'Werkzeuge',
  'connectors.connect': 'Verbinden',
  'connectors.disconnect': 'Trennen',
  'connectors.authorizationPending': 'Warten auf Autorisierung...',
  'connectors.authorizationPendingHint': 'Schließen Sie die Autorisierung im geöffneten Fenster ab.',
  'connectors.cancelAuthorization': 'Abbrechen',
  'connectors.configure': 'Konfigurieren',
  'connectors.unavailable': 'Nicht verfügbar',
  'connectors.phaseStubTitle': 'Connector-APIs kommen in Phase 3; dies ist eine Vorschau.',
  'connectors.statusAvailable': 'Verfügbar',
  'connectors.statusConnected': 'Verbunden',
  'connectors.statusError': 'Fehler',
  'connectors.statusDisabled': 'Deaktiviert',
  'connectors.gateTitle': 'Fügen Sie Ihren Composio-API-Key hinzu, um fortzufahren',
  'connectors.gateBody': 'Fügen Sie Ihren Key oben ein und klicken Sie auf Key speichern, um verfügbare Integrationen zu laden.',
  'connectors.aboutLabel': 'Info',
  'connectors.detailsLabel': 'Details',
  'connectors.statusLabel': 'Status',
  'connectors.category.aiAgents': 'KI-Agents',
  'connectors.category.aiInfrastructure': 'KI-Infrastruktur',
  'connectors.category.accounting': 'Buchhaltung',
  'connectors.category.admin': 'Administration',
  'connectors.category.advertising': 'Werbung',
  'connectors.category.analytics': 'Analytics',
  'connectors.category.automation': 'Automatisierung',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Kalender',
  'connectors.category.commerce': 'Commerce',
  'connectors.category.communication': 'Kommunikation',
  'connectors.category.contacts': 'Kontakte',
  'connectors.category.dataPlatform': 'Datenplattform',
  'connectors.category.database': 'Datenbank',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Entwickler',
  'connectors.category.documentation': 'Dokumentation',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Bildung',
  'connectors.category.email': 'E-Mail',
  'connectors.category.events': 'Events',
  'connectors.category.fieldService': 'Außendienst',
  'connectors.category.finance': 'Finanzen',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Formulare',
  'connectors.category.gaming': 'Gaming',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Gastgewerbe',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integration',
  'connectors.category.localization': 'Lokalisierung',
  'connectors.category.logistics': 'Logistik',
  'connectors.category.maps': 'Karten',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Medien',
  'connectors.category.meetings': 'Meetings',
  'connectors.category.nonprofit': 'Gemeinnützig',
  'connectors.category.observability': 'Observability',
  'connectors.category.payments': 'Zahlungen',
  'connectors.category.personal': 'Persönlich',
  'connectors.category.presentations': 'Präsentationen',
  'connectors.category.procurement': 'Beschaffung',
  'connectors.category.product': 'Produkt',
  'connectors.category.productivity': 'Produktivität',
  'connectors.category.projectManagement': 'Projektmanagement',
  'connectors.category.recruiting': 'Recruiting',
  'connectors.category.research': 'Recherche',
  'connectors.category.salesIntelligence': 'Sales Intelligence',
  'connectors.category.scheduling': 'Terminplanung',
  'connectors.category.search': 'Suche',
  'connectors.category.security': 'Sicherheit',
  'connectors.category.signing': 'Signieren',
  'connectors.category.social': 'Social',
  'connectors.category.spreadsheets': 'Tabellen',
  'connectors.category.storage': 'Speicher',
  'connectors.category.support': 'Support',
  'connectors.category.surveys': 'Umfragen',
  'connectors.category.tasks': 'Aufgaben',
  'connectors.category.timeTracking': 'Zeiterfassung',
  'connectors.category.video': 'Video',
  'connectors.category.whiteboard': 'Whiteboard',
  'connectors.categoryLabel': 'Kategorie',
  'connectors.providerLabel': 'Anbieter',
  'connectors.toolsSection': 'Werkzeuge',
  'connectors.toolsLoading': 'Werkzeuge werden geladen…',
  'connectors.noToolsAvailable': 'Noch keine Tools verfügbar. Verbinden Sie sich, um zu entdecken, was diese Integration bereitstellt.',
  'connectors.toolDetailsUnavailable': 'Tool-Details sind nicht verfügbar, aber dieser Connector meldet {n} Tools.',
  'connectors.loadMoreTools': 'Weitere Tools laden',
  'connectors.openDetailsAria': 'Details zu {name} öffnen',
  'connectors.toolsBadgeNone': 'Keine Tools',
  'connectors.toolsBadgeOne': '{n} Tool',
  'connectors.toolsBadgeMany': '{n} Tools',
  'connectors.searchPlaceholder': 'Connectors durchsuchen…',
  'connectors.searchAriaLabel': 'Connectors nach Name, Anbieter oder Tool suchen',
  'connectors.searchClear': 'Suche zurücksetzen',
  'connectors.emptyNoMatchTitle': 'Keine Connectors passen zu „{query}“',
  'connectors.emptyNoMatchBody': 'Versuchen Sie ein anderes Stichwort oder setzen Sie die Suche zurück, um den gesamten Katalog zu durchsuchen.',
  'connectors.emptyNoMatchAction': 'Suche zurücksetzen',
  'newproj.tabPrototype': 'Prototyp',
  'newproj.tabLiveArtifact': 'Live-Artefakt',
  'newproj.tabDeck': 'Slide Deck',
  'newproj.tabTemplate': 'Aus Template',
  'newproj.tabMedia': 'Medien',
  'newproj.tabOther': 'Andere',
  'newproj.titlePrototype': 'Neuer Prototyp',
  'newproj.titleLiveArtifact': 'Neues Live-Artefakt',
  'newproj.titleDeck': 'Neues Slide Deck',
  'newproj.titleTemplate': 'Mit Template starten',
  'newproj.titleImage': 'Neues Bild',
  'newproj.titleVideo': 'Neues Video',
  'newproj.titleAudio': 'Neues Audio',
  'newproj.titleMedia': 'Neue Medien',
  'newproj.titleOther': 'Neues Projekt',
  'newproj.namePlaceholder': 'Projektname',
  'newproj.fidelityLabel': 'Detailgrad',
  'newproj.fidelityWireframe': 'Wireframe',
  'newproj.fidelityHigh': 'High Fidelity',
  'newproj.toggleSpeakerNotes': 'Sprechernotizen verwenden',
  'newproj.toggleSpeakerNotesHint': 'Weniger Text auf Slides — Gesprächspunkte in Notizen halten.',
  'newproj.toggleAnimations': 'Animationen einbeziehen',
  'newproj.toggleAnimationsHint': 'Bewegung (Einstiege, Hover, Übergänge) zusätzlich zum Template hinzufügen.',
  'newproj.targetPlatformsLabel': 'Zielplattformen',
  'newproj.targetPlatformsHint': 'Wählen Sie eine oder mehrere aus. Responsive Web deckt nur Browser-Breakpoints ab; fügen Sie iOS, Android, Tablet-App oder Desktop-App für native plattformübergreifende Varianten hinzu.',
  'newproj.platform.responsive.label': 'Responsive Web',
  'newproj.platform.responsive.hint': 'Ein Web-Erlebnis, angepasst für Desktop-, Tablet- und Mobile-Browser',
  'newproj.platform.webDesktop.label': 'Desktop-Web',
  'newproj.platform.webDesktop.hint': 'Browser-first-Produkt oder Landingpage',
  'newproj.platform.mobileIos.label': 'iOS-App',
  'newproj.platform.mobileIos.hint': 'iPhone-Frames und iOS-Interaktionsregeln',
  'newproj.platform.mobileAndroid.label': 'Android-App',
  'newproj.platform.mobileAndroid.hint': 'Pixel-Frames und Material-Interaktionsregeln',
  'newproj.platform.tablet.label': 'Tablet-App',
  'newproj.platform.tablet.hint': 'Natives Tablet-Erlebnis mit geteilten Ansichten',
  'newproj.platform.desktopApp.label': 'Desktop-App',
  'newproj.platform.desktopApp.hint': 'macOS-/Windows-App-Chrome',
  'newproj.surfaceOptionsLabel': 'Begleitende Oberflächen',
  'newproj.includeLandingPage': 'Landingpage einschließen',
  'newproj.includeLandingPageHint': 'Fügen Sie eine responsive Marketingseite für Werbeanzeigen, Wartelisten, Launch-Kampagnen, App-Downloads oder Produkterklärungen hinzu.',
  'newproj.includeOsWidgets': 'OS-Widgets einschließen',
  'newproj.includeOsWidgetsHint': 'Fügen Sie plattformeigene Startbildschirm-, Sperrbildschirm- oder Schnellzugriffs-Widgets für Mobil-/Tablet-Apps hinzu.',
  'newproj.includeOsWidgetsDisabledHint': 'Verfügbar, wenn iOS-, Android- oder Tablet-App als Zielplattform ausgewählt ist.',
  'newproj.templateLabel': 'Vorlage',
  'newproj.noTemplatesTitle': 'Noch keine Templates',
  'newproj.noTemplatesBody': 'Öffnen Sie ein Projekt und nutzen Sie dann das Teilen-Menü im File Viewer, um es in ein Template umzuwandeln. Templates erscheinen hier.',
  'newproj.savedTemplate': 'Gespeichertes Template',
  'newproj.fileSingular': 'Datei',
  'newproj.filePlural': 'Dateien',
  'newproj.create': 'Erstellen',
  'newproj.locationLabel': 'Speichern unter',
  'newproj.locationDefault': 'Open Design-Projekte',
  'newproj.locationExternalBase': 'Externe Basis',
  'newproj.createLiveArtifact': 'Live-Artefakt erstellen',
  'newproj.createFromTemplate': 'Aus Template erstellen',
  'newproj.createDisabledTitle': 'Speichern Sie zuerst ein Projekt als Template (Teilen-Menü in einem beliebigen Projekt).',
  'newproj.importClaudeZip': 'Claude Design ZIP importieren',
  'newproj.importClaudeZipTitle': 'Einen Claude Design .zip-Export importieren',
  'newproj.importingClaudeZip': 'Import läuft…',
  'newproj.privacyFooter': 'Standardmäßig können nur Sie Ihr Projekt sehen.',
  'newproj.designSystem': 'Designsystem',
  'newproj.dsNoneFreeform': 'Keines — frei',
  'newproj.dsNoneSubtitleEmpty': 'Keine System-Tokens, eigene Palette wählen',
  'newproj.dsNoneSubtitleSelected': 'System-Tokens überspringen. Der Agent wählt eine eigene Palette.',
  'newproj.dsCategoryFallback': 'Designsystem',
  'newproj.dsSearch': 'Designsysteme suchen…',
  'newproj.dsModeAria': 'Auswahlmodus',
  'newproj.dsModeSingle': 'Einzeln',
  'newproj.dsModeMulti': 'Mehrfach',
  'newproj.dsNoneTitle': 'Keines — frei',
  'newproj.dsNoneSub': 'System-Tokens überspringen. Der Agent wählt eine eigene Palette.',
  'newproj.dsEmpty': 'Keine Designsysteme passen zu „{query}“.',
  'newproj.dsFootSingular': 'dient nur als Inspiration.',
  'newproj.dsFootPlural': 'dienen nur als Inspiration.',
  'newproj.dsFootClear': 'Leeren',
  'newproj.dsBadgeDefault': 'STANDARD',
  'newproj.dsPrimaryFallback': 'Primär',
  'newproj.surfaceImage': 'Bild',
  'newproj.surfaceVideo': 'Video',
  'newproj.surfaceAudio': 'Audio',
  'newproj.modelLabel': 'Modell',
  'newproj.modelSearch': 'Modelle suchen…',
  'newproj.modelEmpty': 'Keine passenden Modelle.',
  'newproj.modelRecommended': 'Empfohlen',
  'newproj.modelMissingTitle': 'Modell auswählen',
  'newproj.modelMissingSub': 'Wähle ein Modell für diese Oberfläche.',
  'newproj.aspectLabel': 'Format',
  'newproj.videoLengthLabel': 'Länge',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioKindLabel': 'Audiotyp',
  'newproj.audioKindMusic': 'Musik',
  'newproj.audioKindSpeech': 'Sprache / TTS',
  'newproj.audioKindSfx': 'SFX',
  'newproj.audioDurationLabel': 'Dauer',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.voiceLabel': 'Stimme',
  'newproj.voicePlaceholder': 'Provider-Voice-ID, optional',
  'newproj.connectorsLabel': 'Connectors',
  'newproj.connectorsHint': 'Datenquellen, aus denen dieses Artefakt Daten beziehen kann.',
  'newproj.connectorsEmptyTitle': 'Keine Connectors konfiguriert',
  'newproj.connectorsEmptyBody': 'Verbinden Sie eine Datenquelle, damit Ihr Live-Artefakt echte Zahlen statt Platzhalter abrufen kann.',
  'newproj.connectorsEmptyCta': 'Connectors einrichten →',
  'newproj.connectorsLoading': 'Connectors werden geladen…',
  'newproj.connectorsCountOne': '{n} verbunden',
  'newproj.connectorsCountMany': '{n} verbunden',
  'newproj.connectorsManage': 'Verwalten',
  'newproj.promptTemplateLabel': 'Referenzvorlage',
  'newproj.promptTemplateNoneTitle': 'Keine — eigene schreiben',
  'newproj.promptTemplateNoneSub': 'Galerie überspringen und eigenes Briefing verfassen',
  'newproj.promptTemplateRefSub': 'Referenzvorlage',
  'newproj.promptTemplateSearch': 'Vorlagen suchen…',
  'newproj.promptTemplateEmpty': 'Für dieses Format sind noch keine Vorlagen installiert.',
  'newproj.promptTemplateBodyLabel': 'Prompt (kann angepasst werden)',
  'newproj.promptTemplateOptimizeHint': 'Beliebig editierbar — deine Änderungen fließen in das Agenten-Briefing ein.',
  'newproj.promptTemplateBodyEmpty': 'Leerer Body — der Agent erhält keine Vorlagenreferenz.',
  'newproj.deleteTemplateTitle': 'Template löschen',
  'newproj.deleteTemplateConfirm': '„{name}" löschen? Dies kann nicht rückgängig gemacht werden.',
  'newproj.deleteTemplateConfirmCta': 'Template löschen',
  'newproj.deleteTemplateError': 'Dieses Template konnte nicht gelöscht werden. Bitte erneut versuchen.',
  'designs.subRecent': 'Aktuell',
  'designs.subYours': 'Ihre Designs',
  'designs.filterAria': 'Projekte filtern',
  'designs.searchPlaceholder': 'Suchen…',
  'designs.emptyNoProjects': 'Noch keine Projekte.',
  'designs.emptyNoMatch': 'Keine Projekte passen zu Ihrer Suche.',
  'designs.deleteTitle': 'Projekt löschen',
  'designs.deleteConfirm': '„{name}“ löschen?',
  'designs.cardFreeform': 'frei',
  'designs.badgeLive': 'Live',
  'designs.liveArtifactBadgesAria': 'Live-Artefakt-Badges',
  'designs.liveCount': '{n} live',
  'designs.statusLive': 'Live-Artefakt',
  'designs.statusArchived': 'Archiviert',
  'designs.statusError': 'Fehler',
  'designs.statusRefreshing': 'Wird aktualisiert…',
  'designs.statusRefreshFailed': 'Aktualisierung fehlgeschlagen',
  'designs.statusRefreshed': 'Aktualisiert',
  'designs.status.notStarted': 'Nicht gestartet',
  'designs.status.queued': 'In Warteschlange',
  'designs.status.running': 'Läuft',
  'designs.status.awaitingInput': 'Eingabe nötig',
  'designs.status.succeeded': 'Abgeschlossen',
  'designs.status.published': 'Veröffentlicht',
  'designs.status.failed': 'Fehlgeschlagen',
  'designs.status.canceled': 'Abgebrochen',
  'designs.viewToggleAria': 'Ansichtsmodus',
  'designs.viewGrid': 'Rasteransicht',
  'designs.viewKanban': 'Board-Ansicht',
  'designs.kanbanEmptyColumn': 'Keine Designs',
  'designs.deleteAria': 'Projekt {name} löschen',
  'designs.menuMore': 'Weitere Aktionen',
  'designs.menuRename': 'Umbenennen',
  'designs.menuDelete': 'Löschen',
  'designs.renamePrompt': 'Neuer Name für "{name}"',
  'designs.selectMode': 'Auswählen',
  'designs.cancelSelect': 'Abbrechen',
  'designs.deleteSelected': 'Ausgewählte löschen',
  'designs.selectedCount': '{n} ausgewählt',
  'designs.deleteSelectedConfirm': '{n} Projekt(e) löschen?',
  'designs.deleteSelectedSuccess': '{n} Projekt(e) erfolgreich gelöscht.',
  'designs.deleteSelectedPartial': '{deleted} Projekt(e) gelöscht; {failed} fehlgeschlagen.',
  'designs.tagPrototype': 'Prototyp',
  'designs.tagLiveArtifact': 'Live-Artefakt',
  'designs.tagSlide': 'Folie',
  'designs.tagMedia': 'Medien',
  'designs.renameTitle': 'Projekt umbenennen',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Abbrechen',
  'examples.typeLabel': 'Typ',
  'examples.surfaceLabel': 'Oberfläche',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Bild',
  'examples.surfaceVideo': 'Video',
  'examples.surfaceAudio': 'Audio',
  'examples.scenarioLabel': 'Szenario',
  'examples.modeAll': 'Alle',
  'examples.modePrototypeDesktop': 'Prototypen · Desktop',
  'examples.modePrototypeMobile': 'Prototypen · Mobil',
  'examples.modeDeck': 'Folien',
  'examples.modeDocument': 'Dokumente & Templates',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Live',
  'examples.scenarioGeneral': 'Allgemein',
  'examples.scenarioEngineering': 'Entwicklung',
  'examples.scenarioProduct': 'Produkt',
  'examples.scenarioDesign': 'Design',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Vertrieb',
  'examples.scenarioFinance': 'Finanzen',
  'examples.scenarioHr': 'Personal',
  'examples.scenarioOperations': 'Betrieb',
  'examples.scenarioSupport': 'Support',
  'examples.scenarioLegal': 'Recht',
  'examples.scenarioEducation': 'Bildung',
  'examples.scenarioPersonal': 'Persönlich',
  'examples.searchPlaceholder': 'Beispiele suchen…',
  'examples.searchAria': 'Beispiele nach Namen suchen',
  'examples.emptyNoSkills': 'Keine Skills verfügbar. Läuft der Daemon?',
  'examples.emptyNoMatch': 'Keine Beispiele passen zu diesen Filtern.',
  'examples.openPreview': '⤢ Vorschau öffnen',
  'examples.loadingPreview': 'Vorschau wird geladen…',
  'examples.hoverPreview': 'Für Vorschau hovern',
  'examples.usePrompt': 'Diesen Prompt verwenden',
  'examples.previewModalTitle': 'Vollständige Vorschau öffnen (Modal)',
  'examples.shareTitle': 'Dieses Beispiel teilen',
  'examples.shareLoadFirst': 'Zuerst hovern, um die Vorschau zu laden',
  'examples.unavailablePlaceholder': 'Keine mitgelieferte {kind}-Vorschau — öffnen für mehr Infos',
  'examples.shareUnavailable': 'Keine mitgelieferte {kind}-Vorschau zum Teilen',
  'examples.shareMenu': 'Teilen ▾',
  'examples.exportPdfAllSlides': 'Als PDF exportieren (alle Slides)',
  'examples.exportPptxLocked': 'Als PPTX exportieren… (zuerst Template öffnen)',
  'examples.tagSlideDeck': 'Foliendeck',
  'examples.tagTemplate': 'Vorlage',
  'examples.tagDesignSystem': 'Designsystem',
  'examples.tagMobilePrototype': 'Mobiler Prototyp',
  'examples.tagDesktopPrototype': 'Desktop-Prototyp',
  'examples.tagImage': 'Bild',
  'examples.tagVideo': 'Video',
  'examples.tagAudio': 'Audio',
  'examples.previewLabel': 'Vorschau',
  'ds.surfaceLabel': 'Oberfläche',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Bild',
  'ds.surfaceVideo': 'Video',
  'ds.surfaceAudio': 'Audio',
  'ds.searchPlaceholder': 'Designsysteme suchen…',
  'ds.emptyNoMatch': 'Keine Designsysteme passen zu Ihrer Suche.',
  'ds.badgeDefault': 'STANDARD',
  'ds.preview': 'Vorschau',
  'ds.previewTitle': 'Designsystem-Vorschau',
  'ds.categoryAll': 'Alle',
  'ds.categoryUncategorized': 'Nicht kategorisiert',
  'ds.showcase': 'Showcase',
  'ds.tokens': 'Token',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'DESIGN.md wird geladen…',
  'avatar.title': 'Konto & Einstellungen',
  'avatar.localCli': 'Lokale CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Lokale CLI verwenden',
  'avatar.useApi': 'API · BYOK verwenden',
  'avatar.codeAgent': 'Code-Agent',
  'avatar.rescan': 'PATH neu scannen',
  'avatar.amrConsole': 'AMR-Konto',
  'avatar.amrConsoleMeta': 'Guthaben & Aufladen',
  'avatar.settings': 'Einstellungen',
  'avatar.backToProjects': 'Zurück zu Projekten',
  'avatar.metaActive': 'aktiv',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'ausgewählt',
  'avatar.noAgentSelected': 'kein Agent ausgewählt',
  'avatar.modelSection': 'Modell',
  'avatar.modelLabel': 'Modell',
  'avatar.reasoningLabel': 'Reasoning',
  'avatar.customSuffix': '(benutzerdefiniert)',
  'socialShare.openDesignSection': 'Open Design teilen',
  'socialShare.openDesignTitle': 'Open Design auf GitHub',
  'socialShare.openDesignText': 'Open Design ist ein Open-Source-Workspace zum Erstellen, Bearbeiten, Bereitstellen und Übergeben von Design-Artefakten.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'IN SOZIALEN NETZWERKEN TEILEN',
  'socialShare.publishPageTitle': 'Teileseite veröffentlichen',
  'socialShare.publishPageSubtitle': 'Veröffentliche diese Vorschau, damit sie auf sozialen Plattformen geteilt werden kann.',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'Erstellt mit Open Design: {title}. Sieh dir das bereitgestellte Artefakt an und gib dem Repo einen Stern: {repo}',
  'socialShare.projectCopyText': 'Erstellt mit Open Design: {title}\n{url}\nOpen Design-Repo: {repo}',
  'socialShare.deployFirst': 'Erst deployen, dann teilen…',
  'socialShare.copied': 'Kopiert',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'CLI / Modell wechseln',
  'inlineSwitcher.chipCli': 'Lokales CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'Standard',
  'inlineSwitcher.noAgent': 'kein Agent',
  'inlineSwitcher.modeLabel': 'Modus',
  'inlineSwitcher.agentLabel': 'Agent',
  'inlineSwitcher.providerLabel': 'Anbieter',
  'inlineSwitcher.modelLabel': 'Modell',
  'inlineSwitcher.useCli': 'Lokales CLI verwenden',
  'inlineSwitcher.useByok': 'Eigenen API-Schlüssel verwenden',
  'inlineSwitcher.daemonOffline': 'Daemon offline — Einstellungen öffnen',
  'inlineSwitcher.noAgentsDetected': 'Kein CLI im PATH gefunden',
  'inlineSwitcher.openSettingsForModel': 'Anbieter in den Einstellungen konfigurieren',
  'inlineSwitcher.missingApiKey': 'API-Schlüssel fehlt — in den Einstellungen ergänzen.',
  'inlineSwitcher.openFullSettings': 'Ausführungseinstellungen öffnen',
  'inlineSwitcher.customSuffix': '(benutzerdefiniert)',
  'project.backToProjects': 'Zurück zu Projekten',
  'project.brandReadyTitle': 'Designsystem {name} ist bereit',
  'project.brandReadyTitleGeneric': 'Dein Designsystem ist bereit',
  'project.brandReadyCta': 'In Design-Systemen ansehen',
  'project.brandReadyDismiss': 'Schließen',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Designsystem-Vorschau geöffnet.',
  'project.metaFreeform': 'frei',
  'project.customInstructions': 'Projektanweisungen',
  'project.customInstructionsPlaceholder': 'Anweisungen für dieses Projekt (bei jeder Nachricht eingefügt)…',
  'project.resizeChatPanel': 'Größe des Chat-Bereichs ändern',
  'project.instructionsActive': 'Aktiv – in jeder Nachricht enthalten',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Chat',
  'chat.tabComments': 'Kommentare',
  'chat.commentsSoon': 'Kommentare — demnächst',
  'chat.comments.attached': 'An Chat angehängt',
  'chat.comments.emptyAttached': 'Keine Kommentare angehängt.',
  'chat.comments.saved': 'Gespeicherte Kommentare',
  'chat.comments.emptySaved': 'Keine gespeicherten Kommentare.',
  'chat.comments.add': 'Hinzufügen',
  'chat.comments.addAll': 'Alle hinzufügen',
  'chat.comments.remove': 'Entfernen',
  'chat.comments.placeholder': 'Dieses Element kommentieren…',
  'chat.comments.addSend': 'Hinzufügen & senden',
  'chat.comments.updateSend': 'Aktualisieren & senden',
  'chat.comments.removeAttachment': 'Kommentaranhang entfernen',
  'chat.comments.removeAttachmentAria': 'Kommentaranhang für {name} entfernen',
  'chat.comments.comment': 'Kommentar',
  'chat.comments.sendToChat': 'An Chat senden',
  'chat.comments.sending': 'Wird gesendet…',
  'chat.comments.edit': 'Bearbeiten',
  'chat.comments.select': 'Auswählen',
  'chat.comments.selectAll': 'Alle auswählen',
  'chat.comments.deselect': 'Abwählen',
  'chat.comments.nSelected': '{n} ausgewählt',
  'chat.comments.pin': 'Anheften',
  'chat.comments.addNote': 'Notiz hinzufügen',
  'chat.comments.savedToast': 'Kommentar gespeichert',
  'chat.comments.pinSavedToast': 'Pin gespeichert',
  'chat.comments.pinAtCoords': 'bei {x}, {y}',
  'chat.comments.capturedItems': '{n} erfasste Elemente',
  'chat.comments.clear': 'Löschen',
  'chat.comments.targetImage': 'Bild',
  'chat.comments.targetControl': 'Steuerelement',
  'chat.comments.targetLink': 'Link',
  'chat.comments.targetText': 'Text',
  'chat.comments.targetSection': 'Abschnitt',
  'chat.comments.targetPage': 'Seite',
  'chat.comments.targetArea': 'Bereich',
  'chat.annotationNotePlaceholder': 'Notiz für diese Markierung hinzufügen',
  'chat.annotationAttachImage': 'Bild anhängen',
  'chat.annotationAttachedImages': 'Angehängte Bilder',
  'chat.annotationAttachedRemove': 'Letztes Bild entfernen',
  'chat.annotationAddToInput': 'Zur Eingabe hinzufügen',
  'chat.annotationAddingToInput': 'Wird hinzugefügt...',
  'chat.annotationQueue': 'Warteschlange',
  'chat.annotationQueueing': 'Wird eingereiht...',
  'chat.annotationSending': 'Wird gesendet...',
  'chat.annotationSendDisabledReason': 'Eine Aufgabe wird gerade ausgeführt',
  'chat.annotationPreviewMissing': 'Vorschau konnte nicht erfasst werden. Bitte versuche es erneut.',
  'chat.annotationPreviewMissingInk': 'Vorschau konnte nicht erfasst werden. Versuche es erneut, um nicht nur die Tinte zu senden.',
  'chat.annotationSentWithoutScreenshot': 'Vorschau konnte nicht erfasst werden. Die Anmerkung wurde ohne Screenshot gesendet.',
  'chat.annotationTimeout': 'Zeitüberschreitung beim Senden der Annotation. Bitte versuche es erneut.',
  'chat.annotationFailed': 'Senden der Anmerkung fehlgeschlagen. Bitte versuche es erneut.',
  'chat.annotationProjectCreateFailed': 'Es konnte kein Projekt erstellt werden, daher wurde die Anmerkung nicht gesendet.',
  'chat.annotationUploadFailed': 'Hochladen des Anhangs fehlgeschlagen. Bitte versuche es erneut.',
  'chat.conversationsTitle': 'Konversationen',
  'chat.conversationsAria': 'Konversationsverlauf',
  'chat.newConversation': 'Neue Konversation',
  'chat.newConversationsTitle': 'Neue Konversation',
  'chat.conversationsHeading': 'Konversationen',
  'chat.new': 'Neu',
  'chat.emptyConversations': 'Noch keine Konversationen.',
  'chat.deleteConversation': 'Konversation löschen',
  'chat.renameConversationLabel': '„{title}“ umbenennen',
  'chat.deleteConversationConfirm': '„{title}“ löschen? Dadurch werden die Nachrichten entfernt.',
  'chat.untitledConversation': 'Konversation ohne Titel',
  'chat.forkedConversationTitle': '{title} Fork',
  'chat.forkConversationFailed': 'Diese Konversation konnte nicht geforkt werden.',
  'chat.startTitle': 'Konversation starten',
  'chat.startHint': 'Beschreiben Sie, was Sie generieren möchten, oder starten Sie mit einem dieser Beispiele:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so Open Design can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'Open Design needs browser assist to finish this brand extraction. Clear the page in the Browser tab, then confirm below.',
  'brandEnrichment.title': "KI-Optimierung",
  'brandEnrichment.body': "Open Design startet im Hintergrund eine tiefere Extraktion, wendet automatisch die passenden Design-System-Skills an und aktualisiert dieses System direkt. Das kann 10-20 Minuten dauern; du kannst weiterarbeiten.",
  'brandEnrichment.cta': "KI-Optimierung",
  'brandEnrichment.busy': "KI-Optimierung wird gestartet...",
  'brandExtractionTranscript.sourceDesignMd': 'Eingefügtes DESIGN.md',
  'brandExtractionTranscript.user': 'Extrahiere ein Designsystem aus {source}.',
  'brandExtractionTranscript.doneTitle': 'Die programmatische Extraktion für {name} ist abgeschlossen.',
  'brandExtractionTranscript.doneBody': 'Ich habe das Designsystem {designSystemId} aus {source} erstellt und registriert. Es kann jetzt in der Vorschau geöffnet und für neue Designs verwendet werden.',
  'brandExtractionTranscript.next': 'Als Nächstes kannst du AI Optimize für einen tieferen Extraktionslauf starten oder mit diesem System ein neues Design erstellen.',
  'chat.fillInputTitle': 'Klicken, um die Eingabe zu füllen',
  'chat.jumpToLatest': 'Zur neuesten springen',
  'chat.scrollToLatest': 'Zur neuesten scrollen',
  'chat.you': 'Sie',
  'chat.openFile': '{name} öffnen',
  'chat.copyPrompt': 'Prompt kopieren',
  'chat.copyErrorDiagnostic': 'Fehlerdiagnose kopieren',
  'chat.copyDone': 'Kopiert!',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.composerPlaceholder': 'Beschreiben Sie, was Sie generieren möchten…',
  'chat.activeFileEditingLabel': 'Bearbeiten',
  'chat.activeFilePlaceholder': 'Bitte Open Design, {file} zu ändern...',
  'chat.designArtifactsShowMore': '{count} weitere Designdateien anzeigen',
  'chat.mode.chat.label': 'Fragen',
  'chat.mode.chat.title': 'Ask-Modus',
  'chat.mode.chat.summary': 'Für schnelle Antworten, Überarbeitungen, Planung und Diskussion, ohne automatisch ein Design-Artefakt zu erstellen.',
  'chat.mode.chat.solves': 'Nutze ihn, um Ideen zu klären, Prompts zu verbessern, Optionen zu vergleichen oder bestehende Arbeit zu besprechen.',
  'chat.mode.chat.query1': 'Fasse diesen Entwurf zusammen und zeige Lücken auf.',
  'chat.mode.chat.query2': 'Hilf mir, die beste Struktur für diese Landingpage zu wählen.',
  'chat.mode.chat.query3': 'Prüfe dieses Design und schlage konkrete Verbesserungen vor.',
  'chat.mode.design.label': 'Design',
  'chat.mode.design.title': 'Design-Modus',
  'chat.mode.design.summary': 'Zum Erstellen oder Ändern konkreter Design-Ergebnisse wie Seiten, Prototypen, Live-Artefakte, Folien, Bilder, Videos, HyperFrames, Audio, Dashboards und Projektdateien.',
  'chat.mode.design.solves': 'Nutze ihn, wenn Open Design Dateien erzeugen, den Workspace aktualisieren oder ein Briefing in multimodale Ergebnisse verwandeln soll.',
  'chat.mode.design.query1': 'Erstelle aus diesem Briefing eine Produktlaunch-Landingpage und einen HyperFrames-Prototyp.',
  'chat.mode.design.query2': 'Erstelle ein Investoren-Deck mit 10 Folien und Sprechernotizen.',
  'chat.mode.design.query3': 'Entwickle Bild-, Video- und Audioideen für diese Kampagne.',
  'chat.mode.cardBestFor': 'Geeignet für',
  'chat.mode.cardTry': 'Beispielfragen',
  'chat.composerHint': '⌘/Ctrl + Enter zum Senden · Ziel, Inhalt, Stil und Format angeben',
  'chat.cliSettingsTitle': 'CLI- & Modelleinstellungen',
  'chat.cliSettingsAria': 'CLI- und Modelleinstellungen öffnen',
  'chat.attachTitle': 'Dateien anhängen (oder einfügen / ablegen)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Dateien anhängen',
  'chat.importTitle': 'Quellen importieren (demnächst)',
  'chat.importLabel': 'Importieren',
  'chat.importComingSoon': 'Demnächst',
  'chat.importSoon': 'Bald',
  'chat.importFig': '.fig-Datei hochladen',
  'chat.importGitHub': 'GitHub verbinden',
  'chat.importWeb': 'Webelement erfassen',
  'chat.importFolder': 'Code-Ordner verknüpfen',
  'chat.importSkills': 'Skills und Designsysteme',
  'chat.importProject': 'Auf anderes Projekt verweisen',
  'chat.importDesignSystemHeader': 'Designsystem auswählen',
  'chat.importDesignSystemBack': 'Zurück',
  'chat.importDesignSystemSearch': 'Designsysteme suchen…',
  'chat.importDesignSystemEmpty': 'Keine Designsysteme passen zu "{query}"',
  'chat.importDesignSystemNone': 'Keines — frei',
  'chat.importDesignSystemNoneSub': 'In dieser Runde an kein System binden',
  'chat.importDesignSystemActive': 'Aktiv',
  'chat.importDesignSystemSwitched': 'Designsystem zu {title} gewechselt',
  'chat.importDesignSystemFailed': 'Designsystem konnte nicht gewechselt werden. Bitte erneut versuchen.',
  'chat.importDesignSystemLoadFailed': 'Designsysteme konnten nicht geladen werden.',
  'browserUse.title': 'Inspiration',
  'browserUse.summary': '{count} Webaktionen, mit Priorität auf Asset-Extraktion, Designsprache, Motion, visuelle Prüfungen und Komponentenstruktur.',
  'browserUse.searchAria': 'Inspiration suchen',
  'browserUse.searchPlaceholder': 'Screenshots, Schriftarten, Farben, a11y durchsuchen ...',
  'browserUse.empty': 'Keine passende Inspiration',
  'browserUse.unavailable': 'Inspiration ist hier nicht verfügbar',
  'browserUse.added': 'Zum Composer hinzugefügt',
  'browserUse.category.assets': 'Asset-Extraktion',
  'browserUse.category.tokens': 'Designsprache',
  'browserUse.category.motion': 'Motion',
  'browserUse.category.visual': 'Visuelle Prüfungen',
  'browserUse.category.structure': 'Komponenten',
  'browserUse.category.project': 'Projektlauf',
  'browserUse.category.general': 'Allgemein',
  'browserUse.input.none': 'Keine Eingabe',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Optionaler Selektor',
  'browserUse.input.requirementSelector': 'Anforderung, optionaler Selektor',
  'browserUse.input.selectorOptional': 'Optionaler Selektor',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Selektor, scale=2',
  'browserUse.input.gridOverlay': '12 Spalten, max. 1200, Abstand 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, Domain oder Suchbegriffe',
  'browserUse.input.selector': 'Selektor',
  'browserUse.input.selectorText': 'Selektor und Text',
  'browserUse.input.scroll': 'Pixel, oben, unten oder Seite',
  'browserUse.input.terminalRun': 'Befehl, Timeout 120 s',
  'browserUse.input.command': 'Befehl',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Beste Logo-Kandidaten aus Header, Navigation, Klassennamen, Position, OG-Bild und Favicon-Fallback.',
  'browserUse.action.list_images.output': 'Alle img-, srcset-, source- und CSS-Hintergrundbilder mit Abmessungen und Alt-Text.',
  'browserUse.action.download_assets.output': 'Heruntergeladener Asset-Ordner plus _manifest.json mit Referer- und Cookie-Unterstützung.',
  'browserUse.action.extract_svgs.output': 'Inline-SVGs und verlinkte .svg-Dateien, gespeichert als einzelne SVG-Dateien.',
  'browserUse.action.optimize_svgs.output': 'Optimierte SVG-Dateien plus Komprimierungsrate.',
  'browserUse.action.extract_colors.output': 'Gewichtete Palette plus :root-CSS-Farbvariablen als palette.json und palette.html.',
  'browserUse.action.extract_fonts.output': 'Häufigste Schriftfamilien, Größen, Schriftstärken und @font-face-Regeln als typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Radius, Schatten, Abstände und CSS-Variablen als tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Typografische Skala für Überschrift, Fließtext und Schaltfläche mit Größe, Schriftstärke, Zeilenhöhe und Verhältnissen.',
  'browserUse.action.extract_buttons.output': 'Entduplizierte Schaltflächen-Stilbibliothek als buttons.html und buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Grid- und Flex-Container, Richtung, Abstände, Spalten und maximale Breiten als layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Responsive Media-Query-Breakpoints als breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'CSS-Verläufe als gradients.css, gradients.json und Vorschau-HTML.',
  'browserUse.action.extract_shadows.output': 'Box-Schatten, Text-Schatten und Drop-Schatten als shadows.json plus Vorschau.',
  'browserUse.action.extract_easings.output': 'Easing-Funktionen für Übergänge und Animationen als easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js und style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, Übergangs- und Transform-Regeln, erkannte Motion-Bibliotheken, motion.css und motion.json.',
  'browserUse.action.validate_view.output': 'Screenshot-Pfade plus strukturierte visuelle und Layout-Probleme.',
  'browserUse.action.audit_layout.output': 'Layout-Fehler einschließlich Überlauf, Begrenzungen, Überlappung und abgeschnittenem Text als audit.json.',
  'browserUse.action.audit_accessibility.output': 'a11y-Probleme mit Selektoren, Beschriftungen, Rollen, Fokus, Kontrast und Screenshots, wo sinnvoll.',
  'browserUse.action.responsive_screenshots.output': 'Screenshots für Mobil 390, Tablet 834 und Desktop 1440.',
  'browserUse.action.screenshot_full.output': 'Screenshot der gesamten Seite über den Viewport hinaus.',
  'browserUse.action.screenshot_element.output': 'Screenshot eines einzelnen Elements, standardmäßig in 2x.',
  'browserUse.action.screenshot_with_grid.output': 'Screenshot mit Layout-Raster-Überlagerung.',
  'browserUse.action.screenshot_dark_mode.output': 'Screenshot mit prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'Einseitiger Styleguide mit Farben, Typografieskala, Radius und Schatten.',
  'browserUse.action.extract_html.output': 'Sauberes, eigenständiges HTML ohne script, noscript oder Inline-Event-Attribute.',
  'browserUse.action.extract_component_inventory.output': 'Wiederkehrende Komponentenmuster, Selektoren, Anzahlen und Screenshots.',
  'browserUse.action.extract_copy.output': 'Überschriften, CTAs, Fließtext und Beschreibungen als copy.md und copy.json.',
  'browserUse.action.extract_nav.output': 'Hauptnavigation und Footer-Links als sitemap.md und nav.json.',
  'browserUse.action.extract_forms.output': 'Formularfelder, Beschriftungen, Validierungshinweise und Absende-Aktionen als forms.json.',
  'browserUse.action.run_project.output': 'Erkannte Dev-Server-URL, geöffnet im Browser-Tab.',
  'browserUse.action.detect_project.output': 'Framework, Paketmanager, Installationsbefehl, Dev-Befehl und Port.',
  'browserUse.action.page_info.output': 'URL, Titel, Beschreibung, OG-Bild, Theme-Farbe, Favicon und Viewport.',
  'browserUse.action.snapshot.output': 'Bis zu 120 sichtbare interaktive und Textelemente mit Tag, Beschriftung, href und Koordinaten.',
  'browserUse.action.navigate.output': 'Die Seite öffnen und page_info zurückgeben.',
  'browserUse.action.click.output': 'Auf das erste passende Element klicken, nachdem es in den sichtbaren Bereich gescrollt wurde.',
  'browserUse.action.type_text.output': 'Ein Eingabefeld ausfüllen und input- und change-Events auslösen.',
  'browserUse.action.scroll.output': 'Aktuelle und maximale Scroll-Position.',
  'browserUse.action.extract_og_metadata.output': 'Meta-Titel, Beschreibung, kanonische URL, OG-/Twitter-Cards, Social-Bild und Theme-Farbe.',
  'browserUse.action.terminal_run.output': 'stdout, stderr und Exit-Code.',
  'browserUse.action.terminal_run_background.output': 'ID des Hintergrund-Tasks und aktuelle Ausgabe.',
  'browserUse.action.terminal_read.output': 'Aktuelle geteilte Terminal-Ausgabe.',
  'chat.designToolbox.title': 'Design-Toolbox',
  'chat.designToolbox.tooltip': 'Design-Toolbox',
  'chat.designToolbox.aria': 'Design-Toolbox öffnen',
  'chat.designToolbox.searchPlaceholder': 'Skills / MCP / Plugins / Connectors / Designdateien durchsuchen...',
  'chat.designToolbox.searchAria': 'Ressourcen der Design-Toolbox durchsuchen',
  'chat.designToolbox.followupSection': 'Nachfassen',
  'chat.designToolbox.resourcesSection': 'Globale Ressourcen',
  'chat.designToolbox.selected': 'Ausgewählt',
  'chat.designToolbox.noResources': 'Keine Ressourcen für „{query}“ gefunden.',
  'chat.designToolbox.badge.video': 'Video',
  'chat.designToolbox.badge.image': 'Bild',
  'chat.designToolbox.badge.motion': 'Motion',
  'chat.designToolbox.badge.polish': 'Feinschliff',
  'chat.designToolbox.action.auto-match.title': 'Nächsten Schritt zuordnen',
  'chat.designToolbox.action.auto-match.badge': 'Zuordnen',
  'chat.designToolbox.action.auto-match.description': 'Zuerst die Geschmacks-Messlatte definieren, dann Skills, MCP, Plugins, Connectors und Dateien zuordnen.',
  'chat.designToolbox.action.motion.title': 'Animation / Motion hinzufügen',
  'chat.designToolbox.action.motion.badge': 'Motion',
  'chat.designToolbox.action.motion.description': 'Eingangs-, Scroll-, Zustandsübergangs- und Mikrointeraktions-Motion zum aktuellen HTML oder Seitenelement hinzufügen.',
  'chat.designToolbox.action.motion-polish.title': 'Motion verfeinern',
  'chat.designToolbox.action.motion-polish.badge': 'Timing',
  'chat.designToolbox.action.motion-polish.description': 'Timing, Easing, Performance und Reduced-Motion-Fallbacks für vorhandenes Motion überprüfen.',
  'chat.designToolbox.action.anti-ai-polish.title': 'KI-Anmutung entfernen',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Geschmack',
  'chat.designToolbox.action.anti-ai-polish.description': 'Vorlagen-Anmutung, KI-Verläufe, billige Karten-Stapel und vage Texte entfernen.',
  'chat.designToolbox.action.visual-polish.title': 'Design-Feinschliff / versandfertig',
  'chat.designToolbox.action.visual-polish.badge': 'Feinschliff',
  'chat.designToolbox.action.visual-polish.description': 'Visuelle Hierarchie, Typografie, Abstände, responsives Verhalten, Barrierefreiheit und Lieferqualität prüfen.',
  'chat.designToolbox.action.image-gen.title': 'Bilder / visuelle Referenzen generieren',
  'chat.designToolbox.action.image-gen.badge': 'Bild',
  'chat.designToolbox.action.image-gen.description': 'Abschnitts-Referenzen, Assets, Icons, Social-Bilder oder ein Moodboard für die aktuelle Seite generieren.',
  'chat.designToolbox.action.video-gen.title': 'Video / Motion-Skript generieren',
  'chat.designToolbox.action.video-gen.badge': 'Video',
  'chat.designToolbox.action.video-gen.description': 'Das Design in ein kurzes Video, ein Remotion- / Hyperframes-Storyboard oder einen generierungsbereiten Prompt verwandeln.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'MCP-Vorlage',
  'chat.designToolbox.kind.connector': 'Connector',
  'chat.designToolbox.kind.designFile': 'Designdatei',
  'chat.designToolbox.context.browser': 'Browser',
  'chat.designToolbox.context.designFiles': 'Designdateien',
  'chat.designToolbox.context.designSystem': 'Designsystem',
  'chat.designToolbox.context.folder': 'Ordner',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Seiten-Chat',
  'chat.designToolbox.context.liveArtifact': 'Live-Artefakt',
  'chat.designToolbox.context.file': 'Datei',
  'chat.designToolbox.prompt.contextGeneric': 'Aktuelles Ziel: die derzeit geöffnete HTML-/Designdatei bzw. das geöffnete Webelement.',
  'chat.designToolbox.prompt.contextSpecific': 'Aktuelles Ziel: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Bewahre die bereits im Composer vorhandene Absicht: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Ausgewählter Skill: {skill}. Verwende ihn als primären Workflow für diesen Schritt.',
  'chat.designToolbox.prompt.noSkill': 'Falls kein bestimmter Skill passt, wähle zuerst die beste Kombination aus verfügbaren Skills, MCP, Plugins, Connectors und Designdateien.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Agiere als Creative-Director-Orchestrator und schließe einen Design-Workflow ab:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Definiere zunächst, was „gutes Design“ bedeutet: Zielgruppe, Geschäftsziel, Markengefühl, Stilreferenzen, Informationsdichte, Standards für Farbe/Typografie/Motion/Assets sowie zu vermeidende AI-/Template-Muster.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Durchsuche und gleiche den vollständigen Ressourcenindex oben ab. Verlasse dich nicht nur auf die Empfehlungen der Design-Toolbox; kombiniere bei Bedarf Skills, MCP, Plugins, Connectors und Designdateien.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. Wenn das Ziel oder das ästhetische Anspruchsniveau noch unklar ist, leite mich mit begrenzten Auswahlmöglichkeiten oder einer formularartigen UI und gib eine empfohlene Standardoption an. Wenn es klar genug ist, führe den nächsten Schritt direkt aus.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Schließe den Ablauf in dieser Reihenfolge ab: Diagnose -> Stilrichtung -> Ressourcenauswahl -> konkrete Bearbeitung/Generierung -> Überprüfung. Erkläre bei jedem Schritt, warum diese Ressourcen gewählt wurden und was als Nächstes bestätigt werden muss.',
  'chat.designToolbox.prompt.motion': 'Füge dem aktuellen HTML-/Seitenelement hochwertige Bewegung hinzu: Wähle die nützlichsten 1-2 Momente für Eintritt, Scroll, Zustandsübergang oder Mikrointeraktion. Bleibe zurückhaltend, bevorzuge transform/opacity und füge prefers-reduced-motion-Fallbacks hinzu.',
  'chat.designToolbox.prompt.motionPolish': 'Überprüfe und optimiere Timing, Easing, Performance und Barrierefreiheit vorhandener Bewegung. Entferne abrupte, billige oder die Lesbarkeit beeinträchtigende Animationen; verwende bei Bedarf eine verfeinerte Timeline.',
  'chat.designToolbox.prompt.antiAiPolish': 'Führe einen Durchgang zur Beseitigung des KI-Eindrucks durch: Entferne schablonenhafte Layouts, billige Verläufe/Glow-Effekte, sinnlose Card-Stapel und vage Texte. Bewahre die Informationen und lass es wirken, als hätte es ein echter Designer geliefert.',
  'chat.designToolbox.prompt.visualPolish': 'Optimiere dieses Design, bis es auslieferbereit ist: Prüfe Hierarchie, Typografie, Abstände, responsives Verhalten, Button-Zustände, Leer-/Lade-/Fehlerzustände und Barrierefreiheit; behebe die wichtigsten Probleme direkt.',
  'chat.designToolbox.prompt.imageGen': 'Erstelle den nächsten Plan für visuelle Assets für dieses Design: Section-Referenzen, Hero-Assets, Illustrationen, Icons, Social-Images oder ein Moodboard. Entscheide zuerst, welche Art von Bild fehlt, und liefere dann ausführbare Generierungs-Prompts / einen Dateiplan.',
  'chat.designToolbox.prompt.videoGen': 'Richte dieses Design auf Video aus: Erstelle ein Kurzvideo-Storyboard, eine HyperFrames-/Remotion-Frame-Struktur oder einen Sora-/fal-fertigen Prompt. Bevorzuge es, vorhandene HTML-/Seiteninhalte auf natürliche Weise zu Shots werden zu lassen.',
  'chat.designToolbox.prompt.useSkill': 'Verwende {skill} im aktuellen Design.',
  'chat.designToolbox.prompt.skillInstruction': 'Entscheide zuerst das beste Folgeziel und schließe dann einen konkreten Durchgang ab. Wenn es von externen Assets oder APIs abhängt, liefere einen lauffähigen Fallback oder gib an, was ich bereitstellen muss.',
  'chat.designToolbox.prompt.selectedResource': 'Ausgewählte Ressource: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Ressourcenbeschreibung: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Verwende dieses Plugin als Hauptkontext für den aktuellen Design-Flow. Wenn es Eingaben oder GenUI bereitstellt, leite mich bei Bedarf zur Auswahl an; wenn es nicht zum Ziel passt, wähle eine bessere globale Ressource und erkläre, warum.',
  'chat.designToolbox.prompt.mcpResource': 'Bevorzuge diese MCP-Fähigkeit für den nächsten Design-Schritt. Wenn externe Assets, Web-Capture, Bild-/Videogenerierung oder Daten benötigt werden, entscheide zuerst, ob sie die Aufgabe erfüllen kann, und gib dann einen ausführbaren Plan an.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'Dieses MCP ist eine konfigurierbare Vorlage. Wenn es das nützlichste Werkzeug für diesen Design-Schritt ist, leite zuerst die Einrichtung an; wenn eine konfigurierte Alternative existiert, fahre mit dieser Alternative fort.',
  'chat.designToolbox.prompt.connectorResource': 'Verwende diesen Connector, wenn echte Daten, Assets, Kontoinhalte oder Zugriff auf externe Workflows benötigt werden. Erkläre vor der Verwendung, was gelesen oder geschrieben wird, und bitte gegebenenfalls um Bestätigung.',
  'chat.designToolbox.prompt.fileResource': 'Verwende diese Designdatei als aktuelles Designziel oder Referenz-Asset und führe den nächsten Schritt davon ausgehend aus. Wenn andere Dateien verglichen werden müssen, suche weiter über alle Designdateien hinweg.',
  'chat.designToolbox.prompt.resourceIndex': 'Globaler Ressourcenindex: Skills({skills}), Plugins({plugins}), MCP({mcpEnabled} aktiviert / {mcpTemplates} Vorlagen), Connectors({connectors} verbunden), Designdateien({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Durchsuchbare Skills',
  'chat.designToolbox.prompt.searchablePlugins': 'Durchsuchbare Plugins',
  'chat.designToolbox.prompt.availableMcp': 'Verfügbare MCP',
  'chat.designToolbox.prompt.connectedConnectors': 'Verbundene Connectors',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Referenz-Designdateien',
  'chat.designToolbox.prompt.mcpTemplateName': '{name}-Vorlage',
  'chat.designToolbox.prompt.processRule': 'Workflow-Regel: Definiere zuerst das ästhetische Ziel und die Einschränkungen, suche und gleiche dann Ressourcen ab; wenn eine Nutzerauswahl erforderlich ist, erzeuge eine UI mit begrenzten Auswahlmöglichkeiten und fahre nach der Bestätigung fort.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} weitere',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Erwähnungsflächen',
  'chat.mentionTabAll': 'Alle',
  'chat.mentionTabTabs': 'Tabs',
  'chat.mentionTabPlugins': 'Plugins',
  'chat.mentionTabSkills': 'Skills',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Connectors',
  'chat.mentionTabFiles': 'Designdateien',
  'chat.mentionNoResults': 'Keine Ergebnisse für „{query}“.',
  'chat.mentionSearchPrompt': 'Durchsuche Designdateien, Tabs, Plugins, Skills, MCP-Server und Connectors.',
  'chat.mentionSectionTabs': 'Tabs',
  'chat.mentionSectionPlugins': 'Plugins',
  'chat.mentionSectionSkills': 'Skills',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Connectors',
  'chat.mentionSectionFiles': 'Designdateien',
  'chat.mentionActiveSkill': 'Aktiv',
  'chat.mentionUseMcpTitle': '{name} verwenden',
  'chat.mentionUseConnectorTitle': '{name} verwenden',
  'chat.mentionPluginOfficial': 'Offiziell',
  'chat.mentionPluginMine': 'Mein Plugin',
  'chat.linkedFolderRemoveAria': 'Verknüpften Ordner {path} entfernen',
  'chat.linkedFolderNotFound': 'Ordner existiert nicht',
  'chat.linkedFolderAlready': 'Dieser Ordner ist bereits verknüpft',
  'chat.linkedFolderPickError': 'Ordnerauswahl konnte nicht geöffnet werden',
  'chat.queuedHeader': 'In Warteschlange',
  'chat.queuedToSend': 'zum Senden',
  'chat.queuedEditQueuedTaskAria': 'Aufgabe in Warteschlange bearbeiten',
  'chat.queuedSave': 'Speichern',
  'chat.queuedCancel': 'Abbrechen',
  'chat.queuedReorder': 'Zum Neuordnen ziehen',
  'chat.queuedEdit': 'Bearbeiten',
  'chat.queuedMore': 'weitere in Warteschlange',
  'chat.queuedFollowUpFallback': 'Folgeaufgabe in Warteschlange',
  'chat.send': 'Senden',
  'chat.stop': 'Stoppen',
  'chat.removeAria': '{name} entfernen',
  'chat.example1Title': 'Editorial Pitch Deck',
  'chat.example1Tag': 'Magazin',
  'chat.example1Prompt': 'Ein 10-Slide-Editorial-Pitch-Deck für ein Designstudio, das eine Seed-Runde aufnimmt — Swiss-Grid-Layout, übergroße Serif-Headlines mit markanten Initialen, Monospace-Abschnittsnummern, großzügiger Negativraum und Full-Bleed-Fotoslides im Wechsel mit textlastigen Slides. Cover, Vision, Markt, Produkt, Traction, Team, Ask, Kontakt.',
  'chat.example2Title': 'SaaS-Analytics-Dashboard',
  'chat.example2Tag': 'Daten',
  'chat.example2Prompt': 'Ein dichtes Analytics-Dashboard für ein Developer-Tools-SaaS — KPI-Leiste mit Week-over-Week-Deltas, zwei gestapelte Liniendiagramme (MRR und aktive Workspaces), eine Welt-Heatmap der Nutzung, ein Kohorten-Retention-Raster, eine Top-Customers-Bestenliste und ein Echtzeit-Event-Feed. Dark Theme, tabellarische Monospace-Ziffern, Sparkline-Akzente.',
  'chat.example3Title': 'Annual Report Long-Scroll',
  'chat.example3Tag': 'Redaktionell',
  'chat.example3Prompt': 'Ein interaktiver Annual Report für eine Klima-Non-Profit-Organisation — Long-Scroll-Editorial-Layout mit großen Pull-Quote-Blöcken, Datenvisualisierungen (gestapelte Balken, animierte Counter, Choropleth-Karte der Projektstandorte), Fotobrechern, Spenderwand und finalem Call-to-Action. Moderne Serifenschrift für Body, Sans-Serif-Chartlabels, erdige Papierpalette.',
  'preview.usePlugin': 'Plugin verwenden',
  'preview.usePluginOnly': 'Nur Plugin verwenden',
  'preview.usePluginOnlyDesc': 'Die Plugin-Struktur nutzen und den Inhalt selbst schreiben',
  'preview.replicateContent': 'Diesen Inhalt nachbilden',
  'preview.replicateContentDesc': 'Mit dem Beispiel-Prompt die Vorschau nachbilden',
  'preview.duplicateTemplate': 'Duplizieren',
  'preview.duplicateTemplateDesc': 'Kopiert dieses Beispiel in ein neues bearbeitbares Projekt',
  'preview.shareMenu': 'Teilen',
  'preview.exportMenu': 'Exportieren',
  'preview.shareTemplateBadge': 'Vorlage',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Vorlagenlink kopieren',
  'preview.copyShareText': 'Freigabetext kopieren',
  'preview.shareSocialGroup': 'In sozialen Medien teilen',
  'preview.shareCopyGroup': 'Kopieren',
  'preview.shareExportGroup': 'Dateien exportieren',
  'preview.shareCopied': 'Kopiert',
  'preview.shareCopyFailed': 'Kopieren fehlgeschlagen',
  'preview.shareTextDefault': 'Open Design-Vorlage: {title}',
  'preview.openInNewTab': 'In neuem Tab öffnen',
  'preview.exit': '⤓ Beenden',
  'preview.fullscreen': '⤢ Vollbild',
  'preview.closeTitle': 'Schließen (Esc)',
  'preview.loading': '{label} wird geladen…',
  'preview.errorTitle': 'Beispiel konnte nicht geladen werden.',
  'preview.errorBody': 'Das Beispiel-HTML konnte nicht abgerufen werden. Stelle sicher, dass Open Design läuft, und versuche es erneut.',
  'preview.retry': 'Erneut versuchen',
  'preview.unavailableTitle': 'Für {noun} ist keine Vorschau verfügbar.',
  'preview.unavailableBody': 'Führe den Prompt im Chat aus, um {kind}-Output zu erzeugen.',
  'preview.nounSkill': 'diesen Skill',
  'preview.nounPlugin': 'dieses Plugin',
  'preview.nounTemplate': 'diese Vorlage',
  'preview.showSidebar': '{label} einblenden',
  'preview.hideSidebar': '{label} ausblenden',
  'misc.savedTemplate': 'Gespeichertes Template',
  'misc.primary': 'Primär',
  'misc.designSystem': 'Designsystem',
  'workspace.designFiles': 'Design-Dateien',
  'workspace.focusMode': 'Arbeitsbereich fokussieren',
  'workspace.showChat': 'Chat anzeigen',
  'workspace.closeTab': 'Tab schließen',
  'workspace.deleteFileConfirm': '„{name}“ aus dem Projektordner löschen?',
  'workspace.deleteSelectedFilesConfirm': '{n} ausgewählte Datei(en) aus dem Projektordner löschen?',
  'workspace.deleteSelectedFilesPartial': '{n} Datei(en) konnten nicht gelöscht werden.',
  'workspace.openFromDesignFiles': 'Datei öffnen aus',
  'workspace.designFilesLink': 'Design-Dateien',
  'workspace.loadingSketch': 'Sketch wird geladen…',
  'workspace.newTab': 'Neuer Tab',
  'workspace.searchFilesPlaceholder': 'Dateien suchen…',
  'workspace.openTabs': 'Tabs öffnen',
  'workspace.openFile': 'Datei öffnen',
  'workspace.noFilesMatch': 'Keine passenden Dateien',
  'workspace.allFiles': 'Alle',
  'workspace.createNew': 'Neu erstellen',
  'workspace.tabOpen': 'Geöffnet',
  'workspace.sideChatContextBanner': 'Kontext der aktuellen Unterhaltung übernommen',
  'workspace.sideChatDefaultTitle': 'Seiten-Chat',
  'workspace.newTerminal': 'Neues Terminal',
  'workspace.newTerminalDescription': 'Eine Shell im Projektverzeichnis in einem neuen Tab öffnen',
  'workspace.newBrowser': 'Neuer Browser',
  'workspace.newBrowserDescription': 'Einen integrierten Browser-Tab für Referenzseiten und Browser-Aufgaben öffnen',
  'workspace.terminalStarting': 'Terminal wird gestartet…',
  'workspace.terminalStartingDescription': 'Projektshell wird vorbereitet. Das dauert normalerweise nur ein paar Sekunden.',
  'workspace.terminalSessionEnded': 'Sitzung beendet',
  'workspace.terminalReconnecting': 'Verbindung wird wiederhergestellt…',
  'workspace.terminalStartFailed': 'Terminalsitzung konnte nicht gestartet werden',
  'workspace.terminalRestart': 'Neu starten',
  'designFiles.title': 'Design-Dateien',
  'designFiles.upload': 'Dateien hochladen',
  'designFiles.pasteText': 'Als Textdatei einfügen',
  'designFiles.newSketch': 'Neuer Sketch',
  'designFiles.empty': 'Kreationen erscheinen hier',
  'designFiles.refresh': 'Aktualisieren',
  'designFiles.delete': 'Löschen',
  'designFiles.searchPlaceholder': 'Dateien suchen…',
  'designFiles.up': 'Nach oben',
  'designFiles.back': 'Zurück',
  'designFiles.crumbs': 'Projekt',
  'designFiles.rowMenu': 'Zeilenmenü',
  'designFiles.openInTab': 'In Tab öffnen',
  'designFiles.download': 'Herunterladen',
  'designFiles.downloadSelected': '{n} als ZIP herunterladen',
  'designFiles.deleteSelected': '{n} löschen',
  'designFiles.clearSelection': 'Auswahl aufheben',
  'designFiles.selectPage': 'Alle auf dieser Seite auswählen',
  'designFiles.selectAll': 'Alle auswählen',
  'designFiles.dropTitle': '⤓ Dateien hier ablegen',
  'designFiles.dropDesc': 'Bilder, Docs, Referenzen oder Ordner — der Agent nutzt sie als Kontext.',
  'designFiles.dropLabel': 'Dateien hier ablegen',
  'designFiles.upload.title': 'Dateien hochladen',
  'designFiles.paste.title': 'Text als Datei einfügen',
  'designFiles.upload.label': 'Hochladen',
  'designFiles.paste.label': 'Einfügen',
  'designFiles.previewOpen': 'Öffnen',
  'designFiles.previewClose': 'Vorschau schließen',
  'designFiles.modified': 'Geändert {time} · {size}',
  'designFiles.weeksAgo': 'vor {n} W.',
  'designFiles.groupBy': 'Gruppieren nach',
  'designFiles.groupByKind': 'Typ',
  'designFiles.groupByModified': 'Geändert',
  'designFiles.filterBy': 'Nach Typ filtern',
  'designFiles.filterClear': 'Löschen',
  'designFiles.filterCount': '{n} Typen',
  'designFiles.expandGroup': 'Erweitern',
  'designFiles.collapseGroup': 'Einklappen',
  'designFiles.sectionPages': 'Seiten',
  'designFiles.sectionScripts': 'Skripte',
  'designFiles.sectionImages': 'Bilder',
  'designFiles.sectionSketches': 'Skizzen',
  'designFiles.sectionLiveArtifacts': 'Live-Artefakte',
  'designFiles.sectionOther': 'Andere',
  'designFiles.modifiedToday': 'Heute',
  'designFiles.modifiedYesterday': 'Gestern',
  'designFiles.modifiedPrevious7Days': 'Letzte 7 Tage',
  'designFiles.modifiedPrevious30Days': 'Letzte 30 Tage',
  'designFiles.modifiedOlder': 'Älter',
  'designFiles.showMore': '+{n} weitere anzeigen',
  'designFiles.kindHtml': 'HTML-Seite',
  'designFiles.kindImage': 'Bild',
  'designFiles.kindSketch': 'Skizze',
  'designFiles.kindText': 'Text',
  'designFiles.kindCode': 'Skript',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Dokument',
  'designFiles.kindPresentation': 'Präsentation',
  'designFiles.kindSpreadsheet': 'Tabellenblatt',
  'designFiles.kindLiveArtifact': 'Live-Artefakt',
  'designFiles.kindBinary': 'Binärdatei',
  'designFiles.kindFolder': 'Ordner',
  'designFiles.folderCount': '{n} Dateien',
  'designFiles.newFolderTitle': 'Neuer Ordner',
  'designFiles.newFolderLabel': 'Ordnername',
  'designFiles.moveTitle': 'In Ordner verschieben',
  'designFiles.moveLabel': 'Zielordner',
  'designFiles.moveRoot': 'Projektstamm',
  'designFiles.moveNewFolder': 'Neuer Ordner…',
  'designFiles.move': 'Verschieben',
  'designFiles.copyPath': 'Pfad kopieren',
  'designFiles.copiedPath': 'Pfad kopiert',
  'designFiles.deleteFolderConfirm': 'Ordner „{name}“ und seinen gesamten Inhalt löschen?',
  'designFiles.folderCreated': 'Ordner „{name}“ erstellt',
  'designFiles.folderDeleted': 'Ordner „{name}“ gelöscht',
  'designFiles.filesMoved': '{n} nach {dest} verschoben',
  'designFiles.colName': 'Name',
  'designFiles.colKind': 'Art',
  'designFiles.colModified': 'Geändert',
  'designFiles.perPage': 'Anzeigen',
  'designFiles.all': 'Alle',
  'designFiles.prev': 'Zurück',
  'designFiles.next': 'Weiter',
  'designFiles.jumpToPage': 'Gehe zu Seite',
  'designFiles.pageInfo': '{start}–{end} von {total}',
  'designFiles.sectionFolders': 'Ordner',
  'designFiles.sectionStylesheets': 'Stylesheets',
  'designFiles.sectionDocuments': 'Dokumente',
  'designFiles.kindStylesheet': 'Stylesheet',
  'designFiles.modifiedExt': 'Geändert {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Nützliche Infos',
  'designFiles.usefulInfoTip': 'Doppelklicken Sie auf eine beliebige Datei, um sie in einem vollständigen Tab zu öffnen.',
  'designFiles.usefulInfoTip2': 'Tippe @ im Chat, um eine Datei als Kontext zu referenzieren.',
  'designFiles.usefulInfoTip4': 'Wähle ein Designsystem, damit Ergebnisse zur Marke passen.',
  'designFiles.usefulInfoTip5': 'Keine Idee? Probiere eine Plugin-Vorlage aus der Community auf der Startseite.',
  'designFiles.usefulInfoTip6': 'Fragen oder Feedback? Komm zu uns auf Discord.',
  'designFiles.usefulInfoTip7': 'Gefällt dir Open Design? Gib uns einen Stern auf GitHub.',
  'designFiles.usefulInfoTip8': 'Folge @OpenDesignHQ auf X für Neuigkeiten.',
  'designFiles.usefulInfoTip9': 'Ziehe Bilder, Dokumente oder ganze Ordner in dieses Panel — der Agent nutzt sie als Kontext.',
  'designFiles.usefulInfoTip10': 'Klicke auf „Neue Skizze“ und zeichne ein Layout — der Agent setzt es um.',
  'designFiles.usefulInfoTip11': 'Wähle ein Element in der Vorschau aus und kommentiere es — der Agent ändert gezielt.',
  'designFiles.usefulInfoTip12': 'Mit dem Ergebnis unzufrieden? Markieren ist schneller als neu beschreiben.',
  'designFiles.usefulInfoTip13': 'Designs lassen sich mit einem Klick als PDF, Bild oder eigenständiges HTML exportieren.',
  'designFiles.usefulInfoTip14': 'Zufrieden mit einem Projekt? Speichere es über das Teilen-Menü als Vorlage.',
  'designFiles.usefulInfoTip15': 'Nach dem Deployment kannst du direkt Social-Media-Karten erstellen.',
  'quickSwitcher.placeholder': 'Datei öffnen…',
  'quickSwitcher.empty': 'Keine Dateien in diesem Projekt',
  'quickSwitcher.noMatches': 'Keine Treffer',
  'quickSwitcher.navigate': 'navigieren',
  'quickSwitcher.open': 'öffnen',
  'quickSwitcher.close': 'schließen',
  'pasteDialog.title': 'Text einfügen',
  'pasteDialog.hint': 'Wird im Projektordner gespeichert. Wählen Sie einen beliebigen Namen.',
  'pasteDialog.fileNameLabel': 'Dateiname',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'Inhalt',
  'pasteDialog.contentPlaceholder': 'Beliebigen Text einfügen…',
  'pasteDialog.save': 'Speichern',
  'pasteDialog.cancel': 'Abbrechen',
  'sketch.save': 'Sketch speichern',
  'sketch.cancel': 'Abbrechen',
  'sketch.saving': 'Speichern…',
  'sketch.saved': 'Gespeichert',
  'sketch.tooltipDirty': 'Ungespeicherte Änderungen',
  'sketch.tooltipClean': 'Gespeichert',
  'fileViewer.empty': 'Wählen Sie eine Datei zur Ansicht aus.',
  'fileViewer.loading': 'Wird geladen…',
  'fileViewer.exportPptx': 'Als PPTX exportieren',
  'fileViewer.openInNewTab': 'In neuem Tab öffnen',
  'fileViewer.copyPath': 'Pfad kopieren',
  'fileViewer.copied': 'Kopiert!',
  'fileViewer.share': 'Teilen',
  'fileViewer.binaryMeta': 'Binärdatei · {size}',
  'fileViewer.binaryNote': 'Binärdatei ({size} Bytes). Laden Sie sie herunter oder öffnen Sie sie von der Festplatte, um sie zu prüfen.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Dokument',
  'fileViewer.presentationMeta': 'Präsentation',
  'fileViewer.spreadsheetMeta': 'Tabellenblatt',
  'fileViewer.previewUnavailable': 'Vorschau nicht verfügbar. Laden Sie die Datei herunter oder öffnen Sie sie zur Prüfung.',
  'fileViewer.download': 'Herunterladen',
  'fileViewer.open': 'Öffnen',
  'fileViewer.imageMeta': 'Bild · {size}',
  'fileViewer.reactMeta': 'React-Komponente · {size}',
  'fileViewer.sketchMeta': 'Skizze · {size}',
  'fileViewer.markdownStreamingMeta': 'Streaming-Vorschau…',
  'fileViewer.markdownErrorMeta': 'Vorschau ist möglicherweise unvollständig (Generierungsfehler).',
  'fileViewer.markdownStreamingStatus': 'Streaming… zeige partielles Markdown.',
  'fileViewer.markdownErrorStatus': 'Generierungsfehler. Zeige letzten verfügbaren Inhalt.',
  'fileViewer.videoMeta': 'Video · {size}',
  'fileViewer.audioMeta': 'Audio · {size}',
  'fileViewer.reload': 'Neu laden',
  'fileViewer.reloadDisk': 'Von Festplatte neu laden',
  'fileViewer.copy': 'Kopieren',
  'fileViewer.copyTitle': 'Dateiinhalte kopieren',
  'fileViewer.saveDisabled': 'Speichern (Read-only-Viewer)',
  'fileViewer.save': 'Speichern',
  'fileViewer.preview': 'Vorschau',
  'fileViewer.source': 'Quelle',
  'fileViewer.tweaks': 'Feinabstimmungen',
  'fileViewer.tweaksUnavailable': 'Kein Tweaks-Panel in diesem Artefakt',
  'fileViewer.jsxModuleTitle': 'Keine eigenständige Vorschau',
  'fileViewer.jsxModuleBody': 'Diese Datei ist ein Komponentenmodul, das von einer anderen Seite geladen wird.',
  'fileViewer.jsxModuleCta': 'Öffne die Seite, die es rendert:',
  'fileViewer.comment': 'Kommentieren',
  'fileViewer.edit': 'Bearbeiten',
  'fileViewer.draw': 'Zeichnen',
  'fileViewer.mark': 'Markieren',
  'fileViewer.markTool': 'Markierungswerkzeug',
  'fileViewer.boxSelect': 'Bereich auswählen',
  'fileViewer.screenshot': 'Screenshot',
  'manualEdit.layers': 'Ebenen',
  'manualEdit.editableCount': '{count} bearbeitbar',
  'manualEdit.hiddenBadge': 'Ausgeblendet',
  'manualEdit.title': 'Manueller Editor',
  'manualEdit.fallbackTitle': 'Bearbeiten',
  'manualEdit.movePanel': 'Bearbeitungsfenster verschieben',
  'manualEdit.editParams': 'Parameter bearbeiten',
  'manualEdit.closePanel': 'Bearbeitungsfenster schließen',
  'manualEdit.selectLayer': 'Ebene auswählen',
  'manualEdit.empty': 'Klicken Sie auf ein Element in der Vorschau oder wählen Sie eine Ebene aus.',
  'manualEdit.noEditableLayers': 'Keine bearbeitbaren Ebenen gefunden.',
  'manualEdit.noClass': 'keine Klasse',
  'manualEdit.tabsAria': 'Tabs für manuelle Bearbeitung',
  'manualEdit.tabContent': 'Inhalt',
  'manualEdit.tabStyle': 'Stil',
  'manualEdit.tabAttributes': 'Attribute',
  'manualEdit.tabHtml': 'HTML',
  'manualEdit.tabSource': 'Quelle',
  'manualEdit.attributesJson': 'Attribute JSON',
  'manualEdit.selectedHtml': 'HTML des ausgewählten Elements',
  'manualEdit.fullSource': 'Vollständiger Artefaktquellcode',
  'manualEdit.applyContent': 'Inhalt übernehmen',
  'manualEdit.applyStyle': 'Stil übernehmen',
  'manualEdit.applyAttributes': 'Attribute übernehmen',
  'manualEdit.applyHtml': 'HTML übernehmen',
  'manualEdit.applySource': 'Quelle übernehmen',
  'manualEdit.invalidAttributes': 'Ungültiges Attribute-JSON.',
  'manualEdit.changes': 'Änderungen',
  'manualEdit.undo': 'Rückgängig',
  'manualEdit.redo': 'Wiederholen',
  'manualEdit.noChanges': 'Noch keine manuellen Bearbeitungen.',
  'manualEdit.imageUrl': 'Bild-URL',
  'manualEdit.altText': 'Alternativtext',
  'manualEdit.label': 'Beschriftung',
  'manualEdit.text': 'Text',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Textfarbe',
  'manualEdit.background': 'Hintergrund',
  'manualEdit.fontSize': 'Schriftgröße',
  'manualEdit.weight': 'Stärke',
  'manualEdit.align': 'Ausrichtung',
  'manualEdit.padding': 'Innenabstand',
  'manualEdit.margin': 'Außenabstand',
  'manualEdit.radius': 'Radius',
  'manualEdit.border': 'Rahmen',
  'manualEdit.width': 'Breite',
  'manualEdit.minHeight': 'Mindesthöhe',
  'manualEdit.deleteElement': 'Element löschen',
  'manualEdit.deleteElementConfirm': 'Ausgewähltes Element löschen? Dies kann mit Rückgängig widerrufen werden.',
  'manualEdit.uploadImage': 'Bild hochladen',
  'manualEdit.uploadingImage': 'Bild wird hochgeladen…',
  'manualEdit.uploadImageFailed': 'Bild konnte nicht hochgeladen werden.',
  'manualEdit.focusSlides': 'Folien fokussieren',
  'manualEdit.showPanels': 'Bereiche anzeigen',
  'fileViewer.zoomOut': 'Verkleinern',
  'fileViewer.zoomIn': 'Vergrößern',
  'fileViewer.resetZoom': 'Zoom zurücksetzen',
  'fileViewer.viewportAria': 'Vorschau-Viewport',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Desktop-Vorschau in voller Breite',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Tablet-Vorschau mit 820 × 1180 (moderne Hochformat-Baseline)',
  'fileViewer.viewportMobile': 'Mobil',
  'fileViewer.viewportMobileTitle': 'Mobil-Vorschau mit 390 × 844',
  'fileViewer.reloadAria': 'Neu laden',
  'fileViewer.previousSlide': 'Vorherige Slide',
  'fileViewer.nextSlide': 'Nächste Slide',
  'fileViewer.slideNavAria': 'Slide-Navigation',
  'fileViewer.present': 'Präsentieren',
  'fileViewer.presentInTab': 'In diesem Tab',
  'fileViewer.presentFullscreen': 'Vollbild',
  'fileViewer.presentNewTab': 'Neuer Tab',
  'fileViewer.exitPresentation': 'Präsentation beenden',
  'fileViewer.shareLabel': 'Teilen',
  'fileViewer.shareMenuShareLink': 'TEILEN',
  'fileViewer.shareMenuPublishOnline': 'ONLINE VERÖFFENTLICHEN',
  'fileViewer.shareMenuDownload': 'HERUNTERLADEN',
  'fileViewer.shareMenuPresentation': 'Präsentation',
  'fileViewer.shareMenuSourceFiles': 'Quelldateien',
  'fileViewer.shareMenuSave': 'SPEICHERN',
  'fileViewer.copyShareLink': 'Teillink kopieren',
  'fileViewer.openSharePage': 'Teileseite öffnen',
  'fileViewer.shareLinkRequiresDeploy': 'Erst online veröffentlichen, um einen Link zu erhalten',
  'fileViewer.shareLinkPublishGuide': 'Oben online veröffentlichen, um Teilen zu aktivieren ↑',
  'fileViewer.shareAfterGenerationComplete': 'Teilen nach Abschluss der Generierung',
  'fileViewer.copyProviderLink': '{provider}-Link kopieren',
  'fileViewer.copyCloudflareLink': 'Cloudflare-Link kopieren',
  'fileViewer.screenshotCopying': 'Screenshot wird kopiert ...',
  'fileViewer.screenshotCopied': 'Screenshot in die Zwischenablage kopiert',
  'fileViewer.screenshotClipboardDenied': 'Der Browser hat den Zugriff auf die Zwischenablage blockiert',
  'fileViewer.screenshotPreviewLoading': 'Die Vorschau wird noch geladen. Versuche es gleich erneut.',
  'fileViewer.screenshotCaptureFailed': 'Die Vorschau konnte nicht erfasst werden. Bitte versuche es erneut.',
  'fileViewer.exportPdf': 'Als PDF exportieren',
  'fileViewer.exportPdfAllSlides': 'Als PDF exportieren (alle Slides)',
  'fileViewer.exportPptxBusy': 'Warten Sie, bis der aktuelle Turn abgeschlossen ist.',
  'fileViewer.exportPptxHint': 'Senden Sie eine Anfrage an den Agent, um dieses Design in PPTX umzuwandeln.',
  'fileViewer.exportPptxNa': 'PPTX-Export ist hier nicht verfügbar.',
  'fileViewer.exportZip': 'Als .zip herunterladen',
  'fileViewer.exportHtml': 'Als eigenständiges HTML exportieren',
  'fileViewer.exportMd': 'Als Markdown exportieren',
  'fileViewer.exportImage': 'Als Bild exportieren',
  'fileViewer.exportPptxImages': 'Als PPTX (Bilder) exportieren',
  'fileViewer.exportPptxEditable': 'Als PPTX (bearbeitbar) exportieren',
  'fileViewer.exportingProgress': 'Exportieren…',
  'fileViewer.exportSlideProgress': 'Folie {current}/{total} wird exportiert…',
  'fileViewer.exportingElapsed': 'Exportieren… {seconds}s',
  'fileViewer.exportSlideEta': 'Folie {current}/{total} · noch ca. {seconds}s',
  'fileViewer.exportFailed': 'Export fehlgeschlagen. Bitte erneut versuchen.',
  'fileViewer.exportDone': 'Export abgeschlossen',
  'fileViewer.exportImageFailed': 'Bildaufnahme fehlgeschlagen. Bitte versuchen Sie es erneut oder verwenden Sie das Screenshot-Tool Ihres Browsers.',
  'fileViewer.exportImageModalSubtitle': 'Wählen Sie ein Format und laden Sie dann die aktuelle Vorschau als Bild herunter.',
  'fileViewer.exportImageFormatLabel': 'Format',
  'fileViewer.exportImageSaving': 'Bild wird gespeichert…',
  'fileViewer.exportImageSaved': 'Bild gespeichert',
  'fileViewer.exportImageDownloadStarted': 'Download gestartet',
  'fileViewer.exportImageDownloadDetails': '{filename} befindet sich in den Browser-Downloads, falls kein Speichern-unter-Dialog erschienen ist.',
  'fileViewer.exportJsx': 'Als JSX exportieren',
  'fileViewer.exportReactHtml': 'Vorschau als HTML exportieren',
  'fileViewer.exportStarted': 'Export gestartet',
  'fileViewer.saveAsTemplate': 'Als Template speichern…',
  'fileViewer.savingTemplate': 'Template wird gespeichert…',
  'fileViewer.savedTemplate': 'Als „{name}“ gespeichert',
  'fileViewer.savedTemplateFail': 'Template konnte nicht gespeichert werden — bitte erneut versuchen.',
  'fileViewer.templateNamePrompt': 'Template-Name',
  'fileViewer.templateNameDefault': 'Template ohne Titel',
  'fileViewer.templateDescPrompt': 'Kurze Beschreibung (optional — was macht dieses Template nützlich?)',
  'liveArtifact.refresh.button': 'Aktualisieren',
  'liveArtifact.refresh.buttonTitle': 'Dieses Live-Artefakt aktualisieren',
  'liveArtifact.refresh.loadingTitle': 'Live-Artefakt wird geladen…',
  'liveArtifact.refresh.noSourceTitle': 'Noch keine Aktualisierungsquelle verfügbar.',
  'liveArtifact.refresh.running': 'Wird aktualisiert…',
  'liveArtifact.refresh.runningMessage': 'Daten und Vorschau werden aktualisiert. Dies kann einen Moment dauern.',
  'liveArtifact.refresh.runningAction': 'Die vorherige Vorschau bleibt sichtbar, bis die Aktualisierung erfolgreich ist.',
  'liveArtifact.refresh.successOne': 'Aktualisierung abgeschlossen. Daten aktualisiert.',
  'liveArtifact.refresh.successMany': 'Aktualisierung abgeschlossen. Daten aktualisiert.',
  'liveArtifact.refresh.successAction': 'Die Vorschau wurde mit den zuletzt committeten Daten neu geladen.',
  'liveArtifact.refresh.previousFailure': 'Vorherige Aktualisierung fehlgeschlagen: {message}',
  'liveArtifact.refresh.failureAction': 'Überprüfe den Aktualisierungsverlauf, behebe das Quell- oder Berechtigungsproblem und versuche es erneut.',
  'liveArtifact.refresh.networkFailure': 'Aktualisierungsanfrage fehlgeschlagen. Überprüfe deine Verbindung und versuche es erneut.',
  'liveArtifact.refresh.genericFailure': 'Aktualisierung fehlgeschlagen.',
  'liveArtifact.refresh.statusNever': 'Nicht aktualisierbar',
  'liveArtifact.refresh.statusReady': 'Bereit zur Aktualisierung',
  'liveArtifact.refresh.statusSucceeded': 'Aktuell',
  'liveArtifact.refresh.statusFailed': 'Aktualisierung fehlgeschlagen',
  'liveArtifact.refresh.statusRunning': 'Wird aktualisiert',
  'liveArtifact.refresh.statusRunningDescription': 'Ein Aktualisierungslauf wird derzeit ausgeführt.',
  'liveArtifact.refresh.statusSucceededDescription': 'Die letzte Aktualisierung wurde erfolgreich abgeschlossen.',
  'liveArtifact.refresh.statusFailedDescription': 'Der letzte Aktualisierungsversuch wurde nicht erfolgreich abgeschlossen.',
  'liveArtifact.refresh.statusReadyDescription': 'Aktualisierbare Quellen sind konfiguriert, aber es läuft kein Vorgang.',
  'liveArtifact.refresh.statusNeverDescription': 'Dieses Live-Artefakt hat noch keine Aktualisierungsquelle.',
  'liveArtifact.refresh.eventStarted': 'Gestartet',
  'liveArtifact.refresh.eventSucceeded': 'Erfolgreich',
  'liveArtifact.refresh.eventFailed': 'Fehlgeschlagen',
  'liveArtifact.refresh.eventStartedDetail': 'Aktualisierung gestartet…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} Quelle aktualisiert',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} Quellen aktualisiert',
  'liveArtifact.refresh.timelineEmpty': 'Noch keine Aktualisierungsaktivität in dieser Sitzung. Löse eine Aktualisierung aus, um einen Verlauf aufzuzeichnen, oder warte auf automatische Läufe.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Zuletzt aktualisiert',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Nie',
  'liveArtifact.refresh.justNow': 'gerade eben',
  'liveArtifact.refresh.factCreated': 'Erstellt',
  'liveArtifact.refresh.factLastUpdated': 'Zuletzt aktualisiert',
  'liveArtifact.refresh.factUnknown': 'Unbekannt',
  'liveArtifact.refresh.persistedTitle': 'Gespeicherter Aktualisierungsverlauf',
  'liveArtifact.refresh.persistedHint': 'Aus refreshes.jsonl geladene Einträge',
  'liveArtifact.refresh.persistedEmpty': 'Noch kein gespeicherter Aktualisierungsverlauf.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'erfolgreich',
  'liveArtifact.refresh.persistedStatusRunning': 'läuft',
  'liveArtifact.refresh.persistedStatusFailed': 'fehlgeschlagen',
  'liveArtifact.refresh.persistedStatusCancelled': 'abgebrochen',
  'liveArtifact.refresh.persistedStatusSkipped': 'übersprungen',
  'liveArtifact.refresh.sessionTitle': 'Sitzungsaktivität',
  'liveArtifact.refresh.sessionHint': 'Ereignisse, die beobachtet wurden, während dieser Tab geöffnet ist',
  'liveArtifact.refresh.docSourceTitle': 'Dokumentquelle',
  'liveArtifact.refresh.docSourceHint': 'Quelle konfiguriert',
  'liveArtifact.refresh.docSourceType': 'Typ',
  'liveArtifact.refresh.docSourceTool': 'Tool',
  'liveArtifact.refresh.docSourceConnector': 'Connector',
  'liveArtifact.refresh.debugSummary': 'Erweiterte Debug-Metadaten',
  'liveArtifact.refresh.debugNote': 'Kann Connector-IDs, Dateinamen, Quellmetadaten und interne Artefaktpfade enthalten.',
  'liveArtifact.viewer.tabPreview': 'Vorschau',
  'liveArtifact.viewer.tabCode': 'Code',
  'liveArtifact.viewer.tabData': 'Daten',
  'liveArtifact.viewer.tabRefreshHistory': 'Aktualisierungsverlauf',
  'liveArtifact.viewer.dataEmpty': 'Kein data.json-Cache verfügbar.',
  'liveArtifact.viewer.code.templateHeading': 'Vorlagen-HTML',
  'liveArtifact.viewer.code.renderedHeading': 'Gerendertes HTML',
  'liveArtifact.viewer.code.templateHelp': 'Die bearbeitbare Vorlage, die mit data.json zum Erzeugen der Vorschau verwendet wird.',
  'liveArtifact.viewer.code.renderedHelp': 'Die erzeugte index.html, die derzeit von der Vorschau geladen wird.',
  'liveArtifact.viewer.code.variantAria': 'Code-Variante',
  'liveArtifact.viewer.code.variantTemplate': 'Vorlage',
  'liveArtifact.viewer.code.variantRendered': 'Gerendert',
  'liveArtifact.viewer.code.loading': 'Code wird geladen…',
  'liveArtifact.viewer.code.unavailable': 'Code ist noch nicht verfügbar.',
  'liveArtifact.viewer.code.empty': 'Diese Codedatei ist leer.',
  'fileViewer.deployToVercel': 'Auf Vercel deployen',
  'fileViewer.redeployToVercel': 'Erneut deployen',
  'fileViewer.deployingToVercel': 'Deployment auf Vercel…',
  'fileViewer.deployProviderLabel': 'Anbieter',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'Auf {provider} deployen',
  'fileViewer.redeployToProvider': 'Erneut auf {provider} deployen',
  'fileViewer.deployingToProvider': 'Deployment auf {provider}…',
  'fileViewer.preparingPublicLink': 'Öffentlicher Link wird vorbereitet…',
  'fileViewer.copyDeployLink': 'Link kopieren',
  'fileViewer.deployModalTitle': 'Bereitstellen',
  'fileViewer.deployModalSubtitle': 'Verwende das Konto des gewählten Anbieters, um diese HTML-Vorschau zu deployen.',
  'fileViewer.vercelToken': 'Vercel Token',
  'fileViewer.vercelTokenGetLink': 'Vercel Token abrufen',
  'fileViewer.vercelTokenPlaceholder': 'Vercel Token einfügen',
  'fileViewer.vercelTokenReuseHint': 'Gespeicherter Token wird verwendet. Gib einen neuen Token ein, um ihn zu ersetzen.',
  'fileViewer.vercelTokenRequired': 'Gib zuerst einen Vercel Token ein und speichere ihn.',
  'fileViewer.cloudflareApiToken': 'Cloudflare API-Token',
  'fileViewer.cloudflareApiTokenGetLink': 'API-Token abrufen',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Cloudflare API-Token einfügen',
  'fileViewer.cloudflareApiTokenReuseHint': 'Der gespeicherte Cloudflare API-Token wird verwendet. Gib einen neuen Token ein, um ihn zu ersetzen.',
  'fileViewer.cloudflareApiTokenRequired': 'Gib zuerst einen Cloudflare API-Token ein und speichere ihn.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Wähle beim Erstellen des API-Tokens Pages Edit; benutzerdefinierte Domains benötigen Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'Team-ID',
  'fileViewer.vercelTeamSlug': 'Team-Slug',
  'fileViewer.cloudflareAccountId': 'Account-ID',
  'fileViewer.cloudflareAccountIdHint': 'Die Account-ID findest du im Cloudflare-Dashboard.',
  'fileViewer.cloudflareAccountIdRequired': 'Gib zuerst eine Cloudflare Account ID ein und speichere sie.',
  'fileViewer.cloudflareZoneLabel': 'Domain',
  'fileViewer.cloudflareZonePlaceholder': 'Cloudflare-Einstellungen speichern, um Domains zu laden',
  'fileViewer.cloudflareZoneRequired': 'Wähle zuerst eine Cloudflare-Domain aus.',
  'fileViewer.cloudflareZonesLoading': 'Cloudflare-Domains werden geladen…',
  'fileViewer.cloudflareZonesRefresh': 'Domains aktualisieren',
  'fileViewer.cloudflareZonesLoadFailed': 'Cloudflare-Domains konnten nicht geladen werden.',
  'fileViewer.cloudflareZonesEmpty': 'Für dieses Konto wurden keine aktiven vollständigen Cloudflare-Domains gefunden.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Subdomain-Präfix',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Verwende nur ein DNS-Label: Kleinbuchstaben, Zahlen und Bindestriche.',
  'fileViewer.cloudflareHostnamePreview': 'Vorschau der benutzerdefinierten Domain: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Optional: benutzerdefinierte Domain verbinden. Wenn das leer bleibt, wird trotzdem ein pages.dev-Link erstellt.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Benutzerdefinierte Domain',
  'fileViewer.optional': 'Optional',
  'fileViewer.vercelPreviewOnly': 'Deployments sind derzeit nur Preview-Deployments.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages nutzt Direct Upload.',
  'fileViewer.savingConfig': 'Speichern…',
  'fileViewer.deployConfigSaveFailed': 'Vercel-Einstellungen konnten nicht gespeichert werden.',
  'fileViewer.deployFailed': 'Deployment fehlgeschlagen. Prüfe die Vercel-Einstellungen und versuche es erneut.',
  'fileViewer.deployProviderConfigSaveFailed': '{provider}-Einstellungen konnten nicht gespeichert werden.',
  'fileViewer.deployProviderFailed': '{provider}-Deployment fehlgeschlagen. Prüfe die Einstellungen und versuche es erneut.',
  'fileViewer.deployResultLabel': 'Deployment-URL',
  'fileViewer.deployLinkReady': 'Bereit',
  'fileViewer.deploySuccessToast': 'Deployment erfolgreich hochgeladen',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Öffentlicher Link ausstehend',
  'fileViewer.deployLinkDelayed': 'Die Seite wurde deployt. Der Anbieter bereitet den öffentlichen Link noch vor.',
  'fileViewer.deployLinkFailed': 'Benutzerdefinierte Domain fehlgeschlagen',
  'fileViewer.deployLinkProtectedLabel': 'Deployment-Schutz aktiviert',
  'fileViewer.deployLinkProtected': 'Die Seite wurde deployt, aber dieser Vorschau-Link erfordert eine Anmeldung. Deaktiviere Deployment Protection oder nutze eine eigene Domain.',
  'fileViewer.retryLink': 'Jetzt erneut versuchen',
  'questionForm.submit': 'Absenden',
  'questionForm.skip': 'Überspringen',
  'questionForm.locked': 'Beantwortet',
  'conv.switch': 'Konversation wechseln',
  'conv.label': 'Konversation',
  'conv.heading': 'Konversationen',
  'conv.new': '+ Neu',
  'conv.empty': 'Noch keine Konversationen.',
  'conv.untitled': 'Konversation ohne Titel',
  'conv.renameTooltip': 'Doppelklicken zum Umbenennen',
  'conv.delete': 'Konversation löschen',
  'conv.deleteConfirm': '„{title}“ löschen? Dadurch werden die Nachrichten entfernt.',
  'agentPicker.label': 'Agent',
  'agentPicker.modeChoose': 'Ausführungsmodus wählen',
  'agentPicker.localCli': 'Lokale CLI',
  'agentPicker.daemonOff': 'Daemon aus',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'Erkannte Code-Agent-CLI auswählen',
  'agentPicker.noAgents': 'keine Agents im PATH',
  'agentPicker.notInstalled': 'nicht installiert',
  'agentPicker.rescan': 'Lokalen PATH erneut nach Agents scannen',
  'tool.openInTab': '{name} in einem Tab öffnen',
  'tool.open': 'öffnen',
  'tool.todos': 'Aufgaben',
  'tool.todosExpand': 'Aufgaben einblenden',
  'tool.todosCollapse': 'Aufgaben ausblenden',
  'tool.todosDone': 'Fertig',
  'tool.todosDismiss': 'Aufgabenliste schließen',
  'tool.write': 'Schreiben',
  'tool.edit': 'Bearbeiten',
  'tool.read': 'Lesen',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Abrufen',
  'tool.search': 'Suchen',
  'tool.lines': '{n} Zeilen',
  'tool.changeSingular': 'Änderung',
  'tool.changePlural': 'Änderungen',
  'tool.in': 'in {path}',
  'tool.hide': 'ausblenden',
  'tool.output': 'Ausgabe',
  'tool.running': 'läuft…',
  'tool.error': 'Fehler',
  'tool.done': 'fertig',
  'assistant.role': 'Assistent',
  'assistant.workingLabel': 'Arbeitet',
  'assistant.doneLabel': 'Fertig',
  'assistant.copyMarkdown': 'Antwort-Markdown kopieren',
  'assistant.forkConversation': 'Ab hier forken',
  'assistant.forkingConversation': 'Fork wird erstellt…',
  'assistant.shareToOpenDesign': 'An Open Design teilen',
  'assistant.shareToOpenDesignBusy': 'Paket wird vorbereitet…',
  'assistant.feedbackPrompt': 'Feedback',
  'assistant.feedbackPositive': 'Hilfreich',
  'assistant.feedbackNegative': 'Nicht hilfreich',
  'assistant.feedbackReasonTitle': 'Sag uns warum',
  'assistant.feedbackReasonPositiveMatched': 'Hat meine Anfrage verstanden',
  'assistant.feedbackReasonPositiveVisual': 'Sieht gut aus',
  'assistant.feedbackReasonPositiveUseful': 'Nützliche Struktur',
  'assistant.feedbackReasonPositiveEasy': 'Leicht weiter zu bearbeiten',
  'assistant.feedbackReasonPositiveDesignSystem': 'Hat das Designsystem befolgt',
  'assistant.feedbackReasonNegativeMissed': 'Hat meine Anfrage verfehlt',
  'assistant.feedbackReasonNegativeVisual': 'Visuelle Qualität verbesserungswürdig',
  'assistant.feedbackReasonNegativeIncomplete': 'Unvollständige Ausgabe',
  'assistant.feedbackReasonNegativeHard': 'Schwer zu bedienen',
  'assistant.feedbackReasonNegativeDesignSystem': 'Hat das Designsystem nicht befolgt',
  'assistant.feedbackReasonOther': 'Sonstiges',
  'assistant.feedbackReasonPlaceholder': 'Eine kurze Anmerkung hinzufügen...',
  'assistant.feedbackReasonSubmit': 'Absenden',
  'assistant.emptyResponseLabel': 'Keine Ausgabe',
  'assistant.emptyResponseMessage': 'Der Anbieter hat die Anfrage beendet, ohne Text oder ein Artefakt zurückzugeben. Versuche ein anderes Modell oder einen anderen Anbieter, prüfe dein Kontingent oder versuche es erneut.',
  'assistant.unfinishedLabel': 'Mit unerledigter Arbeit gestoppt',
  'assistant.unfinishedSummary': '{n} Aufgabe(n) offen',
  'assistant.unfinishedMore': '+{n} weitere',
  'assistant.continueRemaining': 'Offene Aufgaben fortsetzen',
  'chat.resumeRunCta': 'Lauf fortsetzen',
  'assistant.outTokens': '{n} ausgehend',
  'assistant.producedFiles': 'Dateien aus diesem Turn',
  'assistant.openFile': 'Öffnen',
  'assistant.downloadFile': 'Herunterladen',
  'nextStep.title': 'Nächster Schritt',
  'nextStep.more': 'Mehr',
  'nextStep.share': 'Teilen',
  'nextStep.download': 'Herunterladen',
  'nextStep.contribute': 'Beitragen',
  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.createDesignBusy': 'Design wird erstellt...',
  'assistant.thinking': 'Denkt',
  'assistant.thought': 'Gedacht',
  'assistant.thoughtFor': 'Nachgedacht ({s}s)',
  'assistant.systemReminder': 'Systemhinweis',
  'assistant.possiblePromptInjection': 'Mögliche Prompt-Injektion',
  'assistant.waitingFirstOutput': 'Warte auf erste Ausgabe',
  'assistant.statusBootingAgent': 'Agent wird gestartet',
  'assistant.statusPreparing': 'Wird vorbereitet...',
  'assistant.statusStarting': 'Startet',
  'assistant.statusRequesting': 'Anfrage wird gesendet',
  'assistant.statusThinking': 'Denkt',
  'assistant.statusStreaming': 'Streamt',
  'assistant.slowHint': 'Dauert länger als üblich. Das Formular erscheint normalerweise nach 5–10 s — Sie können Stoppen und umformulieren.',
  'assistant.verbEditing': 'Bearbeitet',
  'assistant.verbWriting': 'Schreibt',
  'assistant.verbReading': 'Liest',
  'assistant.verbSearching': 'Sucht',
  'assistant.verbRunning': 'Führt aus',
  'assistant.verbTodos': 'Aufgaben',
  'assistant.verbFetching': 'Holt',
  'assistant.verbCalling': 'Ruft auf',
  'qf.answered': 'beantwortet',
  'qf.choose': 'Auswählen…',
  'qf.required': 'erforderlich',
  'qf.lockedSubmitted': 'Antworten gesendet — der Agent nutzt sie für den Rest der Sitzung.',
  'qf.lockedPrev': 'Dieses Formular stammt aus einem vorherigen Turn.',
  'qf.hint': 'Wählen Sie, was passt. Überspringen Sie optionale Felder, die Ihnen egal sind — der Agent nutzt sinnvolle Standards.',
  'qf.submitDefault': 'Antworten senden',
  'qf.submitDisabledTitle': 'Füllen Sie zuerst die erforderlichen Felder aus',
  'qf.submitTitle': 'Antworten senden',
  'qf.cardSelected': 'ausgewählt',
  'qf.cardRefs': 'Refs:',
  'qf.cardSampleText': 'Franz jagt im komplett verwahrlosten Taxi quer durch Bayern · 0123',
  'questions.tabLabel': 'Fragen',
  'questions.banner': 'Darf ich dir ein paar kurze Fragen stellen?',
  'questions.bannerAnswered': 'Fragen beantwortet',
  'questions.continue': 'Fortfahren',
  'questions.generating': 'Fragen werden generiert…',
  'questions.skipAll': 'Alle überspringen',
  'questions.autoSkipHint': 'Wird automatisch fortgesetzt, wenn der Timer abläuft',
  'sketch.toolSelect': 'Auswählen (no-op)',
  'sketch.toolPen': 'Stift',
  'sketch.toolText': 'Text',
  'sketch.toolRect': 'Rechteck',
  'sketch.toolArrow': 'Pfeil',
  'sketch.toolEraser': 'Radierer',
  'sketch.color': 'Farbe',
  'sketch.strokeSize': 'Strichstärke',
  'sketch.undo': 'Rückgängig',
  'sketch.clear': 'Leeren',
  'sketch.close': 'Schließen',
  'sketch.closeConfirm': 'Skizze schließen und ungespeicherte Änderungen verwerfen?',
  'sketch.textPrompt': 'Text:',
  'sketch.textModalTitle': 'Text hinzufügen',
  'critiqueTheater.userFacingName': 'Design-Jury',
  'critiqueTheater.roleDesigner': 'Designer',
  'critiqueTheater.roleCritic': 'Kritiker',
  'critiqueTheater.roleBrand': 'Marke',
  'critiqueTheater.roleA11y': 'Barrierefreiheit',
  'critiqueTheater.roleCopy': 'Text',
  'critiqueTheater.roundLabel': 'Runde {n} von {m}',
  'critiqueTheater.mustFix': '{n} Pflichtkorrekturen',
  'critiqueTheater.composite': 'Gesamtscore',
  'critiqueTheater.threshold': 'Schwelle',
  'critiqueTheater.consensus': 'Konsens',
  'critiqueTheater.interrupt': 'Abbrechen',
  'critiqueTheater.interrupting': 'Wird abgebrochen…',
  'critiqueTheater.interrupted': 'Abgebrochen',
  'critiqueTheater.degradedHeading': 'Jury für diesen Lauf offline',
  'critiqueTheater.degradedReasonMalformed': 'Ungültige Jury-Ausgabe (Parser hat den Block abgelehnt).',
  'critiqueTheater.degradedReasonOversize': 'Jury-Ausgabe hat das sichere Byte-Budget überschritten.',
  'critiqueTheater.degradedReasonAdapter': 'Adapter {adapter} unterstützt das Critique-Protokoll nicht.',
  'critiqueTheater.degradedReasonProtocol': 'Adapter {adapter} verwendet eine nicht unterstützte Protokollversion.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Der Lauf endete ohne ein finales Artefakt.',
  'critiqueTheater.replay': 'Wiedergabe',
  'critiqueTheater.replaySpeed': 'Wiedergabegeschwindigkeit',
  'critiqueTheater.readOnly': 'Nur lesen',
  'critiqueTheater.shippedSummary': 'In Runde {round} freigegeben · Gesamtscore {composite}',
  'critiqueTheater.interruptedSummary': 'In Runde {round} abgebrochen · bester Gesamtscore {composite}',
  'critiqueTheater.shippedBadge': 'Freigegeben',
  'critiqueTheater.belowThresholdBadge': 'Unter der Schwelle',
  'critiqueTheater.timedOutBadge': 'Zeitüberschreitung',
  'critiqueTheater.failedHeading': 'Lauf fehlgeschlagen',
  'critiqueTheater.failedReasonCliExit': 'Agent-CLI hat vor Ende der Jury mit einem Fehler beendet.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'Eine Runde hat ihr Zeitbudget überschritten.',
  'critiqueTheater.failedReasonTotalTimeout': 'Der gesamte Lauf hat sein Zeitbudget überschritten.',
  'critiqueTheater.failedReasonOrchestrator': 'Interner Orchestrierungsfehler.',
  'critiqueTheater.transcriptEmpty': 'Noch keine Wiedergabe verfügbar. Starte eine Jury, um eine aufzuzeichnen.',
  'critiqueTheater.transcriptLoading': 'Wiedergabe wird geladen…',
  'critiqueTheater.transcriptError': 'Wiedergabe konnte nicht geladen werden: {error}',
  'critiqueTheater.replaySpeedPaused': 'Pausiert',
  'critiqueTheater.replaySpeedInstant': 'Sofort',
  'critiqueTheater.replaySpeedLive': 'Live',
  'critiqueTheater.replaySpeedFast': 'Schnell',
  'critiqueTheater.settingsNav': 'Design-Jury',
  'critiqueTheater.settingsNavHint': 'Fünf-Panel-Review für deine Agent-Runs',
  'critiqueTheater.settingsEnabledLabel': 'Design Jury während Agent-Runs anzeigen',
  'critiqueTheater.settingsEnabledDescription': 'Aktiviert, läuft während jeder Agent-Generierung eine Fünf-Panel-Review mit, die das Ergebnis vor der Auslieferung bewertet. Du kannst jederzeit unterbrechen.',
  'critiqueTheater.settingsEnabledProjectHint': 'Für dieses Projekt gespeichert. Neue Runs in diesem Projekt laufen serverseitig durch die Design Jury.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Öffne ein Projekt, damit dies serverseitig persistiert. Bis dahin ändert sich nur die Browser-Voreinstellung.',
  'pet.title': 'Haustiere',
  'pet.subtitle': 'Adoptiere ein kleines Maskottchen, das über deinem Workspace schwebt.',
  'pet.navTitle': 'Haustiere',
  'pet.navHint': 'Adoptieren oder anpassen',
  'pet.tabBuiltIn': 'Vorgegeben',
  'pet.tabBuiltInHint': 'Mit Open Design gebündelte Begleiter — auswählen und adoptieren.',
  'pet.builtInEmpty': 'Eingebaute Pets sind gerade nicht verfügbar. Aktualisiere den Community-Tab, sobald der Daemon wieder online ist.',
  'pet.tabCustom': 'Eigenes',
  'pet.tabCustomHint': 'Eigener Name, Glyph, Farbe oder Sprite.',
  'pet.tabCommunity': 'Community',
  'pet.tabCommunityHint': 'Von Codex geschlüpfte Pets — adoptieren oder neue generieren.',
  'pet.tabsAria': 'Pet-Quelle',
  'pet.adopt': 'Adoptieren',
  'pet.adoptedBadge': 'Adoptiert',
  'pet.adoptCallout': 'Ein Haustier adoptieren',
  'pet.changePet': 'Haustier wechseln',
  'pet.wake': 'Wecken',
  'pet.tuck': 'Verstecken',
  'pet.wakeTitle': 'Haustier wecken — Overlay anzeigen.',
  'pet.tuckTitle': 'Haustier verstecken — Overlay ausblenden.',
  'pet.settingsTitle': 'Haustier-Einstellungen öffnen',
  'pet.useCustom': 'Mein Haustier verwenden',
  'pet.customTitle': 'Selbst gestalten',
  'pet.customHint': 'Wähle Name, Symbol und Akzentfarbe — das Overlay aktualisiert sich live.',
  'pet.customGreetingPlaceholder': 'Eine Begrüßung von deinem Haustier…',
  'pet.fieldName': 'Name',
  'pet.fieldGlyph': 'Symbol',
  'pet.fieldGlyphHint': 'Ein einzelnes Emoji passt am besten (z. B. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Begrüßung',
  'pet.fieldAccent': 'Akzentfarbe',
  'pet.fieldAccentCustom': 'Eigene Farbe',
  'pet.fieldAccentDefault': 'Standard-Akzentfarbe',
  'pet.overlayAria': 'Haustier-Begleiter',
  'pet.spriteAria': '{name} — zum Bewegen ziehen, zum Plaudern klicken',
  'pet.spriteTitle': 'Hallo von {name}! Klick zum Plaudern.',
  'pet.taskSummarySingle': '{count} Agent-Aufgabe wird ausgeführt.',
  'pet.taskSummaryMultiple': '{count} Agent-Aufgaben werden in {projects} Projekten ausgeführt.',
  'pet.taskSummaryRecentSingle': '{count} Agent-Aufgabe kürzlich abgeschlossen.',
  'pet.taskSummaryRecentMultiple': '{count} Agent-Aufgaben kürzlich abgeschlossen.',
  'pet.taskListAria': 'Aktive Agent-Aufgaben',
  'pet.taskOpenProject': '{project} öffnen',
  'pet.taskGroup.running': 'Läuft',
  'pet.taskGroup.queued': 'Wartet',
  'pet.taskGroup.recent': 'Kürzlich abgeschlossen',
  'pet.idleQuote.leonardo.text': 'Lernen erschöpft den Geist niemals.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'Ich sah den Engel im Marmor und meißelte, bis ich ihn befreit hatte.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'Es gibt zwei Hilfsmittel für den Bildhauer: Licht und Schatten.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'Wenn man malt, denkt man nicht.',
  'pet.idleQuote.raphael.author': 'Raffael',
  'pet.idleQuote.caravaggio.text': 'Alle Werke, ganz gleich was oder von wem gemalt, sind nichts als Belanglosigkeiten und kindische Spielereien, wenn sie nicht nach dem Leben geschaffen und gemalt sind.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'Das Wichtigste ist, bewegt zu sein, zu lieben, zu hoffen, zu beben, zu leben.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Haustiere — wecken, verstecken oder auswählen',
  'pet.composerMenuTitle': 'Haustiere',
  'pet.composerMenuHint': 'Tipp: tippe /pet zum Umschalten',
  'pet.composerOpenSettings': 'Haustiere verwalten',
  'pet.welcomeTeaserTitle': 'Adoptiere ein Haustier',
  'pet.welcomeTeaserBody': 'Ein kleiner schwebender Begleiter für deinen Workspace.',
  'pet.welcomeTeaserCta': 'Eines wählen',
  'pet.imageUpload': 'Sprite hochladen',
  'pet.imageReplace': 'Sprite ersetzen',
  'pet.imageRemove': 'Emoji verwenden',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF oder SVG. Spritesheet? Lade einen horizontalen Streifen hoch und setze die Frame-Anzahl.',
  'pet.imageHintActive': 'Dein Sprite wird angezeigt. Setze Frames > 1, um einen horizontalen Spritesheet zu animieren.',
  'pet.fieldFrames': 'Frames',
  'pet.fieldFramesHint': '1 = statisch. > 1 = horizontaler Spritesheet.',
  'pet.fieldFps': 'Geschwindigkeit (fps)',
  'pet.fieldFpsHint': 'Wie schnell die Frames durchlaufen.',
  'pet.atlasImport': 'Codex-Sprite importieren',
  'pet.atlasImportTitle': 'Importiere ein hatch-pet 8x9 / 192x208 Atlas (PNG oder WebP).',
  'pet.atlasPickerTitle': 'Animationszeile wählen',
  'pet.atlasPickerHint': 'Codex-Pets bringen 9 Animationszeilen mit. Standardmäßig behalten wir den ganzen Atlas, damit das Pet bei Hover, Drag-Richtung und langer Untätigkeit die Reihen wechselt. Du kannst es auch auf eine Schleife festlegen.',
  'pet.atlasCancel': 'Atlas verwerfen',
  'pet.atlasAdopt': 'Auf diese Zeile festlegen',
  'pet.atlasAdoptFull': 'Ganzen Atlas verwenden (animiert)',
  'pet.atlasAdoptFullTitle': 'Alle Zeilen behalten, damit das Pet auf Hover, Drag-Richtung und lange Untätigkeit reagiert.',
  'pet.atlasAdoptRowTitle': 'Nur die markierte Zeile als einzelne Endlosschleife herausschneiden.',
  'pet.atlasActiveHint': 'Animierter Atlas aktiv — das Pet wählt anhand deiner Interaktion (Hover, Drag, Untätigkeit) eine Zeile aus.',
  'pet.atlasRow.idle': 'Inaktiv',
  'pet.atlasRow.running-right': 'Lauf rechts',
  'pet.atlasRow.running-left': 'Lauf links',
  'pet.atlasRow.waving': 'Winken',
  'pet.atlasRow.jumping': 'Springen',
  'pet.atlasRow.failed': 'Gescheitert',
  'pet.atlasRow.waiting': 'Warten',
  'pet.atlasRow.running': 'Laufen',
  'pet.atlasRow.review': 'Prüfen',
  'pet.hatchTitle': 'Neues Pet mit KI ausbrüten',
  'pet.hatchHint': 'Nutze das mitgelieferte hatch-pet-Skill im Chat, um ein Codex-Spritesheet zu erzeugen, und importiere es danach hier.',
  'pet.hatchConcept': 'Pet-Konzept (optional)',
  'pet.hatchConceptPlaceholder': 'z. B. ein winziger Pixel-Shiba im kuscheligen Pulli',
  'pet.hatchCopy': 'Prompt kopieren',
  'pet.hatchCopied': 'Kopiert!',
  'pet.hatchFoot': 'Sobald das Skill dein Pet gespeichert hat, kommst du zurück und wählst „Codex-Sprite importieren".',
  'pet.slashPopoverAria': 'Slash-Befehle',
  'pet.slashPopoverTitle': 'Befehle',
  'pet.slashPopoverHint': '↑↓ navigieren · enter auswählen · esc schließen',
  'pet.slashPet': 'Pet umschalten, adoptieren oder Einstellungen öffnen.',
  'pet.slashPetWake': 'Schwebende Pet-Anzeige aufwecken.',
  'pet.slashPetTuck': 'Pet vorerst wegstecken.',
  'pet.slashHatch': 'Codex-Pet mit dem hatch-pet-Skill erzeugen.',
  'pet.slashHatchArg': '<Konzept>',
  'pet.slashSearch': 'Suche im Web über den OD-Research-Befehl.',
  'pet.slashSearchArg': '<Suchanfrage>',
  'pet.codexTitle': 'Kürzlich ausgebrütet',
  'pet.codexSubtitle': 'Vom hatch-pet-Skill gepackte Pets erscheinen hier zur Ein-Klick-Adoption.',
  'pet.codexSubtitleWithDir': 'Suche in {dir} nach hatch-pet-Paketen.',
  'pet.codexEmpty': 'Noch keine ausgebrüteten Pets. Tippe /hatch im Chat, um eines zu erzeugen.',
  'pet.codexLoading': 'Suche nach ausgebrüteten Pets…',
  'pet.codexRefresh': 'Aktualisieren',
  'pet.codexAdopt': 'Adoptieren',
  'pet.codexAdopting': 'Adoptiere…',
  'pet.communitySync': 'Community-Pets herunterladen',
  'pet.communitySyncing': 'Lade…',
  'pet.communitySyncTitle': 'Synchronisiere die neuesten Pets aus Codex Pet Share + j20 Hatchery nach ~/.codex/pets/.',
  'pet.communitySyncDone': '{wrote} neue Pets synchronisiert ({total} insgesamt).',
  'pet.communitySyncFailed': 'Sync fehlgeschlagen: {error}',
  'pet.codexBundled': 'Mitgeliefert',
  'pet.codexBundledTitle': 'Wird mit Open Design ausgeliefert — kein Download nötig.',
  'settings.notifications': 'Benachrichtigungen',
  'settings.notificationsHint': 'Ton und Desktop-Benachrichtigung beim Abschluss von Aufgaben',
  'settings.notifyCompletionSound': 'Abschluss-Ton',
  'settings.notifyCompletionSoundHint': 'Wird abgespielt, wenn eine Runde endet. Standardmäßig aus.',
  'settings.notifySuccessSound': 'Erfolgs-Ton',
  'settings.notifyFailureSound': 'Fehler-Ton',
  'settings.notifyDesktop': 'Desktop-Benachrichtigung',
  'settings.notifyDesktopHint': 'Wird gesendet, wenn das Fenster nicht im Vordergrund ist.',
  'settings.notifyDesktopBlocked': 'Vom Browser blockiert. Bitte in den Website-Einstellungen erlauben.',
  'settings.notifyDesktopUnsupported': 'Desktop-Benachrichtigungen werden in dieser Umgebung nicht unterstützt.',
  'settings.notifyTest': 'Test senden',
  'settings.notifyTestSent': 'Testbenachrichtigung gesendet. Wenn kein Banner erscheint, Browser- und Systembenachrichtigungen prüfen.',
  'settings.notifyTestFailed': 'Benachrichtigungsaufruf fehlgeschlagen. Browser- und Systembenachrichtigungen prüfen.',
  'settings.notifySoundDing': 'Ding',
  'settings.notifySoundChime': 'Glockenspiel',
  'settings.notifySoundTwoToneUp': 'Zweiton aufwärts',
  'settings.notifySoundPluck': 'Zupfen',
  'settings.notifySoundBuzz': 'Summen',
  'settings.notifySoundTwoToneDown': 'Zweiton abwärts',
  'settings.notifySoundThud': 'Dumpfer Schlag',
  'settings.skills': 'Skills',
  'settings.skillsHint': 'Funktionale Skills, die der Agent während einer Aufgabe aufrufen kann',
  'settings.skillsNew': 'Neuer Skill',
  'settings.skillsEmpty': 'Wähle links einen Skill aus oder erstelle einen neuen.',
  'settings.skillsEdit': 'Bearbeiten',
  'settings.skillsDelete': 'Löschen',
  'settings.skillsDeleteConfirm': 'Löschen bestätigen',
  'settings.skillsName': 'Name',
  'settings.skillsTriggers': 'Trigger (Komma- oder zeilengetrennt)',
  'settings.skillsDescription': 'Beschreibung',
  'settings.skillsBody': 'SKILL.md-Inhalt',
  'settings.skillsCreate': 'Erstellen',
  'settings.skillsSave': 'Speichern',
  'settings.skillsSaving': 'Speichern…',
  'settings.skillsFiles': 'Dateien',
  'settings.skillsNoFiles': 'Keine Dateien in diesem Skill-Ordner.',
  'settings.skillsNameRequired': 'Skill-Name ist erforderlich.',
  'settings.skillsBodyRequired': 'Skill-Inhalt ist erforderlich.',
  'settings.designSystems': 'Design-Systeme',
  'settings.designSystemsHint': 'Verfügbare Design-Systeme durchsuchen und umschalten',
  'settings.designSystemsInstalled': 'Installiert',
  'settings.designSystemsAdd': 'Design-System hinzufügen',
  'settings.designSystemsHiddenCount': '{count} in der Home-Galerie ausgeblendet',
  'settings.designSystemsShowAll': 'Alle anzeigen',
  'settings.designSystemsShowHidden': 'Ausgeblendete anzeigen',
  'settings.designSystemsSource': 'Quelle',
  'settings.designSystemsSourceLocal': 'Lokal',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'shadcn-Registry-Referenz',
  'settings.designSystemsImportShadcn': 'Aus shadcn importieren',
  'settings.designSystemsStructure': 'Struktur',
  'settings.designSystemsModeHybrid': 'Hybrid',
  'settings.designSystemsModeNormalized': 'Normalisiert',
  'settings.designSystemsModeVerbatim': 'Unverändert',
  'settings.designSystemsCraft': 'Handwerk',
  'settings.designSystemsCraftColor': 'Farbe',
  'settings.designSystemsCraftAccessibility': 'Barrierefreiheit',
  'settings.designSystemsGithubUrl': 'GitHub-URL',
  'settings.designSystemsProjectPath': 'Projektpfad',
  'settings.designSystemsImportGithub': 'Aus GitHub importieren',
  'settings.designSystemsImportProject': 'Aus Projekt importieren',
  'settings.designSystemsImportedStatus': '{title} importiert',
  'settings.designSystemsViewImported': 'Importiertes Design-System anzeigen',
  'settings.designSystemsCategory': 'Kategorie',
  'settings.designSystemsAllCategories': 'Alle Kategorien',
  'settings.designSystemsShowInHomeGallery': 'In Home-Galerie anzeigen',
  'settings.projectLocations': 'Projektorte',
  'settings.projectLocationsHint': 'Workspace-Speicherorte',
  'settings.projectLocationsDescription': 'Füge Arbeitsbasen hinzu, die mehrere Open Design-Projektordner enthalten können. Neue Projekte werden als Ordner in der ausgewählten Basis gespeichert.',
  'settings.projectLocationsSaveError': 'Projektorte konnten nicht gespeichert werden. Prüfe, ob jeder Pfad ein zugänglicher Ordner ist.',
  'settings.projectLocationsSaved': 'Projektorte gespeichert.',
  'settings.projectLocationsScanError': 'Projektorte konnten nicht gescannt werden.',
  'settings.projectLocationsScanComplete': 'Scan abgeschlossen: {imported} importiert, {existing} bereits registriert.',
  'settings.projectLocationsNoFolderSelected': 'Kein Ordner ausgewählt.',
  'settings.projectLocationsDuplicate': 'Diese Arbeitsbasis wurde bereits hinzugefügt.',
  'settings.projectLocationsWorkBaseMeta': 'Arbeitsbasis · Projekte werden hier als Unterordner erstellt',
  'settings.projectLocationsAddFolder': 'Ordner hinzufügen…',
  'settings.projectLocationsDefaultBadge': 'Standardort',
  'settings.projectLocationsMakeDefault': 'Als Standard festlegen',
  'settings.projectLocationsDefaultSaved': 'Standard-Projektort aktualisiert.',
  'settings.librarySkills': 'Fähigkeiten',
  'settings.libraryDesignSystems': 'Designsysteme',
  'settings.librarySearch': 'Suchen...',
  'settings.libraryAll': 'Alle',
  'settings.libraryPreview': 'Vorschau',
  'settings.libraryPreviewClose': 'Schließen',
  'settings.libraryLoading': 'Laden...',
  'settings.libraryNoResults': 'Keine Elemente entsprechen Ihrer Suche.',
  'settings.libraryEnabled': 'Aktiviert',
  'settings.libraryDisabled': 'Deaktiviert',
  'settings.connectorsNavHint': 'Externe Systemverbindungen',
  'settings.connectorsHint': 'Verwalte Connector- und Tool-Anbieter-Einstellungen für dieses Gerät.',
  'settings.connectorsComposioApiKey': 'Composio-API-Schlüssel',
  'settings.connectorsSavedTitle': 'Im lokalen Daemon gespeichert',
  'settings.connectorsSavedWithTail': 'Gespeichert · ••••{tail}',
  'settings.connectorsSaved': 'Gespeichert',
  'settings.connectorsGetApiKey': 'API-Schlüssel abrufen',
  'settings.connectorsReplaceKeyPlaceholder': 'Neuen Schlüssel einfügen, um den gespeicherten zu ersetzen',
  'settings.connectorsApiKeyPlaceholder': 'Composio-API-Schlüssel einfügen',
  'settings.connectorsClear': 'Löschen',
  'settings.connectorsClearConfirmTitle': 'Gespeicherten Composio-API-Schlüssel löschen?',
  'settings.connectorsClearConfirmBody': 'Beim Entfernen des Schlüssels werden alle Composio-Connectors dieses Workspaces getrennt. Verknüpfte Konten, OAuth-Freigaben und Tool-Zugriffe werden allesamt entfernt.',
  'settings.connectorsClearConfirmContinue': 'Weiter',
  'settings.connectorsClearFinalTitle': 'Damit werden alle Connectors getrennt',
  'settings.connectorsClearFinalBody': 'Dieser Schritt lässt sich nicht rückgängig machen. Nach dem Einfügen eines neuen Schlüssels musst du jede Integration neu verbinden.',
  'settings.connectorsClearFinalConfirm': 'Schlüssel löschen & trennen',
  'settings.connectorsClearArming': 'Einen Moment…',
  'settings.connectorsClearCancel': 'Abbrechen',
  'settings.connectorsSaveKey': 'Key speichern',
  'settings.connectorsSaveKeyTitle': 'Diesen Key an den lokalen Daemon senden',
  'settings.connectorsKeySaving': 'Speichere…',
  'settings.connectorsKeySaved': 'Gespeichert ✓',
  'settings.connectorsKeyError': 'Key konnte nicht gespeichert werden. Prüfe, ob der lokale Daemon läuft, und versuche es erneut.',
  'settings.connectorsHelpSaved': 'Dein Schlüssel entsperrt den Katalog unten und bleibt im lokalen Daemon. Füge einen neuen Schlüssel ein, um ihn zu ersetzen, oder lösche ihn.',
  'settings.connectorsHelpUnsaved': 'Ungespeicherte Änderungen — klicke auf „Key speichern“, um diesen Schlüssel im lokalen Daemon abzulegen und den Katalog unten freizuschalten.',
  'settings.connectorsHelpEmpty': 'Füge einen Schlüssel hinzu, um den Katalog unten zu entsperren. Schlüssel werden lokal im Daemon gespeichert und nie über Umgebungsvariablen gesendet.',
  'settings.connectorsLoadingSavedKey': 'Im lokalen Daemon wird nach einem gespeicherten Schlüssel gesucht…',
  'settings.autosaveSaving': 'Speichere…',
  'settings.autosaveSaved': 'Alle Änderungen gespeichert',
  'settings.autosaveError': 'Änderungen konnten nicht gespeichert werden. Der lokale Daemon ist möglicherweise offline.',
  'settings.libraryToggleLabel': 'Umschalten',
  'settings.memory': 'Speicher',
  'settings.memoryHint': 'Persönliche Fakten, automatisch aus Chats extrahiert',
  'settings.customInstructionsTitle': 'Globale Regeln',
  'settings.customInstructionsHint': 'Feste Anweisungen, die Open Design in jedem Chat befolgen soll. Speichere Fakten, Präferenzen und Projektkontext als Erinnerungen.',
  'settings.customInstructionsPlaceholder': 'z. B. „Verwende immer TypeScript. Bevorzuge funktionale Komponenten. Halte Antworten knapp.“',
  'settings.memoryDescription': 'Aus Chats extrahierte Fakten zu deinen Präferenzen, gespeichert als Markdown-Dateien und in jeden Chat eingespielt.',
  'settings.memoryEnabled': 'Aktiviert',
  'settings.memoryDisabled': 'Deaktiviert',
  'settings.memoryEnableLabel': 'Speicher-Injektion aktivieren',
  'settings.memoryDisabledBanner': 'Der Speicher ist derzeit AUS. Bestehende Fakten bleiben auf der Festplatte, werden aber nicht in neue Chats eingespielt.',
  'settings.memoryNew': 'Neuer Eintrag',
  'settings.memoryEdit': 'Bearbeiten',
  'settings.memoryDelete': 'Löschen',
  'settings.memoryPreview': 'Vorschau',
  'settings.memoryEmpty': 'Noch keine Erinnerungen.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'Ich bevorzuge den Dunkelmodus',
  'settings.memoryName': 'Name',
  'settings.memoryDesc': 'Einzeilige Beschreibung',
  'settings.memoryBody': 'Inhalt (Markdown unterstützt)',
  'settings.memoryBodyHint': 'Regel zuerst, dann Zeilen Why und How to apply.',
  'settings.memoryStartersLabel': 'Brauchst du einen Startpunkt? Klicke, um das Formular auszufüllen:',
  'settings.memoryStarterUserName': 'Meine Rolle',
  'settings.memoryStarterUserDesc': 'Ich bin Frontend-Entwickler und arbeite an einem SaaS-Designtool',
  'settings.memoryStarterUserBody': '- Rolle: Senior-Frontend-Entwickler\n- Stack: React, TypeScript, Vite\n- Bereich: Design-/Kollaborationstools\n- Zeitzone: GMT+8 (Asia/Shanghai)\n\nWann anwenden: in jedem Chat – Beispiele rund um Web-Frontend gestalten.',
  'settings.memoryStarterFeedbackName': 'UI-Präferenzen',
  'settings.memoryStarterFeedbackDesc': 'Dunkelmodus, große Fließtextschrift, geringe Informationsdichte',
  'settings.memoryStarterFeedbackBody': '- Theme: standardmäßig dunkel\n- Fließtext: ≥ 18px\n- Informationsdichte: Weißraum bevorzugen, weniger Elemente pro Bildschirm\n\nWarum: weniger Augenbelastung bei langen Sitzungen.\nWann anwenden: immer wenn du UI, Webseiten oder Folien generierst.',
  'settings.memoryStarterProjectName': 'Aktuelles Projekt',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 – chatgesteuerter Design-Editor',
  'settings.memoryStarterProjectBody': '- Ziel: den chatgesteuerten Editor in diesem Quartal ausliefern\n- Prioritäten: Streaming-Rendering, lokal multimodal, Offline-First\n- Stack: Next.js 16, Express-Daemon, SQLite\n\nWann anwenden: in jeder Konversation über dieses Projekt.',
  'settings.memorySaveHint': 'Nicht automatisch gespeichert – auf Erstellen / Speichern klicken, um zu übernehmen.',
  'settings.memoryIndexSaveHint': 'Änderungen am Index werden nicht automatisch gespeichert – auf Index speichern klicken, um zu übernehmen.',
  'settings.memoryIndexUnsaved': 'Nicht gespeicherte Änderungen',
  'settings.memoryFlashCreated': '✓ Memory erstellt',
  'settings.memoryFlashSaved': '✓ Memory gespeichert',
  'settings.memoryFlashDeleted': '✓ Memory gelöscht',
  'settings.memoryFlashIndexSaved': '✓ Index gespeichert',
  'settings.memoryFlashPathCopied': '✓ Pfad kopiert',
  'settings.memoryNameLabel': 'Titel',
  'settings.memoryTypeLabel': 'Typ',
  'settings.memoryDescLabel': 'Beschreibung',
  'settings.memoryBodyLabel': 'Inhalt',
  'settings.memoryTypeUser': 'Benutzer',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Projekt',
  'settings.memoryTypeReference': 'Referenz',
  'settings.memoryTypeProfile': 'Profil',
  'settings.memoryTypeRule': 'Regel',
  'settings.memoryTabMemories': 'Erinnerungen',
  'settings.memoryTabMemoriesCaption': 'Gespeicherten Speicher anzeigen und verwalten',
  'settings.memoryTabHow': 'So funktioniert es',
  'settings.memoryTabHowCaption': 'Die zwei Schleifen und ihre Steuerung',
  'settings.memoryAddDisclosure': 'Erinnerungen hinzufügen oder importieren',
  'settings.memoryAddDisclosureHint': 'Profil, manuelle Eingabe oder verbundene Apps',
  'settings.memoryProfileTab': 'Arbeitsprofil',
  'settings.memoryProfileTabCaption': 'Wer du bist und deine Standardeinstellungen',
  'settings.memoryProfileTitle': 'Dein Arbeitsprofil',
  'settings.memoryProfileHint':
    'Ein paar Fakten über dich und deine Standardeinstellungen. Der Speicher spielt sie vor jeder Aufgabe ein, damit der Agent aus einer kurzen Anfrage ableitet, was du meinst.',
  'settings.memoryProfileName': 'Arbeitsprofil',
  'settings.memoryProfileDescription':
    'Rolle, Unternehmen, Bereich, Zielgruppe, Stil und Standards, die der Assistent wiederverwenden soll.',
  'settings.memoryProfileSave': 'Profil speichern',
  'settings.memoryProfileSaving': 'Wird gespeichert…',
  'settings.memoryProfileSaved': 'Profil gespeichert',
  'settings.memoryProfileRole': 'Rolle',
  'settings.memoryProfileRolePlaceholder': 'z. B. Founder, designer, PM',
  'settings.memoryProfileCompany': 'Unternehmen / Team',
  'settings.memoryProfileCompanyPlaceholder': 'z. B. Acme, growth team',
  'settings.memoryProfileDomain': 'Bereich',
  'settings.memoryProfileDomainPlaceholder': 'z. B. B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Hauptzielgruppe',
  'settings.memoryProfileAudiencePlaceholder': 'z. B. executives, engineers, end users',
  'settings.memoryProfileAesthetic': 'Ästhetik / Geschmack',
  'settings.memoryProfileAestheticPlaceholder':
    'z. B. clean and editorial, light backgrounds, generous whitespace',
  'settings.memoryProfileDeliverables': 'Standard-Lieferobjekte',
  'settings.memoryProfileDeliverablesPlaceholder': 'z. B. landing pages, decks, one-pagers',
  'settings.memoryProfileLocale': 'Region / Sprache',
  'settings.memoryProfileLocalePlaceholder': 'z. B. English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Aktuelle Ziele',
  'settings.memoryProfileGoalsPlaceholder':
    'z. B. ship the new pricing page, raise conversion on the trial flow',
  'settings.memoryHooksTitle': 'Speicher-Hooks',
  'settings.memoryHooksHint':
    'Wähle, welche Teile des Speichers automatisch ausgeführt werden. Der Hauptschalter oben schaltet sie alle aus.',
  'settings.memoryHooksProfileLabel': 'Mein Profil verwenden',
  'settings.memoryHooksProfileDesc': 'Spielt dein Arbeitsprofil in jede Aufgabe ein.',
  'settings.memoryHooksRewriteLabel': 'Kurze Anfragen umschreiben',
  'settings.memoryHooksRewriteDesc': 'PRE: erweitert eine kurze Anfrage zu einem vollständigen Aufgaben-Brief.',
  'settings.memoryHooksVerifyLabel': 'Ausgabe selbst prüfen',
  'settings.memoryHooksVerifyDesc': 'POST: prüft das Ergebnis anhand deiner Regeln und zeigt dann eine Bewertungskarte.',
  'settings.memoryHooksExtractionLabel': 'Aus Chats lernen',
  'settings.memoryHooksExtractionDesc': 'Erfasst nützliche Fakten und Präferenzen aus Chat-Runden.',
  'artifact.odCardTaskBriefChip': 'Speicher angewendet · Brief anzeigen',
  'artifact.odCardScorecardTitle': 'Selbstprüfung',
  'artifact.odCardScorecardStatusPass': 'Bestanden',
  'artifact.odCardScorecardStatusPartial': 'Teilweise',
  'artifact.odCardScorecardStatusFail': 'Nachbesserung nötig',
  'artifact.odCardRuleKicker': 'Vorgeschlagene Regel',
  'artifact.odCardRuleNameLabel': 'Name',
  'artifact.odCardRuleDescriptionLabel': 'Beschreibung',
  'artifact.odCardRuleAssertionLabel': 'Muss gelten',
  'artifact.odCardRuleCheckLabel': 'So wird geprüft',
  'artifact.odCardRuleRationaleLabel': 'Warum',
  'artifact.odCardRuleKeep': 'Behalten',
  'artifact.odCardRuleEdit': 'Bearbeiten',
  'artifact.odCardRuleDone': 'Fertig',
  'artifact.odCardRuleDiscard': 'Verwerfen',
  'artifact.odCardRuleSaving': 'Wird gespeichert…',
  'artifact.odCardRuleSaved': '„{name}“ als Regel gespeichert',
  'artifact.odCardRuleError': 'Die Regel konnte nicht gespeichert werden. Bitte erneut versuchen.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open the brand site in the browser so Open Design can continue extracting this design system.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'settings.memoryIndex': 'MEMORY.md (Index)',
  'settings.memoryIndexSave': 'Index speichern',
  'settings.memoryIndexReset': 'Zurücksetzen',
  'settings.memoryToastChanged': 'Speicher aktualisiert',
  'settings.memoryToastClickHint': 'Anzeigen',
  'settings.memoryAll': 'Alle',
  'settings.memoryExtractions': 'Extraktionsverlauf',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'Noch keine Extraktionen. Die nächste Chat-Runde füllt diese Liste.',
  'settings.memoryExtractionsRefresh': 'Aktualisieren',
  'settings.memoryExtractionsRefreshing': 'Wird aktualisiert…',
  'settings.memoryExtractionPhaseRunning': 'Wird ausgeführt…',
  'settings.memoryExtractionPhaseSuccess': 'Erfolgreich',
  'settings.memoryExtractionPhaseSkipped': 'Übersprungen',
  'settings.memoryExtractionPhaseFailed': 'Fehlgeschlagen',
  'settings.memoryExtractionSkipNoProvider': 'Kein API key für die LLM-Speicherextraktion konfiguriert.',
  'settings.memoryExtractionSkipDisabled': 'Speicher ist deaktiviert.',
  'settings.memoryExtractionSkipEmpty': 'Leere Benutzernachricht – nichts zu extrahieren.',
  'settings.memoryExtractionSkipNoMatch': 'In dieser Runde wurde kein regex-Muster gefunden.',
  'settings.memoryExtractionKindHeuristic': 'Regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'Medieneinstellungen',
  'settings.memoryExtractionProviderOverride': 'Speichereinstellungen',
  'settings.memoryExtractionProposed': 'vorgeschlagen',
  'settings.memoryExtractionWritten': 'geschrieben',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Löschen',
  'settings.memoryExtractionsClear': 'Leeren',
  'settings.memoryExtractionsClearTitle': 'Gesamten Extraktionsverlauf leeren',
  'settings.memoryExtractionsClearConfirm': 'Gesamten Extraktionsverlauf leeren? Dies kann nicht rückgängig gemacht werden.',
  'settings.memoryNoProviderBannerTitle': 'Die LLM-Speicherextraktion läuft nicht',
  'settings.memoryNoProviderBannerBody': 'Kein API key für den Speicher-Extraktor gefunden. Füge unter „Medienanbieter“ einen OpenAI key hinzu oder setze ANTHROPIC_API_KEY / OPENAI_API_KEY in der Umgebung, um die LLM-gesteuerte Extraktion zu aktivieren. Die heuristische regex-Extraktion ist weiterhin aktiv.',
  'settings.libraryInstall': 'Installieren',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Lokaler Pfad',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Installieren',
  'settings.libraryUninstall': 'Deinstallieren',
  'settings.libraryBuiltIn': 'Integriert',
  'settings.libraryInstalled': 'Installiert',
  'notify.successTitle': 'Aufgabe abgeschlossen',
  'notify.failureTitle': 'Aufgabe fehlgeschlagen',
  'notify.successBody': 'Eine Runde ist abgeschlossen.',
  'notify.failureBody': 'Die Aufgabe wurde mit einem Fehler beendet.',
  'updater.available': 'Update verfügbar',
  'updater.availableBody': 'Open Design {version} ist verfügbar. Es wird heruntergeladen, bevor der Installer geöffnet werden kann.',
  'updater.checking': 'Suche nach Updates',
  'updater.download': 'Update herunterladen',
  'updater.downloading': 'Update wird heruntergeladen',
  'updater.downloadingPercent': 'Update wird heruntergeladen {percent}%',
  'updater.done': 'Fertig',
  'updater.failed': 'Update fehlgeschlagen',
  'updater.installerOpenBody': 'Der Installer ist geöffnet. Open Design wird beendet, damit Sie das Update abschließen können.',
  'updater.installerOpened': 'Installer geöffnet',
  'updater.later': 'Später',
  'updater.openFailedFallback': 'Der Installer konnte nicht geöffnet werden.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Update installieren',
  'updater.opening': 'Installer wird geöffnet...',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'Open Design beenden',
  'updater.quitFailedBody': 'Der Installer ist geöffnet, aber Open Design konnte nicht beendet werden. Beenden Sie Open Design, bevor Sie die App ersetzen.',
  'updater.quitFailedTitle': 'Beenden fehlgeschlagen',
  'updater.quitting': 'Wird beendet...',
  'updater.ready': 'Update bereit',
  'updater.readyGeneric': 'Eine neue Version ist bereit. Open Design wird geschlossen und der Installer geöffnet.',
  'updater.readyVersion': 'Open Design {version} ist bereit. Open Design wird geschlossen und der Installer geöffnet.',
  'updater.upToDate': 'Sie verwenden bereits die neueste Version.',
  'newsletter.label': 'Newsletter (optional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'Automatisierung',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Tägliche Connector-Zusammenfassung',
  'settings.orbit.lede': 'Connector-Aktivität nach Zeitplan sammeln und das Ergebnis als aktualisierbares live artifact veröffentlichen.',
  'settings.orbit.statusOnTitle': 'Geplante tägliche Läufe sind aktiv',
  'settings.orbit.statusOffTitle': 'Geplante tägliche Läufe sind deaktiviert',
  'settings.orbit.statusActive': 'Aktiv',
  'settings.orbit.statusOff': 'Aus',
  'settings.orbit.runTitle': 'Einen Orbit-Lauf starten und die Live-Konversation öffnen',
  'settings.orbit.running': 'Läuft…',
  'settings.orbit.runOpen': 'Jetzt ausführen',
  'settings.orbit.dailySummaryTitle': 'Tägliche Zusammenfassung',
  'settings.orbit.dailySummarySub': 'Wird einmal pro Tag zur geplanten lokalen Zeit ausgeführt.',
  'settings.orbit.on': 'Ein',
  'settings.orbit.off': 'Aus',
  'settings.orbit.runTimeTitle': 'Ausführungszeit',
  'settings.orbit.runTimeSub': 'Standard 08:00. Speichern, um den Daemon-Zeitplan anzuwenden.',
  'settings.orbit.runTimeAria': 'Tägliche Orbit-Ausführungszeit',
  'settings.orbit.nextRun': 'Nächster Lauf',
  'settings.orbit.nextRunScheduledAfterSave': 'Nach dem Speichern geplant',
  'settings.orbit.schedule': 'Zeitplan',
  'settings.orbit.pausedManualOnly': 'Pausiert — nur manuelle Läufe',
  'settings.orbit.templateTitle': 'Prompt-Vorlage',
  'settings.orbit.templateMissing': 'Vorlage {id} ist nicht installiert.',
  'settings.orbit.templateMissingOption': '{id} (fehlt)',
  'settings.orbit.templateMissingInstall': 'Installiere eine Orbit-Skill, um den Prompt zu steuern.',
  'settings.orbit.templateMissingPickAnother': 'Wähle eine andere Vorlage aus dem Dropdown.',
  'settings.orbit.templateResetTitle': 'Auf {id} zurücksetzen',
  'settings.orbit.templateReset': 'Zurücksetzen',
  'settings.orbit.templateHelp': 'Steuere Orbit mit einer Skill — der Beispiel-Prompt der ausgewählten Vorlage wird in jeden Orbit-Lauf eingefügt, damit Zusammenfassungen dieser Vorlagenform folgen.',
  'settings.orbit.templateAria': 'Orbit-Prompt-Vorlage',
  'settings.orbit.templatesLoading': 'Vorlagen werden geladen…',
  'settings.orbit.templatesOptgroup': 'Orbit-Skill-Vorlagen',
  'settings.orbit.lastRun': 'Letzter Lauf',
  'settings.orbit.triggerManual': 'Manuell',
  'settings.orbit.triggerScheduled': 'Geplant',
  'settings.orbit.meterAria': '{succeeded} erfolgreich, {skipped} übersprungen, {failed} fehlgeschlagen von {checked} geprüft',
  'settings.orbit.countChecked': 'Geprüft',
  'settings.orbit.countSucceeded': 'Erfolgreich',
  'settings.orbit.countSkipped': 'Übersprungen',
  'settings.orbit.countFailed': 'Fehlgeschlagen',
  'settings.orbit.runError': 'Orbit konnte nicht ausgeführt werden. Stelle sicher, dass der lokale Daemon läuft und Connectors konfiguriert sind.',
  'settings.orbit.gateAriaLabel': 'Connectors werden für Orbit benötigt',
  'settings.orbit.gateEyebrow': 'Einrichtung erforderlich',
  'settings.orbit.gateTitle': 'Verbinde ein Tool, um Orbit zu nutzen',
  'settings.orbit.gateBody': 'Orbit fasst die Aktivität deiner Connectors zusammen. Du hast noch nichts verbunden — füge mindestens eine Integration hinzu, damit Orbit etwas zu berichten hat.',
  'settings.orbit.gateBodyNoKey': 'Orbit fasst die Aktivität deiner Connectors zusammen, und Connectors laufen über Composio. Trage einen Composio-API-Key unter Connectors ein, um den Katalog freizuschalten und deine erste Integration zu wählen.',
  'settings.orbit.gateAction': 'Connectors öffnen',
  'settings.orbit.gateActionNoKey': 'Composio konfigurieren',
  'settings.orbit.gateLoading': 'Connectors werden geprüft…',
  'settings.orbit.controlsLockedBadge': 'Gesperrt',
  'settings.orbit.controlsLockedHint': 'Verbinde ein Tool, um Zeitplan und Vorlage von Orbit freizuschalten.',
  'settings.orbit.artifactKickerLive': 'Live-Artefakt',
  'settings.orbit.artifactKickerLegacy': 'Legacy-Zusammenfassung',
  'settings.orbit.artifactTitle': 'Tägliche Orbit-Aktivitätszusammenfassung',
  'settings.orbit.artifactMetaLive': 'Aktualisierbares HTML-Artefakt, erzeugt aus Connector-Aktivität.',
  'settings.orbit.artifactMetaLegacy': 'Erzeugt, bevor live artifact-Unterstützung aktiviert wurde — führe Orbit erneut aus, um eines zu veröffentlichen.',
  'settings.orbit.copyMarkdownTitle': 'Markdown-Zusammenfassung in die Zwischenablage kopieren',
  'settings.orbit.copied': 'Kopiert',
  'settings.orbit.copy': 'Kopieren',
  'settings.orbit.openArtifact': 'Artefakt öffnen',
  'settings.orbit.sourceMarkdown': 'Quell-Markdown',
  'settings.memoryModelInlineHintByokNeutral': 'Memory verwendet ein separates Modell vom Chat. Standardmäßig wird Ihr Chat-Modell verwendet.',
  'diagnostics.exportTitle': 'Diagnose exportieren',
  'diagnostics.exportButton': 'Diagnose exportieren',
  'diagnostics.exportHint': 'Bündelt die aktuellen App-Logs und Geräteinformationen in ein Zip-Archiv, das du mit dem Team teilen kannst.',
  'diagnostics.exporting': 'Exportiere…',
  'diagnostics.exportSuccess': 'Diagnose gespeichert: {path}',
  'diagnostics.exportFailed': 'Diagnose-Export fehlgeschlagen: {message}',
  'automations.eyebrow': 'Geplante Agent-Sitzungen',
  'automations.title': 'Automatisierungen',
  'automations.lede': 'Planen Sie wiederkehrende Gespräche für Projektarbeit, Orbit-Digests und Live-Artefakte.',
  'automations.summaryAria': 'Automatisierungsübersicht',
  'automations.metricActive': 'Aktiv',
  'automations.metricPaused': 'Pausiert',
  'automations.metricTemplates': 'Vorlagen',
  'automations.newAutomation': 'Neue Automatisierung',
  'automations.yourAutomations': 'Ihre Automatisierungen',
  'automations.loading': 'Wird geladen',
  'automations.emptyTitle': 'Noch keine Automatisierungen',
  'automations.emptyBody': 'Erstellen Sie eine aus einer Vorlage oder beginnen Sie mit einem leeren Zeitplan.',
  'automations.targetNewEachRun': 'Neues Projekt bei jeder Ausführung',
  'automations.lastRun': 'Letzte Ausführung {time}',
  'automations.openResult': 'Ergebnis öffnen',
  'automations.run': 'Ausführen',
  'automations.runNowTitle': 'Jetzt ausführen und Gespräch öffnen',
  'automations.history': 'Verlauf',
  'automations.hideHistory': 'Verlauf ausblenden',
  'automations.edit': 'Bearbeiten',
  'automations.pause': 'Pausieren',
  'automations.resume': 'Fortsetzen',
  'automations.deleteAria': 'Automatisierung löschen',
  'automations.deleteTitle': 'Diese Automatisierung löschen',
  'automations.deleteConfirm': 'Diese Automatisierung löschen? Vergangene Ausführungen und ihre Projekte bleiben erhalten.',
  'automations.proposalsTitle': 'Weiterentwicklungsvorschläge',
  'automations.proposalsSub': 'Prüfen Sie die Automatisierungsausgabe, bevor sie Memory, Skills oder Designsysteme ändert.',
  'automations.proposalsPending': '{n} ausstehend',
  'automations.apply': 'Anwenden',
  'automations.reject': 'Ablehnen',
  'automations.proposalsDismissReason': 'In Automatisierungen verworfen',
  'automations.templatesTitle': 'Vorlagen',
  'automations.templatesSub': 'Orbit und Live-Artefakte sind Vorlagen innerhalb desselben Automatisierungsablaufs.',
  'automations.templatesCount': '{filtered} von {total}',
  'automations.templateFiltersAria': 'Vorlagenfilter',
  'automations.templatesEmptyTitle': 'Noch keine Vorlagen in dieser Kategorie.',
  'automations.templatesEmptyBody': 'Versuchen Sie einen anderen Filter oder beginnen Sie mit einer leeren Automatisierung.',
  'automations.useTemplate': 'Vorlage verwenden',
  'automations.runHistoryLoading': 'Ausführungsverlauf wird geladen ...',
  'automations.runHistoryEmpty': 'Noch keine Ausführungen.',
  'automations.runHistoryTitle': 'Ausführungsverlauf',
  'automations.runHistoryLatest': 'Letzte 10',
  'automations.crystallize': 'Kristallisieren',
  'automations.crystallizing': 'Wird kristallisiert',
  'automations.crystallizeTitle': 'Skill- und Memory-Vorschläge aus dieser Ausführung entwerfen',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Gespräch öffnen',
  'automations.runHistoryAria': 'Ausführungsverlauf der Automatisierung',
  'automations.proposalsAria': 'Weiterentwicklungsvorschläge der Automatisierung',
  'automations.templatesAria': 'Automatisierungsvorlagen',
  'automations.runInProgress': 'In Bearbeitung',
  'automations.scheduleStatusPaused': 'Pausiert',
  'automations.nextRunManualOnly': 'Nur manuell',
  'automations.nextRunScheduled': 'Geplant',
  'automations.nextRunAt': 'Nächste {time}',
  'automations.statusSucceeded': 'Erfolgreich',
  'automations.statusFailed': 'Fehlgeschlagen',
  'automations.statusRunning': 'Läuft',
  'automations.statusQueued': 'In Warteschlange',
  'automations.statusCanceled': 'Abgebrochen',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Live-Artefakt',
  'automations.kindAutomation': 'Automatisierung',
  'automations.proposalTargetMemory': 'Memory',
  'automations.proposalTargetDesignSystem': 'Designsystem',
  'automations.proposalTargetSkill': 'Skill',
  'automations.proposalTargetTemplate': 'Automatisierungsvorlage',
  'automations.proposalActionCreate': 'Erstellen',
  'automations.proposalActionUpdate': 'Aktualisieren',
  'automations.proposalActionMerge': 'Zusammenführen',
  'automations.proposalActionMove': 'Verschieben',
  'automations.proposalActionDelete': 'Löschen',
  'automations.proposalActionPromote': 'Hochstufen',
  'automations.filterAll': 'Alle',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Live-Artefakte',
  'automations.filterMemory': 'Memory',
  'automations.filterDesignSystems': 'Designsysteme',
  'automations.filterSkills': 'Skills',
  'automations.filterConnectors': 'Konnektoren',
  'automations.filterCompression': 'Komprimierung',
  'automations.filterRelease': 'Release',
  'automations.filterQuality': 'Qualität',
  'automations.tpl.memoryRefresh.title': 'Projekt-Memory aus jüngsten Arbeiten aktualisieren.',
  'automations.tpl.memoryRefresh.desc': 'Verwandelt wiederholte Entscheidungen, Präferenzen und Feedback in wiederverwendbare Memory-Aktualisierungen.',
  'automations.tpl.designSystemRefresh.title': 'Designsysteme aus ausgelieferten Artefakten aktualisieren.',
  'automations.tpl.designSystemRefresh.desc': 'Findet wiederverwendbare Token, Komponenten und Regeln in jüngsten Designarbeiten.',
  'automations.tpl.liveArtifactRegistry.title': 'Live-Artefakte prüfen und veraltete Versionen aktualisieren.',
  'automations.tpl.liveArtifactRegistry.desc': 'Hält persistente Dashboards, Berichte und Vorschauen aktuell, anstatt sie zu duplizieren.',
  'automations.tpl.orbitDashboard.title': 'Ein Dashboard für Konnektoraktivität erstellen.',
  'automations.tpl.orbitDashboard.desc': 'Fasst ausgewählte Konnektoren in einem Orbit-artigen Live-Dashboard zusammen.',
  'automations.tpl.releaseNotes.title': 'Release Notes aus ausgelieferten Designarbeiten entwerfen.',
  'automations.tpl.releaseNotes.desc': 'Verbindet gemergte PRs, Artefakte und produktbezogene Änderungen zu Release Notes.',
  'automations.tpl.qualityRegressionWatch.title': 'Auf Design- und Implementierungsregressionen achten.',
  'automations.tpl.qualityRegressionWatch.desc': 'Vergleicht jüngste Änderungen mit Benchmarks, Traces und akzeptierten Referenzen.',
  'automations.tpl.orbitDaily.title': 'Täglicher Konnektor-Digest.',
  'automations.tpl.orbitDaily.desc': 'Aktualisiert einen Digest der Konnektoraktivität nach Zeitplan.',
  'automations.tpl.liveStatusBoard.title': 'Ein Live-Status-Artefakt aktuell halten.',
  'automations.tpl.liveStatusBoard.desc': 'Aktualisiert ein persistentes Artefakt, anstatt bei jeder Ausführung einen neuen Bericht zu erstellen.',
  'dsManager.areaAria': 'Bereich Designsysteme',
  'dsManager.tabDesignSystem': 'Designsystem',
  'dsManager.tabTemplate': 'Vorlage',
  'dsManager.sourceAria': 'Quelle des Designsystems',
  'dsManager.templateSourceAria': 'Vorlagenquelle',
  'dsManager.yourSystems': 'Ihre Systeme',
  'dsManager.officialPresets': 'Offizielle Voreinstellungen',
  'dsManager.enterprise': 'Enterprise',
  'dsManager.yourTemplates': 'Ihre Vorlagen',
  'dsManager.yourSystemsAria': 'Ihre Designsysteme',
  'dsManager.eyebrowDesignSystems': 'Designsysteme',
  'dsManager.yourSystemsHeading': 'Ihre Systeme',
  'dsManager.filterAria': 'Designsysteme filtern',
  'dsManager.filterAll': 'Alle',
  'dsManager.filterPublished': 'Veröffentlicht',
  'dsManager.filterDraft': 'Entwurf',
  'dsManager.createTitle': 'Neues Designsystem erstellen',
  'dsManager.createBody': 'Bringen Sie Open Design Ihre Marke, Ihr Produkt, Ihren Code, Ihre Assets und Ihre Designreferenzen bei.',
  'dsManager.createAction': 'Erstellen',
  'dsManager.emptyMine': 'Noch keine Designsysteme. Erstellen Sie eines aus echtem Produktkontext, prüfen Sie den Entwurf und veröffentlichen Sie es dann für künftige Projekte.',
  'dsManager.badgeDefault': 'Standard',
  'dsManager.rowMetaUpdated': 'Sie · aktualisiert {date}',
  'dsManager.edit': 'Bearbeiten',
  'dsManager.openSystem': 'Öffnen',
  'dsManager.editWithAgent': 'Mit Agent bearbeiten',
  'dsManager.downloadTitle': 'Designsystem herunterladen (.zip + SKILLS.md)',
  'dsManager.downloadAria': '{title} als .zip herunterladen',
  'dsManager.downloadFailed': 'Das Designsystem konnte nicht heruntergeladen werden. Bitte erneut versuchen.',
  'dsManager.deleteConfirm': '„{title}“ löschen? Dadurch wird der Entwurf des Designsystems von diesem Gerät entfernt.',
  'dsManager.makeDefault': 'Als Standard festlegen',
  'dsManager.statusPublished': 'Veröffentlicht',
  'dsManager.statusDraft': 'Entwurf',
  'dsManager.openSystemAria': '{title} öffnen',
  'dsManager.deleteSystemAria': '{title} löschen',
  'dsManager.presetsAria': 'Offizielle Voreinstellungen für Designsysteme',
  'dsManager.eyebrowLibrary': 'Bibliothek',
  'dsManager.eyebrowTemplates': 'Vorlagen',
  'dsManager.yourTemplatesAria': 'Ihre Vorlagen',
  'dsManager.emptyTemplates': 'Noch keine Vorlagen. Erstellen Sie eine aus einem beliebigen generierten Projekt über Teilen, sobald die Vorlagenveröffentlichung aktiviert ist.',
  'dsManager.templateDescFallback': 'Aus einem Projekt erstellt',
  'dsManager.comingSoonBadge': 'Demnächst',
  'dsManager.enterpriseDsTitle': 'Enterprise-Designsysteme',
  'dsManager.enterpriseDsBody': 'Gemeinsame Team-Designsysteme und verwaltete Markenbibliotheken folgen in Kürze.',
  'dsManager.enterpriseTplTitle': 'Enterprise-Vorlagen',
  'dsManager.enterpriseTplBody': 'Vom Team freigegebene Vorlagen und organisationsweite Veröffentlichung folgen in Kürze.',
  'settings.instructionsTitle': 'Anweisungen / Regeln',
  'settings.instructionsSubtitle': 'Festes Verhalten, dem der Assistent folgen soll',
  'settings.instructionsNavSub': 'Festes Assistentenverhalten',
  'settings.customInstructionsDesc': 'Feste Anweisungen, denen Open Design in jedem Chat folgt. Dies sind keine gespeicherten Erinnerungen; verwenden Sie Memory für Fakten, Präferenzen und Projektkontext.',
  'mcpClient.forwardedToLabel': 'Weitergeleitet an:',
  'mcpClient.notForwardedToLabel': 'Nicht weitergeleitet an:',
  'mcpClient.forwardedAcpNote': 'Als stdio gekennzeichnete ACP-Adapter erhalten aus dieser Liste nur stdio-MCP-Server; HTTP- und SSE-Einträge werden beim Start verworfen.',
  'mcpClient.notForwardedNote': 'Konfigurieren Sie MCP-Server für diese Agents in der eigenen Konfigurationsdatei des Agents (z. B. ~/.codex/config.toml, ~/.gemini/settings.json); die unten aufgeführten Server werden dort stillschweigend nicht verwendet.',

  // Brands library + extraction
  'brand.libraryTitle': 'Brand Kit',
  'brand.librarySubtitle': 'Teach Open Design your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'Füge eine Website ein oder wähle unten eine Marke – wir extrahieren ihre Farben, Schriften und das Logo.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'Brand Kit',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'Einmal erstellen, überall bauen',
  'onboarding.buildBody': 'Open Design macht aus deiner Marke ein wiederverwendbares Designsystem – und hält alles, was du baust, markenkonform und einheitlich.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Designsystem erstellen',
  'onboarding.buildHome': 'Zur Startseite',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. Open Design first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.heading': 'Starte mit einer Marke, die du liebst',
  'brandPicker.subtext': 'Klicke auf eine Marke, um ihr Kit direkt von ihrer Website zu extrahieren.',
  'brandPicker.quickPicksLabel': 'Beliebte Marken – zum Extrahieren klicken',
  'brandPicker.searchPlaceholder': 'Marken suchen…',
  'brandPicker.allCategories': 'Alle',
  'brandPicker.extractAction': 'Extrahieren',
  'brandPicker.showMore': 'Mehr anzeigen',
  'brandPicker.opening': 'Extraktion startet – {brand} wird geöffnet…',
  'ds.kitVisualize': 'Visualisieren',
  'ds.kitEdit': 'Bearbeiten',
  'ds.kitSource': 'Quelle',
  'ds.saveDesignMd': 'DESIGN.md speichern',
  'ds.saving': 'Speichern…',
  'ds.copyDesignMd': 'DESIGN.md kopieren',
  'ds.editDesignMd': 'DESIGN.md bearbeiten',
  'ds.openDesignMd': 'DESIGN.md öffnen',
  'ds.copyDesignMdModule': 'Abschnitt {module} kopieren',
  'ds.editDesignMdModule': 'Abschnitt {module} bearbeiten',
  'ds.openDesignMdModule': 'Abschnitt {module} öffnen',
  'ds.uploadMd': 'MD hochladen',
  'ds.uploadFont': 'Schriftdatei hinzufügen',
  'ds.pasteImage': 'Bild einfügen',
  'ds.refresh': 'Aktualisieren',
  'ds.download': 'Herunterladen',
  'ds.importFolder': 'Ordner importieren',
  'ds.reset': 'Zurücksetzen',
  'ds.editingDesignMdHint': 'Das Bearbeiten dieses Markdown aktualisiert die gerenderten Kit-Module.',
  'ds.editingModuleHint': 'Es wird nur das Modul {module} bearbeitet.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Modul speichern',
  'ds.uploadLogo': 'Logo hochladen',
  'ds.uploadImage': 'Bild hochladen',
  'ds.uploading': 'Wird hochgeladen…',
  'ds.moduleEmptyLogo': 'Noch kein Logo',
  'ds.moduleEmptyFonts': 'Keine Schriften erfasst.',
  'ds.actionDone': 'Erledigt',
  'ds.actionFailed': 'Etwas ist fehlgeschlagen. Bitte erneut versuchen.',
  'ds.uploadDone': 'Hochgeladen',
  'ds.uploadFailed': 'Upload fehlgeschlagen. Bitte erneut versuchen.',
  'ds.deleteLogo': 'Logo löschen',
  'ds.deleteImage': '{caption} löschen',
  'ds.deleteProjectConfirm': '„{title}“ löschen? Dadurch werden dieses Designsystem und sein Projekt dauerhaft von diesem Gerät entfernt.',
  'ds.deleteProjectAction': '{title} löschen',
  'ds.editColor': '{name} bearbeiten',
  'ds.colorLabel': 'Farbe',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Hex-Wert',
  'ds.saveColor': 'Farbe speichern',
  'ds.invalidHexColor': 'Gib eine gültige Hex-Farbe ein, z. B. #FF6A3D.',
  'ds.colorSaveFailed': 'Diese Farbe konnte nicht gespeichert werden.',
  'ds.colorResetFailed': 'Diese Farbe konnte nicht zurückgesetzt werden.',
  'ds.designMdSectionLabel': 'DESIGN.md-Abschnitt {module}',
  'ds.kitErrorTitle': 'Diese Ansicht ist auf ein Problem gestoßen.',
  'ds.kitErrorRetry': 'Neu laden',
  'ds.shortcutsLabel': 'Tastaturkürzel',
  'ds.shortcutsHint': 'Kürzel: E bearbeiten · C kopieren · U hochladen · R aktualisieren · ⌫ Logo löschen',
  'ds.moduleEmptyImages': 'Noch keine Bilder',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'Open Design is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so Open Design can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
};
